/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/': {
    get: {
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/cep_brasil': {
    get: {
      parameters: {
        query: {
          idendereco?: parameters['rowFilter.cep_brasil.idendereco'];
          gr_usuario?: parameters['rowFilter.cep_brasil.gr_usuario'];
          idlocalidade?: parameters['rowFilter.cep_brasil.idlocalidade'];
          tipo_logr?: parameters['rowFilter.cep_brasil.tipo_logr'];
          logr_nome?: parameters['rowFilter.cep_brasil.logr_nome'];
          logr_copl?: parameters['rowFilter.cep_brasil.logr_copl'];
          numero?: parameters['rowFilter.cep_brasil.numero'];
          bairro?: parameters['rowFilter.cep_brasil.bairro'];
          nome_localidade?: parameters['rowFilter.cep_brasil.nome_localidade'];
          sigla_uf?: parameters['rowFilter.cep_brasil.sigla_uf'];
          cep?: parameters['rowFilter.cep_brasil.cep'];
          latitude?: parameters['rowFilter.cep_brasil.latitude'];
          longitude?: parameters['rowFilter.cep_brasil.longitude'];
          geom?: parameters['rowFilter.cep_brasil.geom'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['cep_brasil'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** cep_brasil */
          cep_brasil?: definitions['cep_brasil'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          idendereco?: parameters['rowFilter.cep_brasil.idendereco'];
          gr_usuario?: parameters['rowFilter.cep_brasil.gr_usuario'];
          idlocalidade?: parameters['rowFilter.cep_brasil.idlocalidade'];
          tipo_logr?: parameters['rowFilter.cep_brasil.tipo_logr'];
          logr_nome?: parameters['rowFilter.cep_brasil.logr_nome'];
          logr_copl?: parameters['rowFilter.cep_brasil.logr_copl'];
          numero?: parameters['rowFilter.cep_brasil.numero'];
          bairro?: parameters['rowFilter.cep_brasil.bairro'];
          nome_localidade?: parameters['rowFilter.cep_brasil.nome_localidade'];
          sigla_uf?: parameters['rowFilter.cep_brasil.sigla_uf'];
          cep?: parameters['rowFilter.cep_brasil.cep'];
          latitude?: parameters['rowFilter.cep_brasil.latitude'];
          longitude?: parameters['rowFilter.cep_brasil.longitude'];
          geom?: parameters['rowFilter.cep_brasil.geom'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          idendereco?: parameters['rowFilter.cep_brasil.idendereco'];
          gr_usuario?: parameters['rowFilter.cep_brasil.gr_usuario'];
          idlocalidade?: parameters['rowFilter.cep_brasil.idlocalidade'];
          tipo_logr?: parameters['rowFilter.cep_brasil.tipo_logr'];
          logr_nome?: parameters['rowFilter.cep_brasil.logr_nome'];
          logr_copl?: parameters['rowFilter.cep_brasil.logr_copl'];
          numero?: parameters['rowFilter.cep_brasil.numero'];
          bairro?: parameters['rowFilter.cep_brasil.bairro'];
          nome_localidade?: parameters['rowFilter.cep_brasil.nome_localidade'];
          sigla_uf?: parameters['rowFilter.cep_brasil.sigla_uf'];
          cep?: parameters['rowFilter.cep_brasil.cep'];
          latitude?: parameters['rowFilter.cep_brasil.latitude'];
          longitude?: parameters['rowFilter.cep_brasil.longitude'];
          geom?: parameters['rowFilter.cep_brasil.geom'];
        };
        body: {
          /** cep_brasil */
          cep_brasil?: definitions['cep_brasil'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/importacoes_tiff': {
    get: {
      parameters: {
        query: {
          id_importacoes_tiff?: parameters['rowFilter.importacoes_tiff.id_importacoes_tiff'];
          nome_arquivo?: parameters['rowFilter.importacoes_tiff.nome_arquivo'];
          id_projetos?: parameters['rowFilter.importacoes_tiff.id_projetos'];
          nome_layer?: parameters['rowFilter.importacoes_tiff.nome_layer'];
          file_size?: parameters['rowFilter.importacoes_tiff.file_size'];
          tipo_imagem?: parameters['rowFilter.importacoes_tiff.tipo_imagem'];
          min_zoom?: parameters['rowFilter.importacoes_tiff.min_zoom'];
          max_zoom?: parameters['rowFilter.importacoes_tiff.max_zoom'];
          extensao?: parameters['rowFilter.importacoes_tiff.extensao'];
          sinal?: parameters['rowFilter.importacoes_tiff.sinal'];
          representacao?: parameters['rowFilter.importacoes_tiff.representacao'];
          url?: parameters['rowFilter.importacoes_tiff.url'];
          extent?: parameters['rowFilter.importacoes_tiff.extent'];
          preview?: parameters['rowFilter.importacoes_tiff.preview'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['importacoes_tiff'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** importacoes_tiff */
          importacoes_tiff?: definitions['importacoes_tiff'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_importacoes_tiff?: parameters['rowFilter.importacoes_tiff.id_importacoes_tiff'];
          nome_arquivo?: parameters['rowFilter.importacoes_tiff.nome_arquivo'];
          id_projetos?: parameters['rowFilter.importacoes_tiff.id_projetos'];
          nome_layer?: parameters['rowFilter.importacoes_tiff.nome_layer'];
          file_size?: parameters['rowFilter.importacoes_tiff.file_size'];
          tipo_imagem?: parameters['rowFilter.importacoes_tiff.tipo_imagem'];
          min_zoom?: parameters['rowFilter.importacoes_tiff.min_zoom'];
          max_zoom?: parameters['rowFilter.importacoes_tiff.max_zoom'];
          extensao?: parameters['rowFilter.importacoes_tiff.extensao'];
          sinal?: parameters['rowFilter.importacoes_tiff.sinal'];
          representacao?: parameters['rowFilter.importacoes_tiff.representacao'];
          url?: parameters['rowFilter.importacoes_tiff.url'];
          extent?: parameters['rowFilter.importacoes_tiff.extent'];
          preview?: parameters['rowFilter.importacoes_tiff.preview'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_importacoes_tiff?: parameters['rowFilter.importacoes_tiff.id_importacoes_tiff'];
          nome_arquivo?: parameters['rowFilter.importacoes_tiff.nome_arquivo'];
          id_projetos?: parameters['rowFilter.importacoes_tiff.id_projetos'];
          nome_layer?: parameters['rowFilter.importacoes_tiff.nome_layer'];
          file_size?: parameters['rowFilter.importacoes_tiff.file_size'];
          tipo_imagem?: parameters['rowFilter.importacoes_tiff.tipo_imagem'];
          min_zoom?: parameters['rowFilter.importacoes_tiff.min_zoom'];
          max_zoom?: parameters['rowFilter.importacoes_tiff.max_zoom'];
          extensao?: parameters['rowFilter.importacoes_tiff.extensao'];
          sinal?: parameters['rowFilter.importacoes_tiff.sinal'];
          representacao?: parameters['rowFilter.importacoes_tiff.representacao'];
          url?: parameters['rowFilter.importacoes_tiff.url'];
          extent?: parameters['rowFilter.importacoes_tiff.extent'];
          preview?: parameters['rowFilter.importacoes_tiff.preview'];
        };
        body: {
          /** importacoes_tiff */
          importacoes_tiff?: definitions['importacoes_tiff'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/licencas': {
    get: {
      parameters: {
        query: {
          id_licencas?: parameters['rowFilter.licencas.id_licencas'];
          id_tenants?: parameters['rowFilter.licencas.id_tenants'];
          id_planos?: parameters['rowFilter.licencas.id_planos'];
          valor?: parameters['rowFilter.licencas.valor'];
          qtd_usuarios_plano?: parameters['rowFilter.licencas.qtd_usuarios_plano'];
          data_cadastro?: parameters['rowFilter.licencas.data_cadastro'];
          data_inicio_vigencia?: parameters['rowFilter.licencas.data_inicio_vigencia'];
          data_final_vigencia?: parameters['rowFilter.licencas.data_final_vigencia'];
          status?: parameters['rowFilter.licencas.status'];
          armazenamento_plano?: parameters['rowFilter.licencas.armazenamento_plano'];
          armazenamento_adicional?: parameters['rowFilter.licencas.armazenamento_adicional'];
          armazenamento_total?: parameters['rowFilter.licencas.armazenamento_total'];
          valor_armazenamento_ad?: parameters['rowFilter.licencas.valor_armazenamento_ad'];
          qtd_usuarios_adicionais?: parameters['rowFilter.licencas.qtd_usuarios_adicionais'];
          qtd_usuarios_total?: parameters['rowFilter.licencas.qtd_usuarios_total'];
          armazenamento_adicional_raster?: parameters['rowFilter.licencas.armazenamento_adicional_raster'];
          armazenamento_adicional_vetor?: parameters['rowFilter.licencas.armazenamento_adicional_vetor'];
          uso_vetor?: parameters['rowFilter.licencas.uso_vetor'];
          uso_raster?: parameters['rowFilter.licencas.uso_raster'];
          uso_vetor_big?: parameters['rowFilter.licencas.uso_vetor_big'];
          uso_raster_big?: parameters['rowFilter.licencas.uso_raster_big'];
          armazenamento_adicional_raster_big?: parameters['rowFilter.licencas.armazenamento_adicional_raster_big'];
          armazenamento_adicional_vetor_big?: parameters['rowFilter.licencas.armazenamento_adicional_vetor_big'];
          token_card?: parameters['rowFilter.licencas.token_card'];
          token_bing?: parameters['rowFilter.licencas.token_bing'];
          token_mapbox?: parameters['rowFilter.licencas.token_mapbox'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['licencas'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** licencas */
          licencas?: definitions['licencas'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_licencas?: parameters['rowFilter.licencas.id_licencas'];
          id_tenants?: parameters['rowFilter.licencas.id_tenants'];
          id_planos?: parameters['rowFilter.licencas.id_planos'];
          valor?: parameters['rowFilter.licencas.valor'];
          qtd_usuarios_plano?: parameters['rowFilter.licencas.qtd_usuarios_plano'];
          data_cadastro?: parameters['rowFilter.licencas.data_cadastro'];
          data_inicio_vigencia?: parameters['rowFilter.licencas.data_inicio_vigencia'];
          data_final_vigencia?: parameters['rowFilter.licencas.data_final_vigencia'];
          status?: parameters['rowFilter.licencas.status'];
          armazenamento_plano?: parameters['rowFilter.licencas.armazenamento_plano'];
          armazenamento_adicional?: parameters['rowFilter.licencas.armazenamento_adicional'];
          armazenamento_total?: parameters['rowFilter.licencas.armazenamento_total'];
          valor_armazenamento_ad?: parameters['rowFilter.licencas.valor_armazenamento_ad'];
          qtd_usuarios_adicionais?: parameters['rowFilter.licencas.qtd_usuarios_adicionais'];
          qtd_usuarios_total?: parameters['rowFilter.licencas.qtd_usuarios_total'];
          armazenamento_adicional_raster?: parameters['rowFilter.licencas.armazenamento_adicional_raster'];
          armazenamento_adicional_vetor?: parameters['rowFilter.licencas.armazenamento_adicional_vetor'];
          uso_vetor?: parameters['rowFilter.licencas.uso_vetor'];
          uso_raster?: parameters['rowFilter.licencas.uso_raster'];
          uso_vetor_big?: parameters['rowFilter.licencas.uso_vetor_big'];
          uso_raster_big?: parameters['rowFilter.licencas.uso_raster_big'];
          armazenamento_adicional_raster_big?: parameters['rowFilter.licencas.armazenamento_adicional_raster_big'];
          armazenamento_adicional_vetor_big?: parameters['rowFilter.licencas.armazenamento_adicional_vetor_big'];
          token_card?: parameters['rowFilter.licencas.token_card'];
          token_bing?: parameters['rowFilter.licencas.token_bing'];
          token_mapbox?: parameters['rowFilter.licencas.token_mapbox'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_licencas?: parameters['rowFilter.licencas.id_licencas'];
          id_tenants?: parameters['rowFilter.licencas.id_tenants'];
          id_planos?: parameters['rowFilter.licencas.id_planos'];
          valor?: parameters['rowFilter.licencas.valor'];
          qtd_usuarios_plano?: parameters['rowFilter.licencas.qtd_usuarios_plano'];
          data_cadastro?: parameters['rowFilter.licencas.data_cadastro'];
          data_inicio_vigencia?: parameters['rowFilter.licencas.data_inicio_vigencia'];
          data_final_vigencia?: parameters['rowFilter.licencas.data_final_vigencia'];
          status?: parameters['rowFilter.licencas.status'];
          armazenamento_plano?: parameters['rowFilter.licencas.armazenamento_plano'];
          armazenamento_adicional?: parameters['rowFilter.licencas.armazenamento_adicional'];
          armazenamento_total?: parameters['rowFilter.licencas.armazenamento_total'];
          valor_armazenamento_ad?: parameters['rowFilter.licencas.valor_armazenamento_ad'];
          qtd_usuarios_adicionais?: parameters['rowFilter.licencas.qtd_usuarios_adicionais'];
          qtd_usuarios_total?: parameters['rowFilter.licencas.qtd_usuarios_total'];
          armazenamento_adicional_raster?: parameters['rowFilter.licencas.armazenamento_adicional_raster'];
          armazenamento_adicional_vetor?: parameters['rowFilter.licencas.armazenamento_adicional_vetor'];
          uso_vetor?: parameters['rowFilter.licencas.uso_vetor'];
          uso_raster?: parameters['rowFilter.licencas.uso_raster'];
          uso_vetor_big?: parameters['rowFilter.licencas.uso_vetor_big'];
          uso_raster_big?: parameters['rowFilter.licencas.uso_raster_big'];
          armazenamento_adicional_raster_big?: parameters['rowFilter.licencas.armazenamento_adicional_raster_big'];
          armazenamento_adicional_vetor_big?: parameters['rowFilter.licencas.armazenamento_adicional_vetor_big'];
          token_card?: parameters['rowFilter.licencas.token_card'];
          token_bing?: parameters['rowFilter.licencas.token_bing'];
          token_mapbox?: parameters['rowFilter.licencas.token_mapbox'];
        };
        body: {
          /** licencas */
          licencas?: definitions['licencas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/segmentos': {
    get: {
      parameters: {
        query: {
          id_segmentos?: parameters['rowFilter.segmentos.id_segmentos'];
          descricao?: parameters['rowFilter.segmentos.descricao'];
          tipo?: parameters['rowFilter.segmentos.tipo'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['segmentos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** segmentos */
          segmentos?: definitions['segmentos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_segmentos?: parameters['rowFilter.segmentos.id_segmentos'];
          descricao?: parameters['rowFilter.segmentos.descricao'];
          tipo?: parameters['rowFilter.segmentos.tipo'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_segmentos?: parameters['rowFilter.segmentos.id_segmentos'];
          descricao?: parameters['rowFilter.segmentos.descricao'];
          tipo?: parameters['rowFilter.segmentos.tipo'];
        };
        body: {
          /** segmentos */
          segmentos?: definitions['segmentos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/sul_roads_refactor': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads_refactor.gid'];
          osm_id?: parameters['rowFilter.sul_roads_refactor.osm_id'];
          code?: parameters['rowFilter.sul_roads_refactor.code'];
          fclass?: parameters['rowFilter.sul_roads_refactor.fclass'];
          name?: parameters['rowFilter.sul_roads_refactor.name'];
          ref?: parameters['rowFilter.sul_roads_refactor.ref'];
          oneway?: parameters['rowFilter.sul_roads_refactor.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads_refactor.maxspeed'];
          layer?: parameters['rowFilter.sul_roads_refactor.layer'];
          bridge?: parameters['rowFilter.sul_roads_refactor.bridge'];
          tunnel?: parameters['rowFilter.sul_roads_refactor.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads_refactor.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads_refactor.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads_refactor.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads_refactor.geom'];
          fator?: parameters['rowFilter.sul_roads_refactor.fator'];
          geomhelper?: parameters['rowFilter.sul_roads_refactor.geomhelper'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['sul_roads_refactor'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** sul_roads_refactor */
          sul_roads_refactor?: definitions['sul_roads_refactor'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads_refactor.gid'];
          osm_id?: parameters['rowFilter.sul_roads_refactor.osm_id'];
          code?: parameters['rowFilter.sul_roads_refactor.code'];
          fclass?: parameters['rowFilter.sul_roads_refactor.fclass'];
          name?: parameters['rowFilter.sul_roads_refactor.name'];
          ref?: parameters['rowFilter.sul_roads_refactor.ref'];
          oneway?: parameters['rowFilter.sul_roads_refactor.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads_refactor.maxspeed'];
          layer?: parameters['rowFilter.sul_roads_refactor.layer'];
          bridge?: parameters['rowFilter.sul_roads_refactor.bridge'];
          tunnel?: parameters['rowFilter.sul_roads_refactor.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads_refactor.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads_refactor.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads_refactor.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads_refactor.geom'];
          fator?: parameters['rowFilter.sul_roads_refactor.fator'];
          geomhelper?: parameters['rowFilter.sul_roads_refactor.geomhelper'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads_refactor.gid'];
          osm_id?: parameters['rowFilter.sul_roads_refactor.osm_id'];
          code?: parameters['rowFilter.sul_roads_refactor.code'];
          fclass?: parameters['rowFilter.sul_roads_refactor.fclass'];
          name?: parameters['rowFilter.sul_roads_refactor.name'];
          ref?: parameters['rowFilter.sul_roads_refactor.ref'];
          oneway?: parameters['rowFilter.sul_roads_refactor.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads_refactor.maxspeed'];
          layer?: parameters['rowFilter.sul_roads_refactor.layer'];
          bridge?: parameters['rowFilter.sul_roads_refactor.bridge'];
          tunnel?: parameters['rowFilter.sul_roads_refactor.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads_refactor.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads_refactor.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads_refactor.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads_refactor.geom'];
          fator?: parameters['rowFilter.sul_roads_refactor.fator'];
          geomhelper?: parameters['rowFilter.sul_roads_refactor.geomhelper'];
        };
        body: {
          /** sul_roads_refactor */
          sul_roads_refactor?: definitions['sul_roads_refactor'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/fontes_wms': {
    get: {
      parameters: {
        query: {
          id_fontes_wms?: parameters['rowFilter.fontes_wms.id_fontes_wms'];
          nome?: parameters['rowFilter.fontes_wms.nome'];
          descricao?: parameters['rowFilter.fontes_wms.descricao'];
          url?: parameters['rowFilter.fontes_wms.url'];
          foto?: parameters['rowFilter.fontes_wms.foto'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['fontes_wms'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** fontes_wms */
          fontes_wms?: definitions['fontes_wms'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_fontes_wms?: parameters['rowFilter.fontes_wms.id_fontes_wms'];
          nome?: parameters['rowFilter.fontes_wms.nome'];
          descricao?: parameters['rowFilter.fontes_wms.descricao'];
          url?: parameters['rowFilter.fontes_wms.url'];
          foto?: parameters['rowFilter.fontes_wms.foto'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_fontes_wms?: parameters['rowFilter.fontes_wms.id_fontes_wms'];
          nome?: parameters['rowFilter.fontes_wms.nome'];
          descricao?: parameters['rowFilter.fontes_wms.descricao'];
          url?: parameters['rowFilter.fontes_wms.url'];
          foto?: parameters['rowFilter.fontes_wms.foto'];
        };
        body: {
          /** fontes_wms */
          fontes_wms?: definitions['fontes_wms'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/planos': {
    get: {
      parameters: {
        query: {
          id_planos?: parameters['rowFilter.planos.id_planos'];
          nome?: parameters['rowFilter.planos.nome'];
          valor?: parameters['rowFilter.planos.valor'];
          qtd_usuarios?: parameters['rowFilter.planos.qtd_usuarios'];
          armazenamento?: parameters['rowFilter.planos.armazenamento'];
          qtd_projetos?: parameters['rowFilter.planos.qtd_projetos'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['planos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** planos */
          planos?: definitions['planos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_planos?: parameters['rowFilter.planos.id_planos'];
          nome?: parameters['rowFilter.planos.nome'];
          valor?: parameters['rowFilter.planos.valor'];
          qtd_usuarios?: parameters['rowFilter.planos.qtd_usuarios'];
          armazenamento?: parameters['rowFilter.planos.armazenamento'];
          qtd_projetos?: parameters['rowFilter.planos.qtd_projetos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_planos?: parameters['rowFilter.planos.id_planos'];
          nome?: parameters['rowFilter.planos.nome'];
          valor?: parameters['rowFilter.planos.valor'];
          qtd_usuarios?: parameters['rowFilter.planos.qtd_usuarios'];
          armazenamento?: parameters['rowFilter.planos.armazenamento'];
          qtd_projetos?: parameters['rowFilter.planos.qtd_projetos'];
        };
        body: {
          /** planos */
          planos?: definitions['planos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap': {
    get: {
      parameters: {
        query: {
          id_wikimap?: parameters['rowFilter.wikimap.id_wikimap'];
          mundial?: parameters['rowFilter.wikimap.mundial'];
          continental?: parameters['rowFilter.wikimap.continental'];
          pais?: parameters['rowFilter.wikimap.pais'];
          estado?: parameters['rowFilter.wikimap.estado'];
          regiao_metropolitana?: parameters['rowFilter.wikimap.regiao_metropolitana'];
          municipio?: parameters['rowFilter.wikimap.municipio'];
          h1?: parameters['rowFilter.wikimap.h1'];
          h2?: parameters['rowFilter.wikimap.h2'];
          h3?: parameters['rowFilter.wikimap.h3'];
          descricao?: parameters['rowFilter.wikimap.descricao'];
          fonte?: parameters['rowFilter.wikimap.fonte'];
          imagem?: parameters['rowFilter.wikimap.imagem'];
          publicar?: parameters['rowFilter.wikimap.publicar'];
          id_projetos?: parameters['rowFilter.wikimap.id_projetos'];
          id_wikimap_organizacao?: parameters['rowFilter.wikimap.id_wikimap_organizacao'];
          id_wikimap_tema_especifico?: parameters['rowFilter.wikimap.id_wikimap_tema_especifico'];
          id_wikimap_tema_geral?: parameters['rowFilter.wikimap.id_wikimap_tema_geral'];
          template?: parameters['rowFilter.wikimap.template'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap */
          wikimap?: definitions['wikimap'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_wikimap?: parameters['rowFilter.wikimap.id_wikimap'];
          mundial?: parameters['rowFilter.wikimap.mundial'];
          continental?: parameters['rowFilter.wikimap.continental'];
          pais?: parameters['rowFilter.wikimap.pais'];
          estado?: parameters['rowFilter.wikimap.estado'];
          regiao_metropolitana?: parameters['rowFilter.wikimap.regiao_metropolitana'];
          municipio?: parameters['rowFilter.wikimap.municipio'];
          h1?: parameters['rowFilter.wikimap.h1'];
          h2?: parameters['rowFilter.wikimap.h2'];
          h3?: parameters['rowFilter.wikimap.h3'];
          descricao?: parameters['rowFilter.wikimap.descricao'];
          fonte?: parameters['rowFilter.wikimap.fonte'];
          imagem?: parameters['rowFilter.wikimap.imagem'];
          publicar?: parameters['rowFilter.wikimap.publicar'];
          id_projetos?: parameters['rowFilter.wikimap.id_projetos'];
          id_wikimap_organizacao?: parameters['rowFilter.wikimap.id_wikimap_organizacao'];
          id_wikimap_tema_especifico?: parameters['rowFilter.wikimap.id_wikimap_tema_especifico'];
          id_wikimap_tema_geral?: parameters['rowFilter.wikimap.id_wikimap_tema_geral'];
          template?: parameters['rowFilter.wikimap.template'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_wikimap?: parameters['rowFilter.wikimap.id_wikimap'];
          mundial?: parameters['rowFilter.wikimap.mundial'];
          continental?: parameters['rowFilter.wikimap.continental'];
          pais?: parameters['rowFilter.wikimap.pais'];
          estado?: parameters['rowFilter.wikimap.estado'];
          regiao_metropolitana?: parameters['rowFilter.wikimap.regiao_metropolitana'];
          municipio?: parameters['rowFilter.wikimap.municipio'];
          h1?: parameters['rowFilter.wikimap.h1'];
          h2?: parameters['rowFilter.wikimap.h2'];
          h3?: parameters['rowFilter.wikimap.h3'];
          descricao?: parameters['rowFilter.wikimap.descricao'];
          fonte?: parameters['rowFilter.wikimap.fonte'];
          imagem?: parameters['rowFilter.wikimap.imagem'];
          publicar?: parameters['rowFilter.wikimap.publicar'];
          id_projetos?: parameters['rowFilter.wikimap.id_projetos'];
          id_wikimap_organizacao?: parameters['rowFilter.wikimap.id_wikimap_organizacao'];
          id_wikimap_tema_especifico?: parameters['rowFilter.wikimap.id_wikimap_tema_especifico'];
          id_wikimap_tema_geral?: parameters['rowFilter.wikimap.id_wikimap_tema_geral'];
          template?: parameters['rowFilter.wikimap.template'];
        };
        body: {
          /** wikimap */
          wikimap?: definitions['wikimap'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_mapas_personalizados': {
    get: {
      parameters: {
        query: {
          id_projetos_mapas_personalizados?: parameters['rowFilter.projetos_mapas_personalizados.id_projetos_mapas_personalizados'];
          id_projetos?: parameters['rowFilter.projetos_mapas_personalizados.id_projetos'];
          id_tenants?: parameters['rowFilter.projetos_mapas_personalizados.id_tenants'];
          id_usuarios?: parameters['rowFilter.projetos_mapas_personalizados.id_usuarios'];
          compartilhar?: parameters['rowFilter.projetos_mapas_personalizados.compartilhar'];
          publico?: parameters['rowFilter.projetos_mapas_personalizados.publico'];
          nome?: parameters['rowFilter.projetos_mapas_personalizados.nome'];
          configuracao?: parameters['rowFilter.projetos_mapas_personalizados.configuracao'];
          aud_id_criado_por?: parameters['rowFilter.projetos_mapas_personalizados.aud_id_criado_por'];
          aud_criado_data?: parameters['rowFilter.projetos_mapas_personalizados.aud_criado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_mapas_personalizados.aud_id_modificado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_mapas_personalizados.aud_modificado_data'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_mapas_personalizados'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_mapas_personalizados */
          projetos_mapas_personalizados?: definitions['projetos_mapas_personalizados'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_mapas_personalizados?: parameters['rowFilter.projetos_mapas_personalizados.id_projetos_mapas_personalizados'];
          id_projetos?: parameters['rowFilter.projetos_mapas_personalizados.id_projetos'];
          id_tenants?: parameters['rowFilter.projetos_mapas_personalizados.id_tenants'];
          id_usuarios?: parameters['rowFilter.projetos_mapas_personalizados.id_usuarios'];
          compartilhar?: parameters['rowFilter.projetos_mapas_personalizados.compartilhar'];
          publico?: parameters['rowFilter.projetos_mapas_personalizados.publico'];
          nome?: parameters['rowFilter.projetos_mapas_personalizados.nome'];
          configuracao?: parameters['rowFilter.projetos_mapas_personalizados.configuracao'];
          aud_id_criado_por?: parameters['rowFilter.projetos_mapas_personalizados.aud_id_criado_por'];
          aud_criado_data?: parameters['rowFilter.projetos_mapas_personalizados.aud_criado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_mapas_personalizados.aud_id_modificado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_mapas_personalizados.aud_modificado_data'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_mapas_personalizados?: parameters['rowFilter.projetos_mapas_personalizados.id_projetos_mapas_personalizados'];
          id_projetos?: parameters['rowFilter.projetos_mapas_personalizados.id_projetos'];
          id_tenants?: parameters['rowFilter.projetos_mapas_personalizados.id_tenants'];
          id_usuarios?: parameters['rowFilter.projetos_mapas_personalizados.id_usuarios'];
          compartilhar?: parameters['rowFilter.projetos_mapas_personalizados.compartilhar'];
          publico?: parameters['rowFilter.projetos_mapas_personalizados.publico'];
          nome?: parameters['rowFilter.projetos_mapas_personalizados.nome'];
          configuracao?: parameters['rowFilter.projetos_mapas_personalizados.configuracao'];
          aud_id_criado_por?: parameters['rowFilter.projetos_mapas_personalizados.aud_id_criado_por'];
          aud_criado_data?: parameters['rowFilter.projetos_mapas_personalizados.aud_criado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_mapas_personalizados.aud_id_modificado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_mapas_personalizados.aud_modificado_data'];
        };
        body: {
          /** projetos_mapas_personalizados */
          projetos_mapas_personalizados?: definitions['projetos_mapas_personalizados'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/amostras_raspagem': {
    get: {
      parameters: {
        query: {
          id_amostras_raspagem?: parameters['rowFilter.amostras_raspagem.id_amostras_raspagem'];
          vm2?: parameters['rowFilter.amostras_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_raspagem.x'];
          y?: parameters['rowFilter.amostras_raspagem.y'];
          site?: parameters['rowFilter.amostras_raspagem.site'];
          preco?: parameters['rowFilter.amostras_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_raspagem.estado'];
          data_insercao?: parameters['rowFilter.amostras_raspagem.data_insercao'];
          ruabairro?: parameters['rowFilter.amostras_raspagem.ruabairro'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['amostras_raspagem'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** amostras_raspagem */
          amostras_raspagem?: definitions['amostras_raspagem'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_amostras_raspagem?: parameters['rowFilter.amostras_raspagem.id_amostras_raspagem'];
          vm2?: parameters['rowFilter.amostras_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_raspagem.x'];
          y?: parameters['rowFilter.amostras_raspagem.y'];
          site?: parameters['rowFilter.amostras_raspagem.site'];
          preco?: parameters['rowFilter.amostras_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_raspagem.estado'];
          data_insercao?: parameters['rowFilter.amostras_raspagem.data_insercao'];
          ruabairro?: parameters['rowFilter.amostras_raspagem.ruabairro'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_amostras_raspagem?: parameters['rowFilter.amostras_raspagem.id_amostras_raspagem'];
          vm2?: parameters['rowFilter.amostras_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_raspagem.x'];
          y?: parameters['rowFilter.amostras_raspagem.y'];
          site?: parameters['rowFilter.amostras_raspagem.site'];
          preco?: parameters['rowFilter.amostras_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_raspagem.estado'];
          data_insercao?: parameters['rowFilter.amostras_raspagem.data_insercao'];
          ruabairro?: parameters['rowFilter.amostras_raspagem.ruabairro'];
        };
        body: {
          /** amostras_raspagem */
          amostras_raspagem?: definitions['amostras_raspagem'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/recebimentos': {
    get: {
      parameters: {
        query: {
          id_recebimentos?: parameters['rowFilter.recebimentos.id_recebimentos'];
          valor?: parameters['rowFilter.recebimentos.valor'];
          data_emissao?: parameters['rowFilter.recebimentos.data_emissao'];
          data_vencimento?: parameters['rowFilter.recebimentos.data_vencimento'];
          id_tenants?: parameters['rowFilter.recebimentos.id_tenants'];
          id_contratos?: parameters['rowFilter.recebimentos.id_contratos'];
          status?: parameters['rowFilter.recebimentos.status'];
          forma_pagamento?: parameters['rowFilter.recebimentos.forma_pagamento'];
          parcelas?: parameters['rowFilter.recebimentos.parcelas'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['recebimentos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** recebimentos */
          recebimentos?: definitions['recebimentos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_recebimentos?: parameters['rowFilter.recebimentos.id_recebimentos'];
          valor?: parameters['rowFilter.recebimentos.valor'];
          data_emissao?: parameters['rowFilter.recebimentos.data_emissao'];
          data_vencimento?: parameters['rowFilter.recebimentos.data_vencimento'];
          id_tenants?: parameters['rowFilter.recebimentos.id_tenants'];
          id_contratos?: parameters['rowFilter.recebimentos.id_contratos'];
          status?: parameters['rowFilter.recebimentos.status'];
          forma_pagamento?: parameters['rowFilter.recebimentos.forma_pagamento'];
          parcelas?: parameters['rowFilter.recebimentos.parcelas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_recebimentos?: parameters['rowFilter.recebimentos.id_recebimentos'];
          valor?: parameters['rowFilter.recebimentos.valor'];
          data_emissao?: parameters['rowFilter.recebimentos.data_emissao'];
          data_vencimento?: parameters['rowFilter.recebimentos.data_vencimento'];
          id_tenants?: parameters['rowFilter.recebimentos.id_tenants'];
          id_contratos?: parameters['rowFilter.recebimentos.id_contratos'];
          status?: parameters['rowFilter.recebimentos.status'];
          forma_pagamento?: parameters['rowFilter.recebimentos.forma_pagamento'];
          parcelas?: parameters['rowFilter.recebimentos.parcelas'];
        };
        body: {
          /** recebimentos */
          recebimentos?: definitions['recebimentos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_valores': {
    get: {
      parameters: {
        query: {
          id_projetos?: parameters['rowFilter.projetos_camadas_valores.id_projetos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_formularios_campos'];
          valor_num?: parameters['rowFilter.projetos_camadas_valores.valor_num'];
          valor_select?: parameters['rowFilter.projetos_camadas_valores.valor_select'];
          valor_checkbox?: parameters['rowFilter.projetos_camadas_valores.valor_checkbox'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_geometrias'];
          id_projetos_camadas_valores?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_valores'];
          valor_int?: parameters['rowFilter.projetos_camadas_valores.valor_int'];
          valor_text?: parameters['rowFilter.projetos_camadas_valores.valor_text'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_valores.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_valores.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_valores.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_valores.aud_id_modificado_por'];
          valor_timestamp?: parameters['rowFilter.projetos_camadas_valores.valor_timestamp'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_valores'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_valores */
          projetos_camadas_valores?: definitions['projetos_camadas_valores'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos?: parameters['rowFilter.projetos_camadas_valores.id_projetos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_formularios_campos'];
          valor_num?: parameters['rowFilter.projetos_camadas_valores.valor_num'];
          valor_select?: parameters['rowFilter.projetos_camadas_valores.valor_select'];
          valor_checkbox?: parameters['rowFilter.projetos_camadas_valores.valor_checkbox'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_geometrias'];
          id_projetos_camadas_valores?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_valores'];
          valor_int?: parameters['rowFilter.projetos_camadas_valores.valor_int'];
          valor_text?: parameters['rowFilter.projetos_camadas_valores.valor_text'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_valores.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_valores.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_valores.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_valores.aud_id_modificado_por'];
          valor_timestamp?: parameters['rowFilter.projetos_camadas_valores.valor_timestamp'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos?: parameters['rowFilter.projetos_camadas_valores.id_projetos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_formularios_campos'];
          valor_num?: parameters['rowFilter.projetos_camadas_valores.valor_num'];
          valor_select?: parameters['rowFilter.projetos_camadas_valores.valor_select'];
          valor_checkbox?: parameters['rowFilter.projetos_camadas_valores.valor_checkbox'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_geometrias'];
          id_projetos_camadas_valores?: parameters['rowFilter.projetos_camadas_valores.id_projetos_camadas_valores'];
          valor_int?: parameters['rowFilter.projetos_camadas_valores.valor_int'];
          valor_text?: parameters['rowFilter.projetos_camadas_valores.valor_text'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_valores.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_valores.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_valores.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_valores.aud_id_modificado_por'];
          valor_timestamp?: parameters['rowFilter.projetos_camadas_valores.valor_timestamp'];
        };
        body: {
          /** projetos_camadas_valores */
          projetos_camadas_valores?: definitions['projetos_camadas_valores'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/camadas_usuarios': {
    get: {
      parameters: {
        query: {
          id_camadas_usuarios?: parameters['rowFilter.camadas_usuarios.id_camadas_usuarios'];
          id_projetos_camadas?: parameters['rowFilter.camadas_usuarios.id_projetos_camadas'];
          id_usuarios?: parameters['rowFilter.camadas_usuarios.id_usuarios'];
          permissao?: parameters['rowFilter.camadas_usuarios.permissao'];
          aud_criado_data?: parameters['rowFilter.camadas_usuarios.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.camadas_usuarios.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.camadas_usuarios.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.camadas_usuarios.aud_id_modificado_por'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['camadas_usuarios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** camadas_usuarios */
          camadas_usuarios?: definitions['camadas_usuarios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_camadas_usuarios?: parameters['rowFilter.camadas_usuarios.id_camadas_usuarios'];
          id_projetos_camadas?: parameters['rowFilter.camadas_usuarios.id_projetos_camadas'];
          id_usuarios?: parameters['rowFilter.camadas_usuarios.id_usuarios'];
          permissao?: parameters['rowFilter.camadas_usuarios.permissao'];
          aud_criado_data?: parameters['rowFilter.camadas_usuarios.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.camadas_usuarios.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.camadas_usuarios.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.camadas_usuarios.aud_id_modificado_por'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_camadas_usuarios?: parameters['rowFilter.camadas_usuarios.id_camadas_usuarios'];
          id_projetos_camadas?: parameters['rowFilter.camadas_usuarios.id_projetos_camadas'];
          id_usuarios?: parameters['rowFilter.camadas_usuarios.id_usuarios'];
          permissao?: parameters['rowFilter.camadas_usuarios.permissao'];
          aud_criado_data?: parameters['rowFilter.camadas_usuarios.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.camadas_usuarios.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.camadas_usuarios.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.camadas_usuarios.aud_id_modificado_por'];
        };
        body: {
          /** camadas_usuarios */
          camadas_usuarios?: definitions['camadas_usuarios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/setores_sc': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_sc.gid'];
          nm_municip?: parameters['rowFilter.setores_sc.nm_municip'];
          geom?: parameters['rowFilter.setores_sc.geom'];
          cd_geocodi?: parameters['rowFilter.setores_sc.cd_geocodi'];
          cd_geocodm?: parameters['rowFilter.setores_sc.cd_geocodm'];
          geomtext?: parameters['rowFilter.setores_sc.geomtext'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['setores_sc'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** setores_sc */
          setores_sc?: definitions['setores_sc'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_sc.gid'];
          nm_municip?: parameters['rowFilter.setores_sc.nm_municip'];
          geom?: parameters['rowFilter.setores_sc.geom'];
          cd_geocodi?: parameters['rowFilter.setores_sc.cd_geocodi'];
          cd_geocodm?: parameters['rowFilter.setores_sc.cd_geocodm'];
          geomtext?: parameters['rowFilter.setores_sc.geomtext'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_sc.gid'];
          nm_municip?: parameters['rowFilter.setores_sc.nm_municip'];
          geom?: parameters['rowFilter.setores_sc.geom'];
          cd_geocodi?: parameters['rowFilter.setores_sc.cd_geocodi'];
          cd_geocodm?: parameters['rowFilter.setores_sc.cd_geocodm'];
          geomtext?: parameters['rowFilter.setores_sc.geomtext'];
        };
        body: {
          /** setores_sc */
          setores_sc?: definitions['setores_sc'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/krigagem': {
    get: {
      parameters: {
        query: {
          id_krigagem?: parameters['rowFilter.krigagem.id_krigagem'];
          id_variogramas?: parameters['rowFilter.krigagem.id_variogramas'];
          id_dominio_geografico?: parameters['rowFilter.krigagem.id_dominio_geografico'];
          referencia_raster?: parameters['rowFilter.krigagem.referencia_raster'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['krigagem'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** krigagem */
          krigagem?: definitions['krigagem'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_krigagem?: parameters['rowFilter.krigagem.id_krigagem'];
          id_variogramas?: parameters['rowFilter.krigagem.id_variogramas'];
          id_dominio_geografico?: parameters['rowFilter.krigagem.id_dominio_geografico'];
          referencia_raster?: parameters['rowFilter.krigagem.referencia_raster'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_krigagem?: parameters['rowFilter.krigagem.id_krigagem'];
          id_variogramas?: parameters['rowFilter.krigagem.id_variogramas'];
          id_dominio_geografico?: parameters['rowFilter.krigagem.id_dominio_geografico'];
          referencia_raster?: parameters['rowFilter.krigagem.referencia_raster'];
        };
        body: {
          /** krigagem */
          krigagem?: definitions['krigagem'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/valores_select': {
    get: {
      parameters: {
        query: {
          id_valores_select?: parameters['rowFilter.valores_select.id_valores_select'];
          id_projetos_camadas_valores?: parameters['rowFilter.valores_select.id_projetos_camadas_valores'];
          id_campos_select?: parameters['rowFilter.valores_select.id_campos_select'];
          tbl_valor_banco?: parameters['rowFilter.valores_select.tbl_valor_banco'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['valores_select'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** valores_select */
          valores_select?: definitions['valores_select'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_valores_select?: parameters['rowFilter.valores_select.id_valores_select'];
          id_projetos_camadas_valores?: parameters['rowFilter.valores_select.id_projetos_camadas_valores'];
          id_campos_select?: parameters['rowFilter.valores_select.id_campos_select'];
          tbl_valor_banco?: parameters['rowFilter.valores_select.tbl_valor_banco'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_valores_select?: parameters['rowFilter.valores_select.id_valores_select'];
          id_projetos_camadas_valores?: parameters['rowFilter.valores_select.id_projetos_camadas_valores'];
          id_campos_select?: parameters['rowFilter.valores_select.id_campos_select'];
          tbl_valor_banco?: parameters['rowFilter.valores_select.tbl_valor_banco'];
        };
        body: {
          /** valores_select */
          valores_select?: definitions['valores_select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/tenants': {
    get: {
      parameters: {
        query: {
          id_tenants?: parameters['rowFilter.tenants.id_tenants'];
          token?: parameters['rowFilter.tenants.token'];
          config?: parameters['rowFilter.tenants.config'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['tenants'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** tenants */
          tenants?: definitions['tenants'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_tenants?: parameters['rowFilter.tenants.id_tenants'];
          token?: parameters['rowFilter.tenants.token'];
          config?: parameters['rowFilter.tenants.config'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_tenants?: parameters['rowFilter.tenants.id_tenants'];
          token?: parameters['rowFilter.tenants.token'];
          config?: parameters['rowFilter.tenants.config'];
        };
        body: {
          /** tenants */
          tenants?: definitions['tenants'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/importacoes_dxf_geometrias': {
    get: {
      parameters: {
        query: {
          id_importacoes_dxf_geometrias?: parameters['rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf_geometrias'];
          id_importacoes_dxf?: parameters['rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf'];
          geom?: parameters['rowFilter.importacoes_dxf_geometrias.geom'];
          id_projetos?: parameters['rowFilter.importacoes_dxf_geometrias.id_projetos'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['importacoes_dxf_geometrias'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** importacoes_dxf_geometrias */
          importacoes_dxf_geometrias?: definitions['importacoes_dxf_geometrias'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_importacoes_dxf_geometrias?: parameters['rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf_geometrias'];
          id_importacoes_dxf?: parameters['rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf'];
          geom?: parameters['rowFilter.importacoes_dxf_geometrias.geom'];
          id_projetos?: parameters['rowFilter.importacoes_dxf_geometrias.id_projetos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_importacoes_dxf_geometrias?: parameters['rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf_geometrias'];
          id_importacoes_dxf?: parameters['rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf'];
          geom?: parameters['rowFilter.importacoes_dxf_geometrias.geom'];
          id_projetos?: parameters['rowFilter.importacoes_dxf_geometrias.id_projetos'];
        };
        body: {
          /** importacoes_dxf_geometrias */
          importacoes_dxf_geometrias?: definitions['importacoes_dxf_geometrias'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/contratos': {
    get: {
      parameters: {
        query: {
          id_contratos?: parameters['rowFilter.contratos.id_contratos'];
          id_planos?: parameters['rowFilter.contratos.id_planos'];
          valor?: parameters['rowFilter.contratos.valor'];
          qtd_usuarios?: parameters['rowFilter.contratos.qtd_usuarios'];
          data_contrato?: parameters['rowFilter.contratos.data_contrato'];
          id_licencas?: parameters['rowFilter.contratos.id_licencas'];
          armazenamento?: parameters['rowFilter.contratos.armazenamento'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['contratos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** contratos */
          contratos?: definitions['contratos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_contratos?: parameters['rowFilter.contratos.id_contratos'];
          id_planos?: parameters['rowFilter.contratos.id_planos'];
          valor?: parameters['rowFilter.contratos.valor'];
          qtd_usuarios?: parameters['rowFilter.contratos.qtd_usuarios'];
          data_contrato?: parameters['rowFilter.contratos.data_contrato'];
          id_licencas?: parameters['rowFilter.contratos.id_licencas'];
          armazenamento?: parameters['rowFilter.contratos.armazenamento'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_contratos?: parameters['rowFilter.contratos.id_contratos'];
          id_planos?: parameters['rowFilter.contratos.id_planos'];
          valor?: parameters['rowFilter.contratos.valor'];
          qtd_usuarios?: parameters['rowFilter.contratos.qtd_usuarios'];
          data_contrato?: parameters['rowFilter.contratos.data_contrato'];
          id_licencas?: parameters['rowFilter.contratos.id_licencas'];
          armazenamento?: parameters['rowFilter.contratos.armazenamento'];
        };
        body: {
          /** contratos */
          contratos?: definitions['contratos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/criciuma_zonas': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_geometrias?: parameters['rowFilter.criciuma_zonas.id_projetos_camadas_geometrias'];
          afastamento_embas?: parameters['rowFilter.criciuma_zonas.afastamento_embas'];
          afastamento_frente?: parameters['rowFilter.criciuma_zonas.afastamento_frente'];
          afastamento_torre?: parameters['rowFilter.criciuma_zonas.afastamento_torre'];
          area_maxima_lote?: parameters['rowFilter.criciuma_zonas.area_maxima_lote'];
          area_minima_lote?: parameters['rowFilter.criciuma_zonas.area_minima_lote'];
          caracterizacao?: parameters['rowFilter.criciuma_zonas.caracterizacao'];
          codigo?: parameters['rowFilter.criciuma_zonas.codigo'];
          id_zona?: parameters['rowFilter.criciuma_zonas.id_zona'];
          indice_basico_aproveitamento?: parameters['rowFilter.criciuma_zonas.indice_basico_aproveitamento'];
          indice_max_aproveitamento?: parameters['rowFilter.criciuma_zonas.indice_max_aproveitamento'];
          nome?: parameters['rowFilter.criciuma_zonas.nome'];
          numero_max_pavimentos?: parameters['rowFilter.criciuma_zonas.numero_max_pavimentos'];
          objetivos?: parameters['rowFilter.criciuma_zonas.objetivos'];
          observacoes?: parameters['rowFilter.criciuma_zonas.observacoes'];
          taxa_basica_infiltracao?: parameters['rowFilter.criciuma_zonas.taxa_basica_infiltracao'];
          taxa_basica_ocupacao?: parameters['rowFilter.criciuma_zonas.taxa_basica_ocupacao'];
          taxa_max_ocupacao?: parameters['rowFilter.criciuma_zonas.taxa_max_ocupacao'];
          taxa_min_infiltracao?: parameters['rowFilter.criciuma_zonas.taxa_min_infiltracao'];
          valor_outorga?: parameters['rowFilter.criciuma_zonas.valor_outorga'];
          geom?: parameters['rowFilter.criciuma_zonas.geom'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['criciuma_zonas'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
  };
  '/projetos_camadas_valores_valores_select': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_valores_valores_select.id_projetos_camadas_formularios_campos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_valores_valores_select.id_projetos_camadas'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_valores_valores_select.id_projetos_camadas_geometrias'];
          resumo?: parameters['rowFilter.projetos_camadas_valores_valores_select.resumo'];
          nome?: parameters['rowFilter.projetos_camadas_valores_valores_select.nome'];
          valor_num?: parameters['rowFilter.projetos_camadas_valores_valores_select.valor_num'];
          valor_checkbox?: parameters['rowFilter.projetos_camadas_valores_valores_select.valor_checkbox'];
          valor_int?: parameters['rowFilter.projetos_camadas_valores_valores_select.valor_int'];
          valor_text?: parameters['rowFilter.projetos_camadas_valores_valores_select.valor_text'];
          valor_timestamp?: parameters['rowFilter.projetos_camadas_valores_valores_select.valor_timestamp'];
          valor_select?: parameters['rowFilter.projetos_camadas_valores_valores_select.valor_select'];
          id_campos_select?: parameters['rowFilter.projetos_camadas_valores_valores_select.id_campos_select'];
          tipo?: parameters['rowFilter.projetos_camadas_valores_valores_select.tipo'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_valores_valores_select'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
  };
  '/projetos_usuarios': {
    get: {
      parameters: {
        query: {
          id_projetos_usuarios?: parameters['rowFilter.projetos_usuarios.id_projetos_usuarios'];
          id_projetos?: parameters['rowFilter.projetos_usuarios.id_projetos'];
          id_usuarios?: parameters['rowFilter.projetos_usuarios.id_usuarios'];
          permissao?: parameters['rowFilter.projetos_usuarios.permissao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_usuarios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_usuarios */
          projetos_usuarios?: definitions['projetos_usuarios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_usuarios?: parameters['rowFilter.projetos_usuarios.id_projetos_usuarios'];
          id_projetos?: parameters['rowFilter.projetos_usuarios.id_projetos'];
          id_usuarios?: parameters['rowFilter.projetos_usuarios.id_usuarios'];
          permissao?: parameters['rowFilter.projetos_usuarios.permissao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_usuarios?: parameters['rowFilter.projetos_usuarios.id_projetos_usuarios'];
          id_projetos?: parameters['rowFilter.projetos_usuarios.id_projetos'];
          id_usuarios?: parameters['rowFilter.projetos_usuarios.id_usuarios'];
          permissao?: parameters['rowFilter.projetos_usuarios.permissao'];
        };
        body: {
          /** projetos_usuarios */
          projetos_usuarios?: definitions['projetos_usuarios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/campos_select': {
    get: {
      parameters: {
        query: {
          id_campos_select?: parameters['rowFilter.campos_select.id_campos_select'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.campos_select.id_projetos_camadas_formularios_campos'];
          nome?: parameters['rowFilter.campos_select.nome'];
          ordem?: parameters['rowFilter.campos_select.ordem'];
          ativo?: parameters['rowFilter.campos_select.ativo'];
          fator?: parameters['rowFilter.campos_select.fator'];
          tbl_valor_db?: parameters['rowFilter.campos_select.tbl_valor_db'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['campos_select'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** campos_select */
          campos_select?: definitions['campos_select'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_campos_select?: parameters['rowFilter.campos_select.id_campos_select'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.campos_select.id_projetos_camadas_formularios_campos'];
          nome?: parameters['rowFilter.campos_select.nome'];
          ordem?: parameters['rowFilter.campos_select.ordem'];
          ativo?: parameters['rowFilter.campos_select.ativo'];
          fator?: parameters['rowFilter.campos_select.fator'];
          tbl_valor_db?: parameters['rowFilter.campos_select.tbl_valor_db'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_campos_select?: parameters['rowFilter.campos_select.id_campos_select'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.campos_select.id_projetos_camadas_formularios_campos'];
          nome?: parameters['rowFilter.campos_select.nome'];
          ordem?: parameters['rowFilter.campos_select.ordem'];
          ativo?: parameters['rowFilter.campos_select.ativo'];
          fator?: parameters['rowFilter.campos_select.fator'];
          tbl_valor_db?: parameters['rowFilter.campos_select.tbl_valor_db'];
        };
        body: {
          /** campos_select */
          campos_select?: definitions['campos_select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/importacoes_pendentes': {
    get: {
      parameters: {
        query: {
          id_importacoes_pendentes?: parameters['rowFilter.importacoes_pendentes.id_importacoes_pendentes'];
          codigo?: parameters['rowFilter.importacoes_pendentes.codigo'];
          status_completo?: parameters['rowFilter.importacoes_pendentes.status_completo'];
          descricao?: parameters['rowFilter.importacoes_pendentes.descricao'];
          id_projetos?: parameters['rowFilter.importacoes_pendentes.id_projetos'];
          hide?: parameters['rowFilter.importacoes_pendentes.hide'];
          representacao?: parameters['rowFilter.importacoes_pendentes.representacao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['importacoes_pendentes'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** importacoes_pendentes */
          importacoes_pendentes?: definitions['importacoes_pendentes'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_importacoes_pendentes?: parameters['rowFilter.importacoes_pendentes.id_importacoes_pendentes'];
          codigo?: parameters['rowFilter.importacoes_pendentes.codigo'];
          status_completo?: parameters['rowFilter.importacoes_pendentes.status_completo'];
          descricao?: parameters['rowFilter.importacoes_pendentes.descricao'];
          id_projetos?: parameters['rowFilter.importacoes_pendentes.id_projetos'];
          hide?: parameters['rowFilter.importacoes_pendentes.hide'];
          representacao?: parameters['rowFilter.importacoes_pendentes.representacao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_importacoes_pendentes?: parameters['rowFilter.importacoes_pendentes.id_importacoes_pendentes'];
          codigo?: parameters['rowFilter.importacoes_pendentes.codigo'];
          status_completo?: parameters['rowFilter.importacoes_pendentes.status_completo'];
          descricao?: parameters['rowFilter.importacoes_pendentes.descricao'];
          id_projetos?: parameters['rowFilter.importacoes_pendentes.id_projetos'];
          hide?: parameters['rowFilter.importacoes_pendentes.hide'];
          representacao?: parameters['rowFilter.importacoes_pendentes.representacao'];
        };
        body: {
          /** importacoes_pendentes */
          importacoes_pendentes?: definitions['importacoes_pendentes'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap_organizacao': {
    get: {
      parameters: {
        query: {
          id_wikimap_organizacao?: parameters['rowFilter.wikimap_organizacao.id_wikimap_organizacao'];
          organizacao?: parameters['rowFilter.wikimap_organizacao.organizacao'];
          sigla?: parameters['rowFilter.wikimap_organizacao.sigla'];
          url?: parameters['rowFilter.wikimap_organizacao.url'];
          descricao?: parameters['rowFilter.wikimap_organizacao.descricao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap_organizacao'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap_organizacao */
          wikimap_organizacao?: definitions['wikimap_organizacao'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_wikimap_organizacao?: parameters['rowFilter.wikimap_organizacao.id_wikimap_organizacao'];
          organizacao?: parameters['rowFilter.wikimap_organizacao.organizacao'];
          sigla?: parameters['rowFilter.wikimap_organizacao.sigla'];
          url?: parameters['rowFilter.wikimap_organizacao.url'];
          descricao?: parameters['rowFilter.wikimap_organizacao.descricao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_wikimap_organizacao?: parameters['rowFilter.wikimap_organizacao.id_wikimap_organizacao'];
          organizacao?: parameters['rowFilter.wikimap_organizacao.organizacao'];
          sigla?: parameters['rowFilter.wikimap_organizacao.sigla'];
          url?: parameters['rowFilter.wikimap_organizacao.url'];
          descricao?: parameters['rowFilter.wikimap_organizacao.descricao'];
        };
        body: {
          /** wikimap_organizacao */
          wikimap_organizacao?: definitions['wikimap_organizacao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas.id_projetos_camadas'];
          nome?: parameters['rowFilter.projetos_camadas.nome'];
          id_projetos?: parameters['rowFilter.projetos_camadas.id_projetos'];
          ativo?: parameters['rowFilter.projetos_camadas.ativo'];
          tipo_geometria?: parameters['rowFilter.projetos_camadas.tipo_geometria'];
          cor?: parameters['rowFilter.projetos_camadas.cor'];
          espessura?: parameters['rowFilter.projetos_camadas.espessura'];
          preenchimento?: parameters['rowFilter.projetos_camadas.preenchimento'];
          tipo_linha?: parameters['rowFilter.projetos_camadas.tipo_linha'];
          simbolo_ponto?: parameters['rowFilter.projetos_camadas.simbolo_ponto'];
          tamanho_ponto?: parameters['rowFilter.projetos_camadas.tamanho_ponto'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas.aud_id_modificado_por'];
          rotulo_ativo?: parameters['rowFilter.projetos_camadas.rotulo_ativo'];
          rotulo_nome?: parameters['rowFilter.projetos_camadas.rotulo_nome'];
          sld_body?: parameters['rowFilter.projetos_camadas.sld_body'];
          ordem_visualizacao?: parameters['rowFilter.projetos_camadas.ordem_visualizacao'];
          visibilidade?: parameters['rowFilter.projetos_camadas.visibilidade'];
          tamanho_rotulo?: parameters['rowFilter.projetos_camadas.tamanho_rotulo'];
          legenda?: parameters['rowFilter.projetos_camadas.legenda'];
          mapa_tematico?: parameters['rowFilter.projetos_camadas.mapa_tematico'];
          campo_mapa_tematico?: parameters['rowFilter.projetos_camadas.campo_mapa_tematico'];
          id_campo_mapa_tematico?: parameters['rowFilter.projetos_camadas.id_campo_mapa_tematico'];
          layer_size?: parameters['rowFilter.projetos_camadas.layer_size'];
          id_campo_rotulo?: parameters['rowFilter.projetos_camadas.id_campo_rotulo'];
          publico_ouv?: parameters['rowFilter.projetos_camadas.publico_ouv'];
          tipo_camada?: parameters['rowFilter.projetos_camadas.tipo_camada'];
          representacao?: parameters['rowFilter.projetos_camadas.representacao'];
          equacao?: parameters['rowFilter.projetos_camadas.equacao'];
          show_ouv?: parameters['rowFilter.projetos_camadas.show_ouv'];
          escala_max?: parameters['rowFilter.projetos_camadas.escala_max'];
          escala_min?: parameters['rowFilter.projetos_camadas.escala_min'];
          aud_atualizado_raspagem?: parameters['rowFilter.projetos_camadas.aud_atualizado_raspagem'];
          sld_body_ouv?: parameters['rowFilter.projetos_camadas.sld_body_ouv'];
          mapa_tematico_ouv?: parameters['rowFilter.projetos_camadas.mapa_tematico_ouv'];
          estiloouv?: parameters['rowFilter.projetos_camadas.estiloouv'];
          rotulo_decimal?: parameters['rowFilter.projetos_camadas.rotulo_decimal'];
          estilowebgeo?: parameters['rowFilter.projetos_camadas.estilowebgeo'];
          mapa_tematico_fix?: parameters['rowFilter.projetos_camadas.mapa_tematico_fix'];
          privada?: parameters['rowFilter.projetos_camadas.privada'];
          id_campo_rotulo_rotacao?: parameters['rowFilter.projetos_camadas.id_campo_rotulo_rotacao'];
          estiloconsultaprevia?: parameters['rowFilter.projetos_camadas.estiloconsultaprevia'];
          estiloconsultapreviatext?: parameters['rowFilter.projetos_camadas.estiloconsultapreviatext'];
          estiloavaliacao?: parameters['rowFilter.projetos_camadas.estiloavaliacao'];
          show_previa?: parameters['rowFilter.projetos_camadas.show_previa'];
          show_icad?: parameters['rowFilter.projetos_camadas.show_icad'];
          show_avaliacao?: parameters['rowFilter.projetos_camadas.show_avaliacao'];
          publico_icad?: parameters['rowFilter.projetos_camadas.publico_icad'];
          estilo_icad?: parameters['rowFilter.projetos_camadas.estilo_icad'];
          legenda_fix?: parameters['rowFilter.projetos_camadas.legenda_fix'];
          show_generico?: parameters['rowFilter.projetos_camadas.show_generico'];
          publico_generico?: parameters['rowFilter.projetos_camadas.publico_generico'];
          estilo_generico?: parameters['rowFilter.projetos_camadas.estilo_generico'];
          id_campos_rotulos?: parameters['rowFilter.projetos_camadas.id_campos_rotulos'];
          tbl_nome_db?: parameters['rowFilter.projetos_camadas.tbl_nome_db'];
          chave_principal?: parameters['rowFilter.projetos_camadas.chave_principal'];
          chave_secundaria?: parameters['rowFilter.projetos_camadas.chave_secundaria'];
          descricao?: parameters['rowFilter.projetos_camadas.descricao'];
          url?: parameters['rowFilter.projetos_camadas.url'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas */
          projetos_camadas?: definitions['projetos_camadas'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas.id_projetos_camadas'];
          nome?: parameters['rowFilter.projetos_camadas.nome'];
          id_projetos?: parameters['rowFilter.projetos_camadas.id_projetos'];
          ativo?: parameters['rowFilter.projetos_camadas.ativo'];
          tipo_geometria?: parameters['rowFilter.projetos_camadas.tipo_geometria'];
          cor?: parameters['rowFilter.projetos_camadas.cor'];
          espessura?: parameters['rowFilter.projetos_camadas.espessura'];
          preenchimento?: parameters['rowFilter.projetos_camadas.preenchimento'];
          tipo_linha?: parameters['rowFilter.projetos_camadas.tipo_linha'];
          simbolo_ponto?: parameters['rowFilter.projetos_camadas.simbolo_ponto'];
          tamanho_ponto?: parameters['rowFilter.projetos_camadas.tamanho_ponto'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas.aud_id_modificado_por'];
          rotulo_ativo?: parameters['rowFilter.projetos_camadas.rotulo_ativo'];
          rotulo_nome?: parameters['rowFilter.projetos_camadas.rotulo_nome'];
          sld_body?: parameters['rowFilter.projetos_camadas.sld_body'];
          ordem_visualizacao?: parameters['rowFilter.projetos_camadas.ordem_visualizacao'];
          visibilidade?: parameters['rowFilter.projetos_camadas.visibilidade'];
          tamanho_rotulo?: parameters['rowFilter.projetos_camadas.tamanho_rotulo'];
          legenda?: parameters['rowFilter.projetos_camadas.legenda'];
          mapa_tematico?: parameters['rowFilter.projetos_camadas.mapa_tematico'];
          campo_mapa_tematico?: parameters['rowFilter.projetos_camadas.campo_mapa_tematico'];
          id_campo_mapa_tematico?: parameters['rowFilter.projetos_camadas.id_campo_mapa_tematico'];
          layer_size?: parameters['rowFilter.projetos_camadas.layer_size'];
          id_campo_rotulo?: parameters['rowFilter.projetos_camadas.id_campo_rotulo'];
          publico_ouv?: parameters['rowFilter.projetos_camadas.publico_ouv'];
          tipo_camada?: parameters['rowFilter.projetos_camadas.tipo_camada'];
          representacao?: parameters['rowFilter.projetos_camadas.representacao'];
          equacao?: parameters['rowFilter.projetos_camadas.equacao'];
          show_ouv?: parameters['rowFilter.projetos_camadas.show_ouv'];
          escala_max?: parameters['rowFilter.projetos_camadas.escala_max'];
          escala_min?: parameters['rowFilter.projetos_camadas.escala_min'];
          aud_atualizado_raspagem?: parameters['rowFilter.projetos_camadas.aud_atualizado_raspagem'];
          sld_body_ouv?: parameters['rowFilter.projetos_camadas.sld_body_ouv'];
          mapa_tematico_ouv?: parameters['rowFilter.projetos_camadas.mapa_tematico_ouv'];
          estiloouv?: parameters['rowFilter.projetos_camadas.estiloouv'];
          rotulo_decimal?: parameters['rowFilter.projetos_camadas.rotulo_decimal'];
          estilowebgeo?: parameters['rowFilter.projetos_camadas.estilowebgeo'];
          mapa_tematico_fix?: parameters['rowFilter.projetos_camadas.mapa_tematico_fix'];
          privada?: parameters['rowFilter.projetos_camadas.privada'];
          id_campo_rotulo_rotacao?: parameters['rowFilter.projetos_camadas.id_campo_rotulo_rotacao'];
          estiloconsultaprevia?: parameters['rowFilter.projetos_camadas.estiloconsultaprevia'];
          estiloconsultapreviatext?: parameters['rowFilter.projetos_camadas.estiloconsultapreviatext'];
          estiloavaliacao?: parameters['rowFilter.projetos_camadas.estiloavaliacao'];
          show_previa?: parameters['rowFilter.projetos_camadas.show_previa'];
          show_icad?: parameters['rowFilter.projetos_camadas.show_icad'];
          show_avaliacao?: parameters['rowFilter.projetos_camadas.show_avaliacao'];
          publico_icad?: parameters['rowFilter.projetos_camadas.publico_icad'];
          estilo_icad?: parameters['rowFilter.projetos_camadas.estilo_icad'];
          legenda_fix?: parameters['rowFilter.projetos_camadas.legenda_fix'];
          show_generico?: parameters['rowFilter.projetos_camadas.show_generico'];
          publico_generico?: parameters['rowFilter.projetos_camadas.publico_generico'];
          estilo_generico?: parameters['rowFilter.projetos_camadas.estilo_generico'];
          id_campos_rotulos?: parameters['rowFilter.projetos_camadas.id_campos_rotulos'];
          tbl_nome_db?: parameters['rowFilter.projetos_camadas.tbl_nome_db'];
          chave_principal?: parameters['rowFilter.projetos_camadas.chave_principal'];
          chave_secundaria?: parameters['rowFilter.projetos_camadas.chave_secundaria'];
          descricao?: parameters['rowFilter.projetos_camadas.descricao'];
          url?: parameters['rowFilter.projetos_camadas.url'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas.id_projetos_camadas'];
          nome?: parameters['rowFilter.projetos_camadas.nome'];
          id_projetos?: parameters['rowFilter.projetos_camadas.id_projetos'];
          ativo?: parameters['rowFilter.projetos_camadas.ativo'];
          tipo_geometria?: parameters['rowFilter.projetos_camadas.tipo_geometria'];
          cor?: parameters['rowFilter.projetos_camadas.cor'];
          espessura?: parameters['rowFilter.projetos_camadas.espessura'];
          preenchimento?: parameters['rowFilter.projetos_camadas.preenchimento'];
          tipo_linha?: parameters['rowFilter.projetos_camadas.tipo_linha'];
          simbolo_ponto?: parameters['rowFilter.projetos_camadas.simbolo_ponto'];
          tamanho_ponto?: parameters['rowFilter.projetos_camadas.tamanho_ponto'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas.aud_id_modificado_por'];
          rotulo_ativo?: parameters['rowFilter.projetos_camadas.rotulo_ativo'];
          rotulo_nome?: parameters['rowFilter.projetos_camadas.rotulo_nome'];
          sld_body?: parameters['rowFilter.projetos_camadas.sld_body'];
          ordem_visualizacao?: parameters['rowFilter.projetos_camadas.ordem_visualizacao'];
          visibilidade?: parameters['rowFilter.projetos_camadas.visibilidade'];
          tamanho_rotulo?: parameters['rowFilter.projetos_camadas.tamanho_rotulo'];
          legenda?: parameters['rowFilter.projetos_camadas.legenda'];
          mapa_tematico?: parameters['rowFilter.projetos_camadas.mapa_tematico'];
          campo_mapa_tematico?: parameters['rowFilter.projetos_camadas.campo_mapa_tematico'];
          id_campo_mapa_tematico?: parameters['rowFilter.projetos_camadas.id_campo_mapa_tematico'];
          layer_size?: parameters['rowFilter.projetos_camadas.layer_size'];
          id_campo_rotulo?: parameters['rowFilter.projetos_camadas.id_campo_rotulo'];
          publico_ouv?: parameters['rowFilter.projetos_camadas.publico_ouv'];
          tipo_camada?: parameters['rowFilter.projetos_camadas.tipo_camada'];
          representacao?: parameters['rowFilter.projetos_camadas.representacao'];
          equacao?: parameters['rowFilter.projetos_camadas.equacao'];
          show_ouv?: parameters['rowFilter.projetos_camadas.show_ouv'];
          escala_max?: parameters['rowFilter.projetos_camadas.escala_max'];
          escala_min?: parameters['rowFilter.projetos_camadas.escala_min'];
          aud_atualizado_raspagem?: parameters['rowFilter.projetos_camadas.aud_atualizado_raspagem'];
          sld_body_ouv?: parameters['rowFilter.projetos_camadas.sld_body_ouv'];
          mapa_tematico_ouv?: parameters['rowFilter.projetos_camadas.mapa_tematico_ouv'];
          estiloouv?: parameters['rowFilter.projetos_camadas.estiloouv'];
          rotulo_decimal?: parameters['rowFilter.projetos_camadas.rotulo_decimal'];
          estilowebgeo?: parameters['rowFilter.projetos_camadas.estilowebgeo'];
          mapa_tematico_fix?: parameters['rowFilter.projetos_camadas.mapa_tematico_fix'];
          privada?: parameters['rowFilter.projetos_camadas.privada'];
          id_campo_rotulo_rotacao?: parameters['rowFilter.projetos_camadas.id_campo_rotulo_rotacao'];
          estiloconsultaprevia?: parameters['rowFilter.projetos_camadas.estiloconsultaprevia'];
          estiloconsultapreviatext?: parameters['rowFilter.projetos_camadas.estiloconsultapreviatext'];
          estiloavaliacao?: parameters['rowFilter.projetos_camadas.estiloavaliacao'];
          show_previa?: parameters['rowFilter.projetos_camadas.show_previa'];
          show_icad?: parameters['rowFilter.projetos_camadas.show_icad'];
          show_avaliacao?: parameters['rowFilter.projetos_camadas.show_avaliacao'];
          publico_icad?: parameters['rowFilter.projetos_camadas.publico_icad'];
          estilo_icad?: parameters['rowFilter.projetos_camadas.estilo_icad'];
          legenda_fix?: parameters['rowFilter.projetos_camadas.legenda_fix'];
          show_generico?: parameters['rowFilter.projetos_camadas.show_generico'];
          publico_generico?: parameters['rowFilter.projetos_camadas.publico_generico'];
          estilo_generico?: parameters['rowFilter.projetos_camadas.estilo_generico'];
          id_campos_rotulos?: parameters['rowFilter.projetos_camadas.id_campos_rotulos'];
          tbl_nome_db?: parameters['rowFilter.projetos_camadas.tbl_nome_db'];
          chave_principal?: parameters['rowFilter.projetos_camadas.chave_principal'];
          chave_secundaria?: parameters['rowFilter.projetos_camadas.chave_secundaria'];
          descricao?: parameters['rowFilter.projetos_camadas.descricao'];
          url?: parameters['rowFilter.projetos_camadas.url'];
        };
        body: {
          /** projetos_camadas */
          projetos_camadas?: definitions['projetos_camadas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/usuarios': {
    get: {
      parameters: {
        query: {
          id_usuarios?: parameters['rowFilter.usuarios.id_usuarios'];
          nome?: parameters['rowFilter.usuarios.nome'];
          auth_token?: parameters['rowFilter.usuarios.auth_token'];
          email?: parameters['rowFilter.usuarios.email'];
          senha?: parameters['rowFilter.usuarios.senha'];
          id_tenants?: parameters['rowFilter.usuarios.id_tenants'];
          adm?: parameters['rowFilter.usuarios.adm'];
          tipo?: parameters['rowFilter.usuarios.tipo'];
          ativo?: parameters['rowFilter.usuarios.ativo'];
          status_import?: parameters['rowFilter.usuarios.status_import'];
          ip_login?: parameters['rowFilter.usuarios.ip_login'];
          foto?: parameters['rowFilter.usuarios.foto'];
          user?: parameters['rowFilter.usuarios.user'];
          colaborativo?: parameters['rowFilter.usuarios.colaborativo'];
          classificacoes?: parameters['rowFilter.usuarios.classificacoes'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['usuarios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** usuarios */
          usuarios?: definitions['usuarios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_usuarios?: parameters['rowFilter.usuarios.id_usuarios'];
          nome?: parameters['rowFilter.usuarios.nome'];
          auth_token?: parameters['rowFilter.usuarios.auth_token'];
          email?: parameters['rowFilter.usuarios.email'];
          senha?: parameters['rowFilter.usuarios.senha'];
          id_tenants?: parameters['rowFilter.usuarios.id_tenants'];
          adm?: parameters['rowFilter.usuarios.adm'];
          tipo?: parameters['rowFilter.usuarios.tipo'];
          ativo?: parameters['rowFilter.usuarios.ativo'];
          status_import?: parameters['rowFilter.usuarios.status_import'];
          ip_login?: parameters['rowFilter.usuarios.ip_login'];
          foto?: parameters['rowFilter.usuarios.foto'];
          user?: parameters['rowFilter.usuarios.user'];
          colaborativo?: parameters['rowFilter.usuarios.colaborativo'];
          classificacoes?: parameters['rowFilter.usuarios.classificacoes'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_usuarios?: parameters['rowFilter.usuarios.id_usuarios'];
          nome?: parameters['rowFilter.usuarios.nome'];
          auth_token?: parameters['rowFilter.usuarios.auth_token'];
          email?: parameters['rowFilter.usuarios.email'];
          senha?: parameters['rowFilter.usuarios.senha'];
          id_tenants?: parameters['rowFilter.usuarios.id_tenants'];
          adm?: parameters['rowFilter.usuarios.adm'];
          tipo?: parameters['rowFilter.usuarios.tipo'];
          ativo?: parameters['rowFilter.usuarios.ativo'];
          status_import?: parameters['rowFilter.usuarios.status_import'];
          ip_login?: parameters['rowFilter.usuarios.ip_login'];
          foto?: parameters['rowFilter.usuarios.foto'];
          user?: parameters['rowFilter.usuarios.user'];
          colaborativo?: parameters['rowFilter.usuarios.colaborativo'];
          classificacoes?: parameters['rowFilter.usuarios.classificacoes'];
        };
        body: {
          /** usuarios */
          usuarios?: definitions['usuarios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap_comentarios': {
    get: {
      parameters: {
        query: {
          id_wikimap_comentarios?: parameters['rowFilter.wikimap_comentarios.id_wikimap_comentarios'];
          id_wikimap?: parameters['rowFilter.wikimap_comentarios.id_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_comentarios.id_usuarios'];
          comentario?: parameters['rowFilter.wikimap_comentarios.comentario'];
          criado?: parameters['rowFilter.wikimap_comentarios.criado'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap_comentarios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap_comentarios */
          wikimap_comentarios?: definitions['wikimap_comentarios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_wikimap_comentarios?: parameters['rowFilter.wikimap_comentarios.id_wikimap_comentarios'];
          id_wikimap?: parameters['rowFilter.wikimap_comentarios.id_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_comentarios.id_usuarios'];
          comentario?: parameters['rowFilter.wikimap_comentarios.comentario'];
          criado?: parameters['rowFilter.wikimap_comentarios.criado'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_wikimap_comentarios?: parameters['rowFilter.wikimap_comentarios.id_wikimap_comentarios'];
          id_wikimap?: parameters['rowFilter.wikimap_comentarios.id_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_comentarios.id_usuarios'];
          comentario?: parameters['rowFilter.wikimap_comentarios.comentario'];
          criado?: parameters['rowFilter.wikimap_comentarios.criado'];
        };
        body: {
          /** wikimap_comentarios */
          wikimap_comentarios?: definitions['wikimap_comentarios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/django_migrations': {
    get: {
      parameters: {
        query: {
          id?: parameters['rowFilter.django_migrations.id'];
          app?: parameters['rowFilter.django_migrations.app'];
          name?: parameters['rowFilter.django_migrations.name'];
          applied?: parameters['rowFilter.django_migrations.applied'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['django_migrations'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** django_migrations */
          django_migrations?: definitions['django_migrations'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id?: parameters['rowFilter.django_migrations.id'];
          app?: parameters['rowFilter.django_migrations.app'];
          name?: parameters['rowFilter.django_migrations.name'];
          applied?: parameters['rowFilter.django_migrations.applied'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id?: parameters['rowFilter.django_migrations.id'];
          app?: parameters['rowFilter.django_migrations.app'];
          name?: parameters['rowFilter.django_migrations.name'];
          applied?: parameters['rowFilter.django_migrations.applied'];
        };
        body: {
          /** django_migrations */
          django_migrations?: definitions['django_migrations'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/solicitacoes_ouv': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.solicitacoes_ouv.gid'];
          nome?: parameters['rowFilter.solicitacoes_ouv.nome'];
          email?: parameters['rowFilter.solicitacoes_ouv.email'];
          msg?: parameters['rowFilter.solicitacoes_ouv.msg'];
          telefone?: parameters['rowFilter.solicitacoes_ouv.telefone'];
          empresa?: parameters['rowFilter.solicitacoes_ouv.empresa'];
          data?: parameters['rowFilter.solicitacoes_ouv.data'];
          ip?: parameters['rowFilter.solicitacoes_ouv.ip'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['solicitacoes_ouv'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** solicitacoes_ouv */
          solicitacoes_ouv?: definitions['solicitacoes_ouv'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.solicitacoes_ouv.gid'];
          nome?: parameters['rowFilter.solicitacoes_ouv.nome'];
          email?: parameters['rowFilter.solicitacoes_ouv.email'];
          msg?: parameters['rowFilter.solicitacoes_ouv.msg'];
          telefone?: parameters['rowFilter.solicitacoes_ouv.telefone'];
          empresa?: parameters['rowFilter.solicitacoes_ouv.empresa'];
          data?: parameters['rowFilter.solicitacoes_ouv.data'];
          ip?: parameters['rowFilter.solicitacoes_ouv.ip'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.solicitacoes_ouv.gid'];
          nome?: parameters['rowFilter.solicitacoes_ouv.nome'];
          email?: parameters['rowFilter.solicitacoes_ouv.email'];
          msg?: parameters['rowFilter.solicitacoes_ouv.msg'];
          telefone?: parameters['rowFilter.solicitacoes_ouv.telefone'];
          empresa?: parameters['rowFilter.solicitacoes_ouv.empresa'];
          data?: parameters['rowFilter.solicitacoes_ouv.data'];
          ip?: parameters['rowFilter.solicitacoes_ouv.ip'];
        };
        body: {
          /** solicitacoes_ouv */
          solicitacoes_ouv?: definitions['solicitacoes_ouv'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/faturamentos': {
    get: {
      parameters: {
        query: {
          id_faturamentos?: parameters['rowFilter.faturamentos.id_faturamentos'];
          id_tenants?: parameters['rowFilter.faturamentos.id_tenants'];
          id_contratos?: parameters['rowFilter.faturamentos.id_contratos'];
          tipo?: parameters['rowFilter.faturamentos.tipo'];
          data_fatura?: parameters['rowFilter.faturamentos.data_fatura'];
          valor?: parameters['rowFilter.faturamentos.valor'];
          status?: parameters['rowFilter.faturamentos.status'];
          descricao?: parameters['rowFilter.faturamentos.descricao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['faturamentos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** faturamentos */
          faturamentos?: definitions['faturamentos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_faturamentos?: parameters['rowFilter.faturamentos.id_faturamentos'];
          id_tenants?: parameters['rowFilter.faturamentos.id_tenants'];
          id_contratos?: parameters['rowFilter.faturamentos.id_contratos'];
          tipo?: parameters['rowFilter.faturamentos.tipo'];
          data_fatura?: parameters['rowFilter.faturamentos.data_fatura'];
          valor?: parameters['rowFilter.faturamentos.valor'];
          status?: parameters['rowFilter.faturamentos.status'];
          descricao?: parameters['rowFilter.faturamentos.descricao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_faturamentos?: parameters['rowFilter.faturamentos.id_faturamentos'];
          id_tenants?: parameters['rowFilter.faturamentos.id_tenants'];
          id_contratos?: parameters['rowFilter.faturamentos.id_contratos'];
          tipo?: parameters['rowFilter.faturamentos.tipo'];
          data_fatura?: parameters['rowFilter.faturamentos.data_fatura'];
          valor?: parameters['rowFilter.faturamentos.valor'];
          status?: parameters['rowFilter.faturamentos.status'];
          descricao?: parameters['rowFilter.faturamentos.descricao'];
        };
        body: {
          /** faturamentos */
          faturamentos?: definitions['faturamentos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/referencias_geograficas': {
    get: {
      parameters: {
        query: {
          id_referencias_geograficas?: parameters['rowFilter.referencias_geograficas.id_referencias_geograficas'];
          srid?: parameters['rowFilter.referencias_geograficas.srid'];
          descricao?: parameters['rowFilter.referencias_geograficas.descricao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['referencias_geograficas'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** referencias_geograficas */
          referencias_geograficas?: definitions['referencias_geograficas'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_referencias_geograficas?: parameters['rowFilter.referencias_geograficas.id_referencias_geograficas'];
          srid?: parameters['rowFilter.referencias_geograficas.srid'];
          descricao?: parameters['rowFilter.referencias_geograficas.descricao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_referencias_geograficas?: parameters['rowFilter.referencias_geograficas.id_referencias_geograficas'];
          srid?: parameters['rowFilter.referencias_geograficas.srid'];
          descricao?: parameters['rowFilter.referencias_geograficas.descricao'];
        };
        body: {
          /** referencias_geograficas */
          referencias_geograficas?: definitions['referencias_geograficas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/importacoes_wms': {
    get: {
      parameters: {
        query: {
          id_importacoes_wms?: parameters['rowFilter.importacoes_wms.id_importacoes_wms'];
          link?: parameters['rowFilter.importacoes_wms.link'];
          id_projetos?: parameters['rowFilter.importacoes_wms.id_projetos'];
          nome?: parameters['rowFilter.importacoes_wms.nome'];
          bbox?: parameters['rowFilter.importacoes_wms.bbox'];
          url?: parameters['rowFilter.importacoes_wms.url'];
          params?: parameters['rowFilter.importacoes_wms.params'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['importacoes_wms'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** importacoes_wms */
          importacoes_wms?: definitions['importacoes_wms'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_importacoes_wms?: parameters['rowFilter.importacoes_wms.id_importacoes_wms'];
          link?: parameters['rowFilter.importacoes_wms.link'];
          id_projetos?: parameters['rowFilter.importacoes_wms.id_projetos'];
          nome?: parameters['rowFilter.importacoes_wms.nome'];
          bbox?: parameters['rowFilter.importacoes_wms.bbox'];
          url?: parameters['rowFilter.importacoes_wms.url'];
          params?: parameters['rowFilter.importacoes_wms.params'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_importacoes_wms?: parameters['rowFilter.importacoes_wms.id_importacoes_wms'];
          link?: parameters['rowFilter.importacoes_wms.link'];
          id_projetos?: parameters['rowFilter.importacoes_wms.id_projetos'];
          nome?: parameters['rowFilter.importacoes_wms.nome'];
          bbox?: parameters['rowFilter.importacoes_wms.bbox'];
          url?: parameters['rowFilter.importacoes_wms.url'];
          params?: parameters['rowFilter.importacoes_wms.params'];
        };
        body: {
          /** importacoes_wms */
          importacoes_wms?: definitions['importacoes_wms'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/auditoria_delete': {
    get: {
      parameters: {
        query: {
          id_auditoria_delete?: parameters['rowFilter.auditoria_delete.id_auditoria_delete'];
          id_projetos?: parameters['rowFilter.auditoria_delete.id_projetos'];
          id_usuarios?: parameters['rowFilter.auditoria_delete.id_usuarios'];
          aud_hora?: parameters['rowFilter.auditoria_delete.aud_hora'];
          informacao?: parameters['rowFilter.auditoria_delete.informacao'];
          id_generico?: parameters['rowFilter.auditoria_delete.id_generico'];
          middleware?: parameters['rowFilter.auditoria_delete.middleware'];
          uri?: parameters['rowFilter.auditoria_delete.uri'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['auditoria_delete'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** auditoria_delete */
          auditoria_delete?: definitions['auditoria_delete'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_auditoria_delete?: parameters['rowFilter.auditoria_delete.id_auditoria_delete'];
          id_projetos?: parameters['rowFilter.auditoria_delete.id_projetos'];
          id_usuarios?: parameters['rowFilter.auditoria_delete.id_usuarios'];
          aud_hora?: parameters['rowFilter.auditoria_delete.aud_hora'];
          informacao?: parameters['rowFilter.auditoria_delete.informacao'];
          id_generico?: parameters['rowFilter.auditoria_delete.id_generico'];
          middleware?: parameters['rowFilter.auditoria_delete.middleware'];
          uri?: parameters['rowFilter.auditoria_delete.uri'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_auditoria_delete?: parameters['rowFilter.auditoria_delete.id_auditoria_delete'];
          id_projetos?: parameters['rowFilter.auditoria_delete.id_projetos'];
          id_usuarios?: parameters['rowFilter.auditoria_delete.id_usuarios'];
          aud_hora?: parameters['rowFilter.auditoria_delete.aud_hora'];
          informacao?: parameters['rowFilter.auditoria_delete.informacao'];
          id_generico?: parameters['rowFilter.auditoria_delete.id_generico'];
          middleware?: parameters['rowFilter.auditoria_delete.middleware'];
          uri?: parameters['rowFilter.auditoria_delete.uri'];
        };
        body: {
          /** auditoria_delete */
          auditoria_delete?: definitions['auditoria_delete'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap_tema_especifico': {
    get: {
      parameters: {
        query: {
          id_wikimap_tema_especifico?: parameters['rowFilter.wikimap_tema_especifico.id_wikimap_tema_especifico'];
          tema?: parameters['rowFilter.wikimap_tema_especifico.tema'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap_tema_especifico'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap_tema_especifico */
          wikimap_tema_especifico?: definitions['wikimap_tema_especifico'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_wikimap_tema_especifico?: parameters['rowFilter.wikimap_tema_especifico.id_wikimap_tema_especifico'];
          tema?: parameters['rowFilter.wikimap_tema_especifico.tema'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_wikimap_tema_especifico?: parameters['rowFilter.wikimap_tema_especifico.id_wikimap_tema_especifico'];
          tema?: parameters['rowFilter.wikimap_tema_especifico.tema'];
        };
        body: {
          /** wikimap_tema_especifico */
          wikimap_tema_especifico?: definitions['wikimap_tema_especifico'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/osm_roads': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.osm_roads.gid'];
          osm_id?: parameters['rowFilter.osm_roads.osm_id'];
          code?: parameters['rowFilter.osm_roads.code'];
          fclass?: parameters['rowFilter.osm_roads.fclass'];
          name?: parameters['rowFilter.osm_roads.name'];
          ref?: parameters['rowFilter.osm_roads.ref'];
          oneway?: parameters['rowFilter.osm_roads.oneway'];
          maxspeed?: parameters['rowFilter.osm_roads.maxspeed'];
          layer?: parameters['rowFilter.osm_roads.layer'];
          bridge?: parameters['rowFilter.osm_roads.bridge'];
          tunnel?: parameters['rowFilter.osm_roads.tunnel'];
          geom?: parameters['rowFilter.osm_roads.geom'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['osm_roads'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** osm_roads */
          osm_roads?: definitions['osm_roads'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.osm_roads.gid'];
          osm_id?: parameters['rowFilter.osm_roads.osm_id'];
          code?: parameters['rowFilter.osm_roads.code'];
          fclass?: parameters['rowFilter.osm_roads.fclass'];
          name?: parameters['rowFilter.osm_roads.name'];
          ref?: parameters['rowFilter.osm_roads.ref'];
          oneway?: parameters['rowFilter.osm_roads.oneway'];
          maxspeed?: parameters['rowFilter.osm_roads.maxspeed'];
          layer?: parameters['rowFilter.osm_roads.layer'];
          bridge?: parameters['rowFilter.osm_roads.bridge'];
          tunnel?: parameters['rowFilter.osm_roads.tunnel'];
          geom?: parameters['rowFilter.osm_roads.geom'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.osm_roads.gid'];
          osm_id?: parameters['rowFilter.osm_roads.osm_id'];
          code?: parameters['rowFilter.osm_roads.code'];
          fclass?: parameters['rowFilter.osm_roads.fclass'];
          name?: parameters['rowFilter.osm_roads.name'];
          ref?: parameters['rowFilter.osm_roads.ref'];
          oneway?: parameters['rowFilter.osm_roads.oneway'];
          maxspeed?: parameters['rowFilter.osm_roads.maxspeed'];
          layer?: parameters['rowFilter.osm_roads.layer'];
          bridge?: parameters['rowFilter.osm_roads.bridge'];
          tunnel?: parameters['rowFilter.osm_roads.tunnel'];
          geom?: parameters['rowFilter.osm_roads.geom'];
        };
        body: {
          /** osm_roads */
          osm_roads?: definitions['osm_roads'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/empresas': {
    get: {
      parameters: {
        query: {
          id_empresas?: parameters['rowFilter.empresas.id_empresas'];
          id_tenants?: parameters['rowFilter.empresas.id_tenants'];
          nome?: parameters['rowFilter.empresas.nome'];
          tipo_pessoa?: parameters['rowFilter.empresas.tipo_pessoa'];
          cpf_cnpj?: parameters['rowFilter.empresas.cpf_cnpj'];
          telefone?: parameters['rowFilter.empresas.telefone'];
          id_segmentos?: parameters['rowFilter.empresas.id_segmentos'];
          endereco?: parameters['rowFilter.empresas.endereco'];
          cidade?: parameters['rowFilter.empresas.cidade'];
          bairro?: parameters['rowFilter.empresas.bairro'];
          complemento?: parameters['rowFilter.empresas.complemento'];
          cep?: parameters['rowFilter.empresas.cep'];
          uf?: parameters['rowFilter.empresas.uf'];
          logo?: parameters['rowFilter.empresas.logo'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['empresas'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** empresas */
          empresas?: definitions['empresas'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_empresas?: parameters['rowFilter.empresas.id_empresas'];
          id_tenants?: parameters['rowFilter.empresas.id_tenants'];
          nome?: parameters['rowFilter.empresas.nome'];
          tipo_pessoa?: parameters['rowFilter.empresas.tipo_pessoa'];
          cpf_cnpj?: parameters['rowFilter.empresas.cpf_cnpj'];
          telefone?: parameters['rowFilter.empresas.telefone'];
          id_segmentos?: parameters['rowFilter.empresas.id_segmentos'];
          endereco?: parameters['rowFilter.empresas.endereco'];
          cidade?: parameters['rowFilter.empresas.cidade'];
          bairro?: parameters['rowFilter.empresas.bairro'];
          complemento?: parameters['rowFilter.empresas.complemento'];
          cep?: parameters['rowFilter.empresas.cep'];
          uf?: parameters['rowFilter.empresas.uf'];
          logo?: parameters['rowFilter.empresas.logo'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_empresas?: parameters['rowFilter.empresas.id_empresas'];
          id_tenants?: parameters['rowFilter.empresas.id_tenants'];
          nome?: parameters['rowFilter.empresas.nome'];
          tipo_pessoa?: parameters['rowFilter.empresas.tipo_pessoa'];
          cpf_cnpj?: parameters['rowFilter.empresas.cpf_cnpj'];
          telefone?: parameters['rowFilter.empresas.telefone'];
          id_segmentos?: parameters['rowFilter.empresas.id_segmentos'];
          endereco?: parameters['rowFilter.empresas.endereco'];
          cidade?: parameters['rowFilter.empresas.cidade'];
          bairro?: parameters['rowFilter.empresas.bairro'];
          complemento?: parameters['rowFilter.empresas.complemento'];
          cep?: parameters['rowFilter.empresas.cep'];
          uf?: parameters['rowFilter.empresas.uf'];
          logo?: parameters['rowFilter.empresas.logo'];
        };
        body: {
          /** empresas */
          empresas?: definitions['empresas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_adicionais': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_adicionais?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos_camadas_adicionais'];
          id_projetos?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos_camadas'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_adicionais'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_adicionais */
          projetos_camadas_adicionais?: definitions['projetos_camadas_adicionais'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_camadas_adicionais?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos_camadas_adicionais'];
          id_projetos?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos_camadas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_camadas_adicionais?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos_camadas_adicionais'];
          id_projetos?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_adicionais.id_projetos_camadas'];
        };
        body: {
          /** projetos_camadas_adicionais */
          projetos_camadas_adicionais?: definitions['projetos_camadas_adicionais'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap_likes': {
    get: {
      parameters: {
        query: {
          id_likes_wikimap?: parameters['rowFilter.wikimap_likes.id_likes_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_likes.id_usuarios'];
          id_wikimap?: parameters['rowFilter.wikimap_likes.id_wikimap'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap_likes'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap_likes */
          wikimap_likes?: definitions['wikimap_likes'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_likes_wikimap?: parameters['rowFilter.wikimap_likes.id_likes_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_likes.id_usuarios'];
          id_wikimap?: parameters['rowFilter.wikimap_likes.id_wikimap'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_likes_wikimap?: parameters['rowFilter.wikimap_likes.id_likes_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_likes.id_usuarios'];
          id_wikimap?: parameters['rowFilter.wikimap_likes.id_wikimap'];
        };
        body: {
          /** wikimap_likes */
          wikimap_likes?: definitions['wikimap_likes'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/layouts': {
    get: {
      parameters: {
        query: {
          id_layout?: parameters['rowFilter.layouts.id_layout'];
          id_projeto?: parameters['rowFilter.layouts.id_projeto'];
          id_tenant?: parameters['rowFilter.layouts.id_tenant'];
          id_usuario?: parameters['rowFilter.layouts.id_usuario'];
          compartilhar?: parameters['rowFilter.layouts.compartilhar'];
          publico?: parameters['rowFilter.layouts.publico'];
          nome?: parameters['rowFilter.layouts.nome'];
          configuracao?: parameters['rowFilter.layouts.configuracao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['layouts'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** layouts */
          layouts?: definitions['layouts'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_layout?: parameters['rowFilter.layouts.id_layout'];
          id_projeto?: parameters['rowFilter.layouts.id_projeto'];
          id_tenant?: parameters['rowFilter.layouts.id_tenant'];
          id_usuario?: parameters['rowFilter.layouts.id_usuario'];
          compartilhar?: parameters['rowFilter.layouts.compartilhar'];
          publico?: parameters['rowFilter.layouts.publico'];
          nome?: parameters['rowFilter.layouts.nome'];
          configuracao?: parameters['rowFilter.layouts.configuracao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_layout?: parameters['rowFilter.layouts.id_layout'];
          id_projeto?: parameters['rowFilter.layouts.id_projeto'];
          id_tenant?: parameters['rowFilter.layouts.id_tenant'];
          id_usuario?: parameters['rowFilter.layouts.id_usuario'];
          compartilhar?: parameters['rowFilter.layouts.compartilhar'];
          publico?: parameters['rowFilter.layouts.publico'];
          nome?: parameters['rowFilter.layouts.nome'];
          configuracao?: parameters['rowFilter.layouts.configuracao'];
        };
        body: {
          /** layouts */
          layouts?: definitions['layouts'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/variogramas': {
    get: {
      parameters: {
        query: {
          id_variogramas?: parameters['rowFilter.variogramas.id_variogramas'];
          id_camadas?: parameters['rowFilter.variogramas.id_camadas'];
          nome?: parameters['rowFilter.variogramas.nome'];
          nugg?: parameters['rowFilter.variogramas.nugg'];
          rang?: parameters['rowFilter.variogramas.rang'];
          psil?: parameters['rowFilter.variogramas.psil'];
          url?: parameters['rowFilter.variogramas.url'];
          automatico?: parameters['rowFilter.variogramas.automatico'];
          log?: parameters['rowFilter.variogramas.log'];
          id_campo_vm2?: parameters['rowFilter.variogramas.id_campo_vm2'];
          id_campo_chk?: parameters['rowFilter.variogramas.id_campo_chk'];
          id_projetos?: parameters['rowFilter.variogramas.id_projetos'];
          zonas_ignorar?: parameters['rowFilter.variogramas.zonas_ignorar'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['variogramas'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** variogramas */
          variogramas?: definitions['variogramas'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_variogramas?: parameters['rowFilter.variogramas.id_variogramas'];
          id_camadas?: parameters['rowFilter.variogramas.id_camadas'];
          nome?: parameters['rowFilter.variogramas.nome'];
          nugg?: parameters['rowFilter.variogramas.nugg'];
          rang?: parameters['rowFilter.variogramas.rang'];
          psil?: parameters['rowFilter.variogramas.psil'];
          url?: parameters['rowFilter.variogramas.url'];
          automatico?: parameters['rowFilter.variogramas.automatico'];
          log?: parameters['rowFilter.variogramas.log'];
          id_campo_vm2?: parameters['rowFilter.variogramas.id_campo_vm2'];
          id_campo_chk?: parameters['rowFilter.variogramas.id_campo_chk'];
          id_projetos?: parameters['rowFilter.variogramas.id_projetos'];
          zonas_ignorar?: parameters['rowFilter.variogramas.zonas_ignorar'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_variogramas?: parameters['rowFilter.variogramas.id_variogramas'];
          id_camadas?: parameters['rowFilter.variogramas.id_camadas'];
          nome?: parameters['rowFilter.variogramas.nome'];
          nugg?: parameters['rowFilter.variogramas.nugg'];
          rang?: parameters['rowFilter.variogramas.rang'];
          psil?: parameters['rowFilter.variogramas.psil'];
          url?: parameters['rowFilter.variogramas.url'];
          automatico?: parameters['rowFilter.variogramas.automatico'];
          log?: parameters['rowFilter.variogramas.log'];
          id_campo_vm2?: parameters['rowFilter.variogramas.id_campo_vm2'];
          id_campo_chk?: parameters['rowFilter.variogramas.id_campo_chk'];
          id_projetos?: parameters['rowFilter.variogramas.id_projetos'];
          zonas_ignorar?: parameters['rowFilter.variogramas.zonas_ignorar'];
        };
        body: {
          /** variogramas */
          variogramas?: definitions['variogramas'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/modelos_variograma': {
    get: {
      parameters: {
        query: {
          id_modelos_variograma?: parameters['rowFilter.modelos_variograma.id_modelos_variograma'];
          id_projetos?: parameters['rowFilter.modelos_variograma.id_projetos'];
          nome_modelo?: parameters['rowFilter.modelos_variograma.nome_modelo'];
          chave?: parameters['rowFilter.modelos_variograma.chave'];
          valor?: parameters['rowFilter.modelos_variograma.valor'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['modelos_variograma'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** modelos_variograma */
          modelos_variograma?: definitions['modelos_variograma'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_modelos_variograma?: parameters['rowFilter.modelos_variograma.id_modelos_variograma'];
          id_projetos?: parameters['rowFilter.modelos_variograma.id_projetos'];
          nome_modelo?: parameters['rowFilter.modelos_variograma.nome_modelo'];
          chave?: parameters['rowFilter.modelos_variograma.chave'];
          valor?: parameters['rowFilter.modelos_variograma.valor'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_modelos_variograma?: parameters['rowFilter.modelos_variograma.id_modelos_variograma'];
          id_projetos?: parameters['rowFilter.modelos_variograma.id_projetos'];
          nome_modelo?: parameters['rowFilter.modelos_variograma.nome_modelo'];
          chave?: parameters['rowFilter.modelos_variograma.chave'];
          valor?: parameters['rowFilter.modelos_variograma.valor'];
        };
        body: {
          /** modelos_variograma */
          modelos_variograma?: definitions['modelos_variograma'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/amostras_apartamentos_raspagem': {
    get: {
      parameters: {
        query: {
          id_amostras_apartamentos_raspagem?: parameters['rowFilter.amostras_apartamentos_raspagem.id_amostras_apartamentos_raspagem'];
          vm2?: parameters['rowFilter.amostras_apartamentos_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_apartamentos_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_apartamentos_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_apartamentos_raspagem.x'];
          y?: parameters['rowFilter.amostras_apartamentos_raspagem.y'];
          site?: parameters['rowFilter.amostras_apartamentos_raspagem.site'];
          preco?: parameters['rowFilter.amostras_apartamentos_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_apartamentos_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_apartamentos_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_apartamentos_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_apartamentos_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_apartamentos_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_apartamentos_raspagem.estado'];
          area_util?: parameters['rowFilter.amostras_apartamentos_raspagem.area_util'];
          data_insercao?: parameters['rowFilter.amostras_apartamentos_raspagem.data_insercao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['amostras_apartamentos_raspagem'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** amostras_apartamentos_raspagem */
          amostras_apartamentos_raspagem?: definitions['amostras_apartamentos_raspagem'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_amostras_apartamentos_raspagem?: parameters['rowFilter.amostras_apartamentos_raspagem.id_amostras_apartamentos_raspagem'];
          vm2?: parameters['rowFilter.amostras_apartamentos_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_apartamentos_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_apartamentos_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_apartamentos_raspagem.x'];
          y?: parameters['rowFilter.amostras_apartamentos_raspagem.y'];
          site?: parameters['rowFilter.amostras_apartamentos_raspagem.site'];
          preco?: parameters['rowFilter.amostras_apartamentos_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_apartamentos_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_apartamentos_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_apartamentos_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_apartamentos_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_apartamentos_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_apartamentos_raspagem.estado'];
          area_util?: parameters['rowFilter.amostras_apartamentos_raspagem.area_util'];
          data_insercao?: parameters['rowFilter.amostras_apartamentos_raspagem.data_insercao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_amostras_apartamentos_raspagem?: parameters['rowFilter.amostras_apartamentos_raspagem.id_amostras_apartamentos_raspagem'];
          vm2?: parameters['rowFilter.amostras_apartamentos_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_apartamentos_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_apartamentos_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_apartamentos_raspagem.x'];
          y?: parameters['rowFilter.amostras_apartamentos_raspagem.y'];
          site?: parameters['rowFilter.amostras_apartamentos_raspagem.site'];
          preco?: parameters['rowFilter.amostras_apartamentos_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_apartamentos_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_apartamentos_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_apartamentos_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_apartamentos_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_apartamentos_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_apartamentos_raspagem.estado'];
          area_util?: parameters['rowFilter.amostras_apartamentos_raspagem.area_util'];
          data_insercao?: parameters['rowFilter.amostras_apartamentos_raspagem.data_insercao'];
        };
        body: {
          /** amostras_apartamentos_raspagem */
          amostras_apartamentos_raspagem?: definitions['amostras_apartamentos_raspagem'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_geometrias_arquivos': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_geometrias_arquivos?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias_arquivos'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias'];
          id_projetos?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos'];
          url_s3?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.url_s3'];
          tipo?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.tipo'];
          file_size?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.file_size'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_id_modificado_por'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_geometrias_arquivos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_geometrias_arquivos */
          projetos_camadas_geometrias_arquivos?: definitions['projetos_camadas_geometrias_arquivos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_camadas_geometrias_arquivos?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias_arquivos'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias'];
          id_projetos?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos'];
          url_s3?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.url_s3'];
          tipo?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.tipo'];
          file_size?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.file_size'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_id_modificado_por'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_camadas_geometrias_arquivos?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias_arquivos'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias'];
          id_projetos?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.id_projetos'];
          url_s3?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.url_s3'];
          tipo?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.tipo'];
          file_size?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.file_size'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_geometrias_arquivos.aud_id_modificado_por'];
        };
        body: {
          /** projetos_camadas_geometrias_arquivos */
          projetos_camadas_geometrias_arquivos?: definitions['projetos_camadas_geometrias_arquivos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/importacoes_dxf': {
    get: {
      parameters: {
        query: {
          id_importacoes_dxf?: parameters['rowFilter.importacoes_dxf.id_importacoes_dxf'];
          nome?: parameters['rowFilter.importacoes_dxf.nome'];
          conteudo?: parameters['rowFilter.importacoes_dxf.conteudo'];
          id_projetos?: parameters['rowFilter.importacoes_dxf.id_projetos'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['importacoes_dxf'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** importacoes_dxf */
          importacoes_dxf?: definitions['importacoes_dxf'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_importacoes_dxf?: parameters['rowFilter.importacoes_dxf.id_importacoes_dxf'];
          nome?: parameters['rowFilter.importacoes_dxf.nome'];
          conteudo?: parameters['rowFilter.importacoes_dxf.conteudo'];
          id_projetos?: parameters['rowFilter.importacoes_dxf.id_projetos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_importacoes_dxf?: parameters['rowFilter.importacoes_dxf.id_importacoes_dxf'];
          nome?: parameters['rowFilter.importacoes_dxf.nome'];
          conteudo?: parameters['rowFilter.importacoes_dxf.conteudo'];
          id_projetos?: parameters['rowFilter.importacoes_dxf.id_projetos'];
        };
        body: {
          /** importacoes_dxf */
          importacoes_dxf?: definitions['importacoes_dxf'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap_tema_geral': {
    get: {
      parameters: {
        query: {
          id_wikimap_tema_geral?: parameters['rowFilter.wikimap_tema_geral.id_wikimap_tema_geral'];
          tema?: parameters['rowFilter.wikimap_tema_geral.tema'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap_tema_geral'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap_tema_geral */
          wikimap_tema_geral?: definitions['wikimap_tema_geral'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_wikimap_tema_geral?: parameters['rowFilter.wikimap_tema_geral.id_wikimap_tema_geral'];
          tema?: parameters['rowFilter.wikimap_tema_geral.tema'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_wikimap_tema_geral?: parameters['rowFilter.wikimap_tema_geral.id_wikimap_tema_geral'];
          tema?: parameters['rowFilter.wikimap_tema_geral.tema'];
        };
        body: {
          /** wikimap_tema_geral */
          wikimap_tema_geral?: definitions['wikimap_tema_geral'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_arquivos': {
    get: {
      parameters: {
        query: {
          id_projetos_arquivos?: parameters['rowFilter.projetos_arquivos.id_projetos_arquivos'];
          id_projetos?: parameters['rowFilter.projetos_arquivos.id_projetos'];
          url_s3?: parameters['rowFilter.projetos_arquivos.url_s3'];
          tipo?: parameters['rowFilter.projetos_arquivos.tipo'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_arquivos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_arquivos */
          projetos_arquivos?: definitions['projetos_arquivos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_arquivos?: parameters['rowFilter.projetos_arquivos.id_projetos_arquivos'];
          id_projetos?: parameters['rowFilter.projetos_arquivos.id_projetos'];
          url_s3?: parameters['rowFilter.projetos_arquivos.url_s3'];
          tipo?: parameters['rowFilter.projetos_arquivos.tipo'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_arquivos?: parameters['rowFilter.projetos_arquivos.id_projetos_arquivos'];
          id_projetos?: parameters['rowFilter.projetos_arquivos.id_projetos'];
          url_s3?: parameters['rowFilter.projetos_arquivos.url_s3'];
          tipo?: parameters['rowFilter.projetos_arquivos.tipo'];
        };
        body: {
          /** projetos_arquivos */
          projetos_arquivos?: definitions['projetos_arquivos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/amostras_salas_raspagem': {
    get: {
      parameters: {
        query: {
          id_amostras_salas_raspagem?: parameters['rowFilter.amostras_salas_raspagem.id_amostras_salas_raspagem'];
          vm2?: parameters['rowFilter.amostras_salas_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_salas_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_salas_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_salas_raspagem.x'];
          y?: parameters['rowFilter.amostras_salas_raspagem.y'];
          site?: parameters['rowFilter.amostras_salas_raspagem.site'];
          preco?: parameters['rowFilter.amostras_salas_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_salas_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_salas_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_salas_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_salas_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_salas_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_salas_raspagem.estado'];
          area_util?: parameters['rowFilter.amostras_salas_raspagem.area_util'];
          data_insercao?: parameters['rowFilter.amostras_salas_raspagem.data_insercao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['amostras_salas_raspagem'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** amostras_salas_raspagem */
          amostras_salas_raspagem?: definitions['amostras_salas_raspagem'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_amostras_salas_raspagem?: parameters['rowFilter.amostras_salas_raspagem.id_amostras_salas_raspagem'];
          vm2?: parameters['rowFilter.amostras_salas_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_salas_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_salas_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_salas_raspagem.x'];
          y?: parameters['rowFilter.amostras_salas_raspagem.y'];
          site?: parameters['rowFilter.amostras_salas_raspagem.site'];
          preco?: parameters['rowFilter.amostras_salas_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_salas_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_salas_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_salas_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_salas_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_salas_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_salas_raspagem.estado'];
          area_util?: parameters['rowFilter.amostras_salas_raspagem.area_util'];
          data_insercao?: parameters['rowFilter.amostras_salas_raspagem.data_insercao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_amostras_salas_raspagem?: parameters['rowFilter.amostras_salas_raspagem.id_amostras_salas_raspagem'];
          vm2?: parameters['rowFilter.amostras_salas_raspagem.vm2'];
          geom?: parameters['rowFilter.amostras_salas_raspagem.geom'];
          imagem?: parameters['rowFilter.amostras_salas_raspagem.imagem'];
          x?: parameters['rowFilter.amostras_salas_raspagem.x'];
          y?: parameters['rowFilter.amostras_salas_raspagem.y'];
          site?: parameters['rowFilter.amostras_salas_raspagem.site'];
          preco?: parameters['rowFilter.amostras_salas_raspagem.preco'];
          tamanho?: parameters['rowFilter.amostras_salas_raspagem.tamanho'];
          cep?: parameters['rowFilter.amostras_salas_raspagem.cep'];
          muni?: parameters['rowFilter.amostras_salas_raspagem.muni'];
          bairro?: parameters['rowFilter.amostras_salas_raspagem.bairro'];
          rua?: parameters['rowFilter.amostras_salas_raspagem.rua'];
          estado?: parameters['rowFilter.amostras_salas_raspagem.estado'];
          area_util?: parameters['rowFilter.amostras_salas_raspagem.area_util'];
          data_insercao?: parameters['rowFilter.amostras_salas_raspagem.data_insercao'];
        };
        body: {
          /** amostras_salas_raspagem */
          amostras_salas_raspagem?: definitions['amostras_salas_raspagem'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_geometrias': {
    get: {
      parameters: {
        query: {
          geom?: parameters['rowFilter.projetos_camadas_geometrias.geom'];
          data_criacao?: parameters['rowFilter.projetos_camadas_geometrias.data_criacao'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos_camadas_geometrias'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos_camadas'];
          id_projetos?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos'];
          seq?: parameters['rowFilter.projetos_camadas_geometrias.seq'];
          geom_wkt?: parameters['rowFilter.projetos_camadas_geometrias.geom_wkt'];
          rotulo?: parameters['rowFilter.projetos_camadas_geometrias.rotulo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_geometrias.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_geometrias.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_geometrias.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_geometrias.aud_id_modificado_por'];
          categoria_mapa_tematico?: parameters['rowFilter.projetos_camadas_geometrias.categoria_mapa_tematico'];
          tem_foto?: parameters['rowFilter.projetos_camadas_geometrias.tem_foto'];
          indexmapatematico?: parameters['rowFilter.projetos_camadas_geometrias.indexmapatematico'];
          aud_raspado?: parameters['rowFilter.projetos_camadas_geometrias.aud_raspado'];
          foto?: parameters['rowFilter.projetos_camadas_geometrias.foto'];
          icadvinculado?: parameters['rowFilter.projetos_camadas_geometrias.icadvinculado'];
          icad_vinculado?: parameters['rowFilter.projetos_camadas_geometrias.icad_vinculado'];
          rotulo_rotacao?: parameters['rowFilter.projetos_camadas_geometrias.rotulo_rotacao'];
          campo_auxiliar?: parameters['rowFilter.projetos_camadas_geometrias.campo_auxiliar'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_geometrias'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_geometrias */
          projetos_camadas_geometrias?: definitions['projetos_camadas_geometrias'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          geom?: parameters['rowFilter.projetos_camadas_geometrias.geom'];
          data_criacao?: parameters['rowFilter.projetos_camadas_geometrias.data_criacao'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos_camadas_geometrias'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos_camadas'];
          id_projetos?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos'];
          seq?: parameters['rowFilter.projetos_camadas_geometrias.seq'];
          geom_wkt?: parameters['rowFilter.projetos_camadas_geometrias.geom_wkt'];
          rotulo?: parameters['rowFilter.projetos_camadas_geometrias.rotulo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_geometrias.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_geometrias.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_geometrias.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_geometrias.aud_id_modificado_por'];
          categoria_mapa_tematico?: parameters['rowFilter.projetos_camadas_geometrias.categoria_mapa_tematico'];
          tem_foto?: parameters['rowFilter.projetos_camadas_geometrias.tem_foto'];
          indexmapatematico?: parameters['rowFilter.projetos_camadas_geometrias.indexmapatematico'];
          aud_raspado?: parameters['rowFilter.projetos_camadas_geometrias.aud_raspado'];
          foto?: parameters['rowFilter.projetos_camadas_geometrias.foto'];
          icadvinculado?: parameters['rowFilter.projetos_camadas_geometrias.icadvinculado'];
          icad_vinculado?: parameters['rowFilter.projetos_camadas_geometrias.icad_vinculado'];
          rotulo_rotacao?: parameters['rowFilter.projetos_camadas_geometrias.rotulo_rotacao'];
          campo_auxiliar?: parameters['rowFilter.projetos_camadas_geometrias.campo_auxiliar'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          geom?: parameters['rowFilter.projetos_camadas_geometrias.geom'];
          data_criacao?: parameters['rowFilter.projetos_camadas_geometrias.data_criacao'];
          id_projetos_camadas_geometrias?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos_camadas_geometrias'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos_camadas'];
          id_projetos?: parameters['rowFilter.projetos_camadas_geometrias.id_projetos'];
          seq?: parameters['rowFilter.projetos_camadas_geometrias.seq'];
          geom_wkt?: parameters['rowFilter.projetos_camadas_geometrias.geom_wkt'];
          rotulo?: parameters['rowFilter.projetos_camadas_geometrias.rotulo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_geometrias.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_geometrias.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_geometrias.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_geometrias.aud_id_modificado_por'];
          categoria_mapa_tematico?: parameters['rowFilter.projetos_camadas_geometrias.categoria_mapa_tematico'];
          tem_foto?: parameters['rowFilter.projetos_camadas_geometrias.tem_foto'];
          indexmapatematico?: parameters['rowFilter.projetos_camadas_geometrias.indexmapatematico'];
          aud_raspado?: parameters['rowFilter.projetos_camadas_geometrias.aud_raspado'];
          foto?: parameters['rowFilter.projetos_camadas_geometrias.foto'];
          icadvinculado?: parameters['rowFilter.projetos_camadas_geometrias.icadvinculado'];
          icad_vinculado?: parameters['rowFilter.projetos_camadas_geometrias.icad_vinculado'];
          rotulo_rotacao?: parameters['rowFilter.projetos_camadas_geometrias.rotulo_rotacao'];
          campo_auxiliar?: parameters['rowFilter.projetos_camadas_geometrias.campo_auxiliar'];
        };
        body: {
          /** projetos_camadas_geometrias */
          projetos_camadas_geometrias?: definitions['projetos_camadas_geometrias'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_formularios': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_formularios?: parameters['rowFilter.projetos_camadas_formularios.id_projetos_camadas_formularios'];
          nome?: parameters['rowFilter.projetos_camadas_formularios.nome'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_formularios.id_projetos_camadas'];
          id_projetos?: parameters['rowFilter.projetos_camadas_formularios.id_projetos'];
          ativo?: parameters['rowFilter.projetos_camadas_formularios.ativo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_formularios.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_formularios.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_formularios.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_formularios.aud_id_modificado_por'];
          representacao?: parameters['rowFilter.projetos_camadas_formularios.representacao'];
          tbl_valor_db?: parameters['rowFilter.projetos_camadas_formularios.tbl_valor_db'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_formularios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_formularios */
          projetos_camadas_formularios?: definitions['projetos_camadas_formularios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_camadas_formularios?: parameters['rowFilter.projetos_camadas_formularios.id_projetos_camadas_formularios'];
          nome?: parameters['rowFilter.projetos_camadas_formularios.nome'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_formularios.id_projetos_camadas'];
          id_projetos?: parameters['rowFilter.projetos_camadas_formularios.id_projetos'];
          ativo?: parameters['rowFilter.projetos_camadas_formularios.ativo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_formularios.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_formularios.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_formularios.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_formularios.aud_id_modificado_por'];
          representacao?: parameters['rowFilter.projetos_camadas_formularios.representacao'];
          tbl_valor_db?: parameters['rowFilter.projetos_camadas_formularios.tbl_valor_db'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_camadas_formularios?: parameters['rowFilter.projetos_camadas_formularios.id_projetos_camadas_formularios'];
          nome?: parameters['rowFilter.projetos_camadas_formularios.nome'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_formularios.id_projetos_camadas'];
          id_projetos?: parameters['rowFilter.projetos_camadas_formularios.id_projetos'];
          ativo?: parameters['rowFilter.projetos_camadas_formularios.ativo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_formularios.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_formularios.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_formularios.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_formularios.aud_id_modificado_por'];
          representacao?: parameters['rowFilter.projetos_camadas_formularios.representacao'];
          tbl_valor_db?: parameters['rowFilter.projetos_camadas_formularios.tbl_valor_db'];
        };
        body: {
          /** projetos_camadas_formularios */
          projetos_camadas_formularios?: definitions['projetos_camadas_formularios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/municipios_ibge': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.municipios_ibge.gid'];
          nm_municip?: parameters['rowFilter.municipios_ibge.nm_municip'];
          cd_geocmu?: parameters['rowFilter.municipios_ibge.cd_geocmu'];
          geom?: parameters['rowFilter.municipios_ibge.geom'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['municipios_ibge'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** municipios_ibge */
          municipios_ibge?: definitions['municipios_ibge'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.municipios_ibge.gid'];
          nm_municip?: parameters['rowFilter.municipios_ibge.nm_municip'];
          cd_geocmu?: parameters['rowFilter.municipios_ibge.cd_geocmu'];
          geom?: parameters['rowFilter.municipios_ibge.geom'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.municipios_ibge.gid'];
          nm_municip?: parameters['rowFilter.municipios_ibge.nm_municip'];
          cd_geocmu?: parameters['rowFilter.municipios_ibge.cd_geocmu'];
          geom?: parameters['rowFilter.municipios_ibge.geom'];
        };
        body: {
          /** municipios_ibge */
          municipios_ibge?: definitions['municipios_ibge'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/criciuma_observacoes': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_geometrias?: parameters['rowFilter.criciuma_observacoes.id_projetos_camadas_geometrias'];
          geom?: parameters['rowFilter.criciuma_observacoes.geom'];
          obser?: parameters['rowFilter.criciuma_observacoes.obser'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['criciuma_observacoes'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
  };
  '/sul_roads_refactorr': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads_refactorr.gid'];
          osm_id?: parameters['rowFilter.sul_roads_refactorr.osm_id'];
          code?: parameters['rowFilter.sul_roads_refactorr.code'];
          fclass?: parameters['rowFilter.sul_roads_refactorr.fclass'];
          name?: parameters['rowFilter.sul_roads_refactorr.name'];
          ref?: parameters['rowFilter.sul_roads_refactorr.ref'];
          oneway?: parameters['rowFilter.sul_roads_refactorr.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads_refactorr.maxspeed'];
          layer?: parameters['rowFilter.sul_roads_refactorr.layer'];
          bridge?: parameters['rowFilter.sul_roads_refactorr.bridge'];
          tunnel?: parameters['rowFilter.sul_roads_refactorr.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads_refactorr.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads_refactorr.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads_refactorr.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads_refactorr.geom'];
          fator?: parameters['rowFilter.sul_roads_refactorr.fator'];
          geomhelper?: parameters['rowFilter.sul_roads_refactorr.geomhelper'];
          geom_dump?: parameters['rowFilter.sul_roads_refactorr.geom_dump'];
          simple_geom?: parameters['rowFilter.sul_roads_refactorr.simple_geom'];
          path?: parameters['rowFilter.sul_roads_refactorr.path'];
          geom_type?: parameters['rowFilter.sul_roads_refactorr.geom_type'];
          geom_wkt?: parameters['rowFilter.sul_roads_refactorr.geom_wkt'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['sul_roads_refactorr'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** sul_roads_refactorr */
          sul_roads_refactorr?: definitions['sul_roads_refactorr'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads_refactorr.gid'];
          osm_id?: parameters['rowFilter.sul_roads_refactorr.osm_id'];
          code?: parameters['rowFilter.sul_roads_refactorr.code'];
          fclass?: parameters['rowFilter.sul_roads_refactorr.fclass'];
          name?: parameters['rowFilter.sul_roads_refactorr.name'];
          ref?: parameters['rowFilter.sul_roads_refactorr.ref'];
          oneway?: parameters['rowFilter.sul_roads_refactorr.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads_refactorr.maxspeed'];
          layer?: parameters['rowFilter.sul_roads_refactorr.layer'];
          bridge?: parameters['rowFilter.sul_roads_refactorr.bridge'];
          tunnel?: parameters['rowFilter.sul_roads_refactorr.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads_refactorr.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads_refactorr.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads_refactorr.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads_refactorr.geom'];
          fator?: parameters['rowFilter.sul_roads_refactorr.fator'];
          geomhelper?: parameters['rowFilter.sul_roads_refactorr.geomhelper'];
          geom_dump?: parameters['rowFilter.sul_roads_refactorr.geom_dump'];
          simple_geom?: parameters['rowFilter.sul_roads_refactorr.simple_geom'];
          path?: parameters['rowFilter.sul_roads_refactorr.path'];
          geom_type?: parameters['rowFilter.sul_roads_refactorr.geom_type'];
          geom_wkt?: parameters['rowFilter.sul_roads_refactorr.geom_wkt'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads_refactorr.gid'];
          osm_id?: parameters['rowFilter.sul_roads_refactorr.osm_id'];
          code?: parameters['rowFilter.sul_roads_refactorr.code'];
          fclass?: parameters['rowFilter.sul_roads_refactorr.fclass'];
          name?: parameters['rowFilter.sul_roads_refactorr.name'];
          ref?: parameters['rowFilter.sul_roads_refactorr.ref'];
          oneway?: parameters['rowFilter.sul_roads_refactorr.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads_refactorr.maxspeed'];
          layer?: parameters['rowFilter.sul_roads_refactorr.layer'];
          bridge?: parameters['rowFilter.sul_roads_refactorr.bridge'];
          tunnel?: parameters['rowFilter.sul_roads_refactorr.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads_refactorr.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads_refactorr.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads_refactorr.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads_refactorr.geom'];
          fator?: parameters['rowFilter.sul_roads_refactorr.fator'];
          geomhelper?: parameters['rowFilter.sul_roads_refactorr.geomhelper'];
          geom_dump?: parameters['rowFilter.sul_roads_refactorr.geom_dump'];
          simple_geom?: parameters['rowFilter.sul_roads_refactorr.simple_geom'];
          path?: parameters['rowFilter.sul_roads_refactorr.path'];
          geom_type?: parameters['rowFilter.sul_roads_refactorr.geom_type'];
          geom_wkt?: parameters['rowFilter.sul_roads_refactorr.geom_wkt'];
        };
        body: {
          /** sul_roads_refactorr */
          sul_roads_refactorr?: definitions['sul_roads_refactorr'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/setores_rss': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_rss.gid'];
          id?: parameters['rowFilter.setores_rss.id'];
          cd_geocodi?: parameters['rowFilter.setores_rss.cd_geocodi'];
          tipo?: parameters['rowFilter.setores_rss.tipo'];
          cd_geocodb?: parameters['rowFilter.setores_rss.cd_geocodb'];
          nm_bairro?: parameters['rowFilter.setores_rss.nm_bairro'];
          cd_geocods?: parameters['rowFilter.setores_rss.cd_geocods'];
          nm_subdist?: parameters['rowFilter.setores_rss.nm_subdist'];
          cd_geocodd?: parameters['rowFilter.setores_rss.cd_geocodd'];
          nm_distrit?: parameters['rowFilter.setores_rss.nm_distrit'];
          cd_geocodm?: parameters['rowFilter.setores_rss.cd_geocodm'];
          nm_municip?: parameters['rowFilter.setores_rss.nm_municip'];
          nm_micro?: parameters['rowFilter.setores_rss.nm_micro'];
          nm_meso?: parameters['rowFilter.setores_rss.nm_meso'];
          geom?: parameters['rowFilter.setores_rss.geom'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['setores_rss'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** setores_rss */
          setores_rss?: definitions['setores_rss'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_rss.gid'];
          id?: parameters['rowFilter.setores_rss.id'];
          cd_geocodi?: parameters['rowFilter.setores_rss.cd_geocodi'];
          tipo?: parameters['rowFilter.setores_rss.tipo'];
          cd_geocodb?: parameters['rowFilter.setores_rss.cd_geocodb'];
          nm_bairro?: parameters['rowFilter.setores_rss.nm_bairro'];
          cd_geocods?: parameters['rowFilter.setores_rss.cd_geocods'];
          nm_subdist?: parameters['rowFilter.setores_rss.nm_subdist'];
          cd_geocodd?: parameters['rowFilter.setores_rss.cd_geocodd'];
          nm_distrit?: parameters['rowFilter.setores_rss.nm_distrit'];
          cd_geocodm?: parameters['rowFilter.setores_rss.cd_geocodm'];
          nm_municip?: parameters['rowFilter.setores_rss.nm_municip'];
          nm_micro?: parameters['rowFilter.setores_rss.nm_micro'];
          nm_meso?: parameters['rowFilter.setores_rss.nm_meso'];
          geom?: parameters['rowFilter.setores_rss.geom'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_rss.gid'];
          id?: parameters['rowFilter.setores_rss.id'];
          cd_geocodi?: parameters['rowFilter.setores_rss.cd_geocodi'];
          tipo?: parameters['rowFilter.setores_rss.tipo'];
          cd_geocodb?: parameters['rowFilter.setores_rss.cd_geocodb'];
          nm_bairro?: parameters['rowFilter.setores_rss.nm_bairro'];
          cd_geocods?: parameters['rowFilter.setores_rss.cd_geocods'];
          nm_subdist?: parameters['rowFilter.setores_rss.nm_subdist'];
          cd_geocodd?: parameters['rowFilter.setores_rss.cd_geocodd'];
          nm_distrit?: parameters['rowFilter.setores_rss.nm_distrit'];
          cd_geocodm?: parameters['rowFilter.setores_rss.cd_geocodm'];
          nm_municip?: parameters['rowFilter.setores_rss.nm_municip'];
          nm_micro?: parameters['rowFilter.setores_rss.nm_micro'];
          nm_meso?: parameters['rowFilter.setores_rss.nm_meso'];
          geom?: parameters['rowFilter.setores_rss.geom'];
        };
        body: {
          /** setores_rss */
          setores_rss?: definitions['setores_rss'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_relatorios': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_relatorios?: parameters['rowFilter.projetos_camadas_relatorios.id_projetos_camadas_relatorios'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_relatorios.id_projetos_camadas'];
          nome?: parameters['rowFilter.projetos_camadas_relatorios.nome'];
          estrutura?: parameters['rowFilter.projetos_camadas_relatorios.estrutura'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_relatorios.aud_criado_data'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_relatorios.aud_modificado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_relatorios.aud_id_criado_por'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_relatorios.aud_id_modificado_por'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_relatorios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_relatorios */
          projetos_camadas_relatorios?: definitions['projetos_camadas_relatorios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_camadas_relatorios?: parameters['rowFilter.projetos_camadas_relatorios.id_projetos_camadas_relatorios'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_relatorios.id_projetos_camadas'];
          nome?: parameters['rowFilter.projetos_camadas_relatorios.nome'];
          estrutura?: parameters['rowFilter.projetos_camadas_relatorios.estrutura'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_relatorios.aud_criado_data'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_relatorios.aud_modificado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_relatorios.aud_id_criado_por'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_relatorios.aud_id_modificado_por'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_camadas_relatorios?: parameters['rowFilter.projetos_camadas_relatorios.id_projetos_camadas_relatorios'];
          id_projetos_camadas?: parameters['rowFilter.projetos_camadas_relatorios.id_projetos_camadas'];
          nome?: parameters['rowFilter.projetos_camadas_relatorios.nome'];
          estrutura?: parameters['rowFilter.projetos_camadas_relatorios.estrutura'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_relatorios.aud_criado_data'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_relatorios.aud_modificado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_relatorios.aud_id_criado_por'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_relatorios.aud_id_modificado_por'];
        };
        body: {
          /** projetos_camadas_relatorios */
          projetos_camadas_relatorios?: definitions['projetos_camadas_relatorios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/sul_roads': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads.gid'];
          osm_id?: parameters['rowFilter.sul_roads.osm_id'];
          code?: parameters['rowFilter.sul_roads.code'];
          fclass?: parameters['rowFilter.sul_roads.fclass'];
          name?: parameters['rowFilter.sul_roads.name'];
          ref?: parameters['rowFilter.sul_roads.ref'];
          oneway?: parameters['rowFilter.sul_roads.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads.maxspeed'];
          layer?: parameters['rowFilter.sul_roads.layer'];
          bridge?: parameters['rowFilter.sul_roads.bridge'];
          tunnel?: parameters['rowFilter.sul_roads.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads.geom'];
          fator?: parameters['rowFilter.sul_roads.fator'];
          geomhelper?: parameters['rowFilter.sul_roads.geomhelper'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['sul_roads'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** sul_roads */
          sul_roads?: definitions['sul_roads'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads.gid'];
          osm_id?: parameters['rowFilter.sul_roads.osm_id'];
          code?: parameters['rowFilter.sul_roads.code'];
          fclass?: parameters['rowFilter.sul_roads.fclass'];
          name?: parameters['rowFilter.sul_roads.name'];
          ref?: parameters['rowFilter.sul_roads.ref'];
          oneway?: parameters['rowFilter.sul_roads.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads.maxspeed'];
          layer?: parameters['rowFilter.sul_roads.layer'];
          bridge?: parameters['rowFilter.sul_roads.bridge'];
          tunnel?: parameters['rowFilter.sul_roads.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads.geom'];
          fator?: parameters['rowFilter.sul_roads.fator'];
          geomhelper?: parameters['rowFilter.sul_roads.geomhelper'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.sul_roads.gid'];
          osm_id?: parameters['rowFilter.sul_roads.osm_id'];
          code?: parameters['rowFilter.sul_roads.code'];
          fclass?: parameters['rowFilter.sul_roads.fclass'];
          name?: parameters['rowFilter.sul_roads.name'];
          ref?: parameters['rowFilter.sul_roads.ref'];
          oneway?: parameters['rowFilter.sul_roads.oneway'];
          maxspeed?: parameters['rowFilter.sul_roads.maxspeed'];
          layer?: parameters['rowFilter.sul_roads.layer'];
          bridge?: parameters['rowFilter.sul_roads.bridge'];
          tunnel?: parameters['rowFilter.sul_roads.tunnel'];
          idmuni?: parameters['rowFilter.sul_roads.idmuni'];
          nm_municip?: parameters['rowFilter.sul_roads.nm_municip'];
          cd_geocmu?: parameters['rowFilter.sul_roads.cd_geocmu'];
          geom?: parameters['rowFilter.sul_roads.geom'];
          fator?: parameters['rowFilter.sul_roads.fator'];
          geomhelper?: parameters['rowFilter.sul_roads.geomhelper'];
        };
        body: {
          /** sul_roads */
          sul_roads?: definitions['sul_roads'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/vinculo': {
    get: {
      parameters: {
        query: {
          id_vinculos?: parameters['rowFilter.vinculo.id_vinculos'];
          id_camada_principal?: parameters['rowFilter.vinculo.id_camada_principal'];
          id_campo_principal?: parameters['rowFilter.vinculo.id_campo_principal'];
          id_camada_secundaria?: parameters['rowFilter.vinculo.id_camada_secundaria'];
          id_campo_secundario?: parameters['rowFilter.vinculo.id_campo_secundario'];
          tipo?: parameters['rowFilter.vinculo.tipo'];
          aud_criado_data?: parameters['rowFilter.vinculo.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.vinculo.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.vinculo.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.vinculo.aud_id_modificado_por'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['vinculo'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** vinculo */
          vinculo?: definitions['vinculo'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_vinculos?: parameters['rowFilter.vinculo.id_vinculos'];
          id_camada_principal?: parameters['rowFilter.vinculo.id_camada_principal'];
          id_campo_principal?: parameters['rowFilter.vinculo.id_campo_principal'];
          id_camada_secundaria?: parameters['rowFilter.vinculo.id_camada_secundaria'];
          id_campo_secundario?: parameters['rowFilter.vinculo.id_campo_secundario'];
          tipo?: parameters['rowFilter.vinculo.tipo'];
          aud_criado_data?: parameters['rowFilter.vinculo.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.vinculo.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.vinculo.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.vinculo.aud_id_modificado_por'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_vinculos?: parameters['rowFilter.vinculo.id_vinculos'];
          id_camada_principal?: parameters['rowFilter.vinculo.id_camada_principal'];
          id_campo_principal?: parameters['rowFilter.vinculo.id_campo_principal'];
          id_camada_secundaria?: parameters['rowFilter.vinculo.id_camada_secundaria'];
          id_campo_secundario?: parameters['rowFilter.vinculo.id_campo_secundario'];
          tipo?: parameters['rowFilter.vinculo.tipo'];
          aud_criado_data?: parameters['rowFilter.vinculo.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.vinculo.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.vinculo.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.vinculo.aud_id_modificado_por'];
        };
        body: {
          /** vinculo */
          vinculo?: definitions['vinculo'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/contratos_items': {
    get: {
      parameters: {
        query: {
          id_contratos_items?: parameters['rowFilter.contratos_items.id_contratos_items'];
          valor?: parameters['rowFilter.contratos_items.valor'];
          id_contratos?: parameters['rowFilter.contratos_items.id_contratos'];
          descricao?: parameters['rowFilter.contratos_items.descricao'];
          id_tenants?: parameters['rowFilter.contratos_items.id_tenants'];
          tipo?: parameters['rowFilter.contratos_items.tipo'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['contratos_items'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** contratos_items */
          contratos_items?: definitions['contratos_items'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_contratos_items?: parameters['rowFilter.contratos_items.id_contratos_items'];
          valor?: parameters['rowFilter.contratos_items.valor'];
          id_contratos?: parameters['rowFilter.contratos_items.id_contratos'];
          descricao?: parameters['rowFilter.contratos_items.descricao'];
          id_tenants?: parameters['rowFilter.contratos_items.id_tenants'];
          tipo?: parameters['rowFilter.contratos_items.tipo'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_contratos_items?: parameters['rowFilter.contratos_items.id_contratos_items'];
          valor?: parameters['rowFilter.contratos_items.valor'];
          id_contratos?: parameters['rowFilter.contratos_items.id_contratos'];
          descricao?: parameters['rowFilter.contratos_items.descricao'];
          id_tenants?: parameters['rowFilter.contratos_items.id_tenants'];
          tipo?: parameters['rowFilter.contratos_items.tipo'];
        };
        body: {
          /** contratos_items */
          contratos_items?: definitions['contratos_items'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/setores_rs': {
    get: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_rs.gid'];
          nm_municip?: parameters['rowFilter.setores_rs.nm_municip'];
          geom?: parameters['rowFilter.setores_rs.geom'];
          cd_geocodi?: parameters['rowFilter.setores_rs.cd_geocodi'];
          cd_geocodm?: parameters['rowFilter.setores_rs.cd_geocodm'];
          geomtext?: parameters['rowFilter.setores_rs.geomtext'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['setores_rs'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** setores_rs */
          setores_rs?: definitions['setores_rs'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_rs.gid'];
          nm_municip?: parameters['rowFilter.setores_rs.nm_municip'];
          geom?: parameters['rowFilter.setores_rs.geom'];
          cd_geocodi?: parameters['rowFilter.setores_rs.cd_geocodi'];
          cd_geocodm?: parameters['rowFilter.setores_rs.cd_geocodm'];
          geomtext?: parameters['rowFilter.setores_rs.geomtext'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          gid?: parameters['rowFilter.setores_rs.gid'];
          nm_municip?: parameters['rowFilter.setores_rs.nm_municip'];
          geom?: parameters['rowFilter.setores_rs.geom'];
          cd_geocodi?: parameters['rowFilter.setores_rs.cd_geocodi'];
          cd_geocodm?: parameters['rowFilter.setores_rs.cd_geocodm'];
          geomtext?: parameters['rowFilter.setores_rs.geomtext'];
        };
        body: {
          /** setores_rs */
          setores_rs?: definitions['setores_rs'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos': {
    get: {
      parameters: {
        query: {
          id_projetos?: parameters['rowFilter.projetos.id_projetos'];
          nome?: parameters['rowFilter.projetos.nome'];
          cidade?: parameters['rowFilter.projetos.cidade'];
          id_usuarios?: parameters['rowFilter.projetos.id_usuarios'];
          ativo?: parameters['rowFilter.projetos.ativo'];
          id_tenants?: parameters['rowFilter.projetos.id_tenants'];
          id_segmentos?: parameters['rowFilter.projetos.id_segmentos'];
          aud_criado_data?: parameters['rowFilter.projetos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos.aud_id_modificado_por'];
          total_size_vectors?: parameters['rowFilter.projetos.total_size_vectors'];
          tipo_projeto?: parameters['rowFilter.projetos.tipo_projeto'];
          endereco_api?: parameters['rowFilter.projetos.endereco_api'];
          ordem_camadas?: parameters['rowFilter.projetos.ordem_camadas'];
          campos_favoritos_pesquisa?: parameters['rowFilter.projetos.campos_favoritos_pesquisa'];
          ordem_camadas_fix?: parameters['rowFilter.projetos.ordem_camadas_fix'];
          notas_consulta_previa?: parameters['rowFilter.projetos.notas_consulta_previa'];
          alias?: parameters['rowFilter.projetos.alias'];
          configuracao?: parameters['rowFilter.projetos.configuracao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos */
          projetos?: definitions['projetos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos?: parameters['rowFilter.projetos.id_projetos'];
          nome?: parameters['rowFilter.projetos.nome'];
          cidade?: parameters['rowFilter.projetos.cidade'];
          id_usuarios?: parameters['rowFilter.projetos.id_usuarios'];
          ativo?: parameters['rowFilter.projetos.ativo'];
          id_tenants?: parameters['rowFilter.projetos.id_tenants'];
          id_segmentos?: parameters['rowFilter.projetos.id_segmentos'];
          aud_criado_data?: parameters['rowFilter.projetos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos.aud_id_modificado_por'];
          total_size_vectors?: parameters['rowFilter.projetos.total_size_vectors'];
          tipo_projeto?: parameters['rowFilter.projetos.tipo_projeto'];
          endereco_api?: parameters['rowFilter.projetos.endereco_api'];
          ordem_camadas?: parameters['rowFilter.projetos.ordem_camadas'];
          campos_favoritos_pesquisa?: parameters['rowFilter.projetos.campos_favoritos_pesquisa'];
          ordem_camadas_fix?: parameters['rowFilter.projetos.ordem_camadas_fix'];
          notas_consulta_previa?: parameters['rowFilter.projetos.notas_consulta_previa'];
          alias?: parameters['rowFilter.projetos.alias'];
          configuracao?: parameters['rowFilter.projetos.configuracao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos?: parameters['rowFilter.projetos.id_projetos'];
          nome?: parameters['rowFilter.projetos.nome'];
          cidade?: parameters['rowFilter.projetos.cidade'];
          id_usuarios?: parameters['rowFilter.projetos.id_usuarios'];
          ativo?: parameters['rowFilter.projetos.ativo'];
          id_tenants?: parameters['rowFilter.projetos.id_tenants'];
          id_segmentos?: parameters['rowFilter.projetos.id_segmentos'];
          aud_criado_data?: parameters['rowFilter.projetos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos.aud_id_modificado_por'];
          total_size_vectors?: parameters['rowFilter.projetos.total_size_vectors'];
          tipo_projeto?: parameters['rowFilter.projetos.tipo_projeto'];
          endereco_api?: parameters['rowFilter.projetos.endereco_api'];
          ordem_camadas?: parameters['rowFilter.projetos.ordem_camadas'];
          campos_favoritos_pesquisa?: parameters['rowFilter.projetos.campos_favoritos_pesquisa'];
          ordem_camadas_fix?: parameters['rowFilter.projetos.ordem_camadas_fix'];
          notas_consulta_previa?: parameters['rowFilter.projetos.notas_consulta_previa'];
          alias?: parameters['rowFilter.projetos.alias'];
          configuracao?: parameters['rowFilter.projetos.configuracao'];
        };
        body: {
          /** projetos */
          projetos?: definitions['projetos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/edificacoes_rincao': {
    get: {
      parameters: {
        query: {
          id_edificacoes?: parameters['rowFilter.edificacoes_rincao.id_edificacoes'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['edificacoes_rincao'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** edificacoes_rincao */
          edificacoes_rincao?: definitions['edificacoes_rincao'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_edificacoes?: parameters['rowFilter.edificacoes_rincao.id_edificacoes'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_edificacoes?: parameters['rowFilter.edificacoes_rincao.id_edificacoes'];
        };
        body: {
          /** edificacoes_rincao */
          edificacoes_rincao?: definitions['edificacoes_rincao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/wikimap_usuarios': {
    get: {
      parameters: {
        query: {
          id_usuarios_wikimap?: parameters['rowFilter.wikimap_usuarios.id_usuarios_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_usuarios.id_usuarios'];
          id_wikimap?: parameters['rowFilter.wikimap_usuarios.id_wikimap'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['wikimap_usuarios'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** wikimap_usuarios */
          wikimap_usuarios?: definitions['wikimap_usuarios'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_usuarios_wikimap?: parameters['rowFilter.wikimap_usuarios.id_usuarios_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_usuarios.id_usuarios'];
          id_wikimap?: parameters['rowFilter.wikimap_usuarios.id_wikimap'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_usuarios_wikimap?: parameters['rowFilter.wikimap_usuarios.id_usuarios_wikimap'];
          id_usuarios?: parameters['rowFilter.wikimap_usuarios.id_usuarios'];
          id_wikimap?: parameters['rowFilter.wikimap_usuarios.id_wikimap'];
        };
        body: {
          /** wikimap_usuarios */
          wikimap_usuarios?: definitions['wikimap_usuarios'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/projetos_camadas_formularios_campos': {
    get: {
      parameters: {
        query: {
          id_projetos_camadas_formularios?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios'];
          nome?: parameters['rowFilter.projetos_camadas_formularios_campos.nome'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos'];
          obrigatorio?: parameters['rowFilter.projetos_camadas_formularios_campos.obrigatorio'];
          id_projetos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos'];
          hint?: parameters['rowFilter.projetos_camadas_formularios_campos.hint'];
          tipo?: parameters['rowFilter.projetos_camadas_formularios_campos.tipo'];
          ordenacao?: parameters['rowFilter.projetos_camadas_formularios_campos.ordenacao'];
          ativo?: parameters['rowFilter.projetos_camadas_formularios_campos.ativo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_id_modificado_por'];
          representacao?: parameters['rowFilter.projetos_camadas_formularios_campos.representacao'];
          publico_ouv?: parameters['rowFilter.projetos_camadas_formularios_campos.publico_ouv'];
          fator?: parameters['rowFilter.projetos_camadas_formularios_campos.fator'];
          fators?: parameters['rowFilter.projetos_camadas_formularios_campos.fators'];
          ordem_visualizacao?: parameters['rowFilter.projetos_camadas_formularios_campos.ordem_visualizacao'];
          tbl_coluna_db?: parameters['rowFilter.projetos_camadas_formularios_campos.tbl_coluna_db'];
          resumo_card_db?: parameters['rowFilter.projetos_camadas_formularios_campos.resumo_card_db'];
          campos_projeto?: parameters['rowFilter.projetos_camadas_formularios_campos.campos_projeto'];
          tbl_nome_coluna?: parameters['rowFilter.projetos_camadas_formularios_campos.tbl_nome_coluna'];
          id_projetos_ocultos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_ocultos'];
          resumo?: parameters['rowFilter.projetos_camadas_formularios_campos.resumo'];
          descricao?: parameters['rowFilter.projetos_camadas_formularios_campos.descricao'];
          caracterizacao?: parameters['rowFilter.projetos_camadas_formularios_campos.caracterizacao'];
          validacao?: parameters['rowFilter.projetos_camadas_formularios_campos.validacao'];
          validacoes?: parameters['rowFilter.projetos_camadas_formularios_campos.validacoes'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['projetos_camadas_formularios_campos'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** projetos_camadas_formularios_campos */
          projetos_camadas_formularios_campos?: definitions['projetos_camadas_formularios_campos'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_projetos_camadas_formularios?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios'];
          nome?: parameters['rowFilter.projetos_camadas_formularios_campos.nome'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos'];
          obrigatorio?: parameters['rowFilter.projetos_camadas_formularios_campos.obrigatorio'];
          id_projetos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos'];
          hint?: parameters['rowFilter.projetos_camadas_formularios_campos.hint'];
          tipo?: parameters['rowFilter.projetos_camadas_formularios_campos.tipo'];
          ordenacao?: parameters['rowFilter.projetos_camadas_formularios_campos.ordenacao'];
          ativo?: parameters['rowFilter.projetos_camadas_formularios_campos.ativo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_id_modificado_por'];
          representacao?: parameters['rowFilter.projetos_camadas_formularios_campos.representacao'];
          publico_ouv?: parameters['rowFilter.projetos_camadas_formularios_campos.publico_ouv'];
          fator?: parameters['rowFilter.projetos_camadas_formularios_campos.fator'];
          fators?: parameters['rowFilter.projetos_camadas_formularios_campos.fators'];
          ordem_visualizacao?: parameters['rowFilter.projetos_camadas_formularios_campos.ordem_visualizacao'];
          tbl_coluna_db?: parameters['rowFilter.projetos_camadas_formularios_campos.tbl_coluna_db'];
          resumo_card_db?: parameters['rowFilter.projetos_camadas_formularios_campos.resumo_card_db'];
          campos_projeto?: parameters['rowFilter.projetos_camadas_formularios_campos.campos_projeto'];
          tbl_nome_coluna?: parameters['rowFilter.projetos_camadas_formularios_campos.tbl_nome_coluna'];
          id_projetos_ocultos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_ocultos'];
          resumo?: parameters['rowFilter.projetos_camadas_formularios_campos.resumo'];
          descricao?: parameters['rowFilter.projetos_camadas_formularios_campos.descricao'];
          caracterizacao?: parameters['rowFilter.projetos_camadas_formularios_campos.caracterizacao'];
          validacao?: parameters['rowFilter.projetos_camadas_formularios_campos.validacao'];
          validacoes?: parameters['rowFilter.projetos_camadas_formularios_campos.validacoes'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_projetos_camadas_formularios?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios'];
          nome?: parameters['rowFilter.projetos_camadas_formularios_campos.nome'];
          id_projetos_camadas_formularios_campos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos'];
          obrigatorio?: parameters['rowFilter.projetos_camadas_formularios_campos.obrigatorio'];
          id_projetos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos'];
          hint?: parameters['rowFilter.projetos_camadas_formularios_campos.hint'];
          tipo?: parameters['rowFilter.projetos_camadas_formularios_campos.tipo'];
          ordenacao?: parameters['rowFilter.projetos_camadas_formularios_campos.ordenacao'];
          ativo?: parameters['rowFilter.projetos_camadas_formularios_campos.ativo'];
          aud_criado_data?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_criado_data'];
          aud_id_criado_por?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_id_criado_por'];
          aud_modificado_data?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_modificado_data'];
          aud_id_modificado_por?: parameters['rowFilter.projetos_camadas_formularios_campos.aud_id_modificado_por'];
          representacao?: parameters['rowFilter.projetos_camadas_formularios_campos.representacao'];
          publico_ouv?: parameters['rowFilter.projetos_camadas_formularios_campos.publico_ouv'];
          fator?: parameters['rowFilter.projetos_camadas_formularios_campos.fator'];
          fators?: parameters['rowFilter.projetos_camadas_formularios_campos.fators'];
          ordem_visualizacao?: parameters['rowFilter.projetos_camadas_formularios_campos.ordem_visualizacao'];
          tbl_coluna_db?: parameters['rowFilter.projetos_camadas_formularios_campos.tbl_coluna_db'];
          resumo_card_db?: parameters['rowFilter.projetos_camadas_formularios_campos.resumo_card_db'];
          campos_projeto?: parameters['rowFilter.projetos_camadas_formularios_campos.campos_projeto'];
          tbl_nome_coluna?: parameters['rowFilter.projetos_camadas_formularios_campos.tbl_nome_coluna'];
          id_projetos_ocultos?: parameters['rowFilter.projetos_camadas_formularios_campos.id_projetos_ocultos'];
          resumo?: parameters['rowFilter.projetos_camadas_formularios_campos.resumo'];
          descricao?: parameters['rowFilter.projetos_camadas_formularios_campos.descricao'];
          caracterizacao?: parameters['rowFilter.projetos_camadas_formularios_campos.caracterizacao'];
          validacao?: parameters['rowFilter.projetos_camadas_formularios_campos.validacao'];
          validacoes?: parameters['rowFilter.projetos_camadas_formularios_campos.validacoes'];
        };
        body: {
          /** projetos_camadas_formularios_campos */
          projetos_camadas_formularios_campos?: definitions['projetos_camadas_formularios_campos'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/rpc/get_registros': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            camada: number;
            /** Format: integer */
            limite: number;
            /** Format: integer */
            page: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/select_consulta_geral': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_camada: number;
            /** Format: character varying */
            valor: string;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_type': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer[] */
            campos: string;
            /** Format: integer */
            formulario: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_valores_filtro': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            camada: number;
            /** Format: text[] */
            campos: string;
            /** Format: integer */
            formulario: number;
            /** Format: integer */
            limitacao: number;
            /** Format: integer */
            page: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_values_from_geom': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer[] */
            ids_geom: string;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_valores_by_name_idcampo_idgeom': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: character varying */
            field_name: string;
            /** Format: integer */
            id_campo: number;
            /** Format: integer */
            id_geom: number;
            /** Format: integer */
            tipo: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/return_form_campos_by_id_geom': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_geom: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/consulta_geral': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_camada: number;
            /** Format: character varying */
            valor: string;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_nome_camada': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_campo: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_tipo_campo': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: text[] */
            campos: string;
            /** Format: integer */
            formulario: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_valores': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            camada: number;
            /** Format: integer */
            formulario: number;
            /** Format: integer */
            limitacao: number;
            /** Format: integer */
            page: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/return_tipos_by_form_campo': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_campo: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_formulario_campo': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            formulario: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_geometria': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_geometria: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/rpc/get_vector_tile': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: integer */
            id_camada: number;
            /** Format: integer */
            tenant: number;
            /** Format: integer */
            x: number;
            /** Format: integer */
            y: number;
            /** Format: integer */
            z: number;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
}

export interface definitions {
  cep_brasil: {
    /** Format: integer */
    idendereco?: number;
    /** Format: integer */
    gr_usuario?: number;
    /** Format: character varying */
    idlocalidade?: string;
    /** Format: character varying */
    tipo_logr?: string;
    /** Format: character varying */
    logr_nome?: string;
    /** Format: character varying */
    logr_copl?: string;
    /** Format: character varying */
    numero?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    nome_localidade?: string;
    /** Format: character varying */
    sigla_uf?: string;
    /** Format: character varying */
    cep?: string;
    /** Format: double precision */
    latitude?: number;
    /** Format: double precision */
    longitude?: number;
    /** Format: public.geometry(Point,4326) */
    geom?: string;
  };
  importacoes_tiff: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_importacoes_tiff: number;
    /** Format: character varying */
    nome_arquivo?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /** Format: character varying */
    nome_layer?: string;
    /**
     * Format: bigint
     * @default 0
     */
    file_size: number;
    /**
     * Format: character varying
     * @default TILE
     */
    tipo_imagem?: string;
    /** Format: integer */
    min_zoom?: number;
    /** Format: integer */
    max_zoom?: number;
    /** Format: text */
    extensao?: string;
    /** Format: boolean */
    sinal?: boolean;
    /** Format: character varying */
    representacao?: string;
    /** Format: character varying */
    url?: string;
    /** Format: character varying */
    extent?: string;
    /** Format: character varying */
    preview?: string;
  };
  licencas: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_licencas: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenants?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `planos.id_planos`.<fk table='planos' column='id_planos'/>
     */
    id_planos?: number;
    /** Format: numeric */
    valor?: number;
    /** Format: integer */
    qtd_usuarios_plano?: number;
    /** Format: timestamp without time zone */
    data_cadastro?: string;
    /** Format: timestamp without time zone */
    data_inicio_vigencia?: string;
    /** Format: timestamp without time zone */
    data_final_vigencia?: string;
    /** Format: character varying */
    status: string;
    /** Format: integer */
    armazenamento_plano?: number;
    /** Format: integer */
    armazenamento_adicional?: number;
    /** Format: integer */
    armazenamento_total?: number;
    /** Format: numeric */
    valor_armazenamento_ad?: number;
    /** Format: integer */
    qtd_usuarios_adicionais?: number;
    /** Format: integer */
    qtd_usuarios_total?: number;
    /** Format: integer */
    armazenamento_adicional_raster?: number;
    /** Format: integer */
    armazenamento_adicional_vetor?: number;
    /** Format: integer */
    uso_vetor?: number;
    /** Format: integer */
    uso_raster?: number;
    /** Format: bigint */
    uso_vetor_big?: number;
    /** Format: bigint */
    uso_raster_big?: number;
    /** Format: bigint */
    armazenamento_adicional_raster_big?: number;
    /** Format: bigint */
    armazenamento_adicional_vetor_big?: number;
    /** Format: character varying */
    token_card?: string;
    /** Format: character varying */
    token_bing?: string;
    /** Format: character varying */
    token_mapbox?: string;
  };
  segmentos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_segmentos: number;
    /** Format: character varying */
    descricao?: string;
    /** Format: character varying */
    tipo?: string;
  };
  sul_roads_refactor: {
    /** Format: integer */
    gid?: number;
    /** Format: character varying */
    osm_id?: string;
    /** Format: smallint */
    code?: number;
    /** Format: character varying */
    fclass?: string;
    /** Format: character varying */
    name?: string;
    /** Format: character varying */
    ref?: string;
    /** Format: character varying */
    oneway?: string;
    /** Format: smallint */
    maxspeed?: number;
    /** Format: double precision */
    layer?: number;
    /** Format: character varying */
    bridge?: string;
    /** Format: character varying */
    tunnel?: string;
    /** Format: bigint */
    idmuni?: number;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: text */
    cd_geocmu?: string;
    /** Format: public.geometry(MultiLineString,4326) */
    geom?: string;
    /** Format: double precision */
    fator?: number;
    /** Format: public.geometry(Geometry,4326) */
    geomhelper?: string;
  };
  fontes_wms: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_fontes_wms: number;
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    descricao?: string;
    /** Format: character varying */
    url?: string;
    /** Format: character varying */
    foto?: string;
  };
  planos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_planos: number;
    /** Format: character varying */
    nome?: string;
    /** Format: numeric */
    valor?: number;
    /** Format: integer */
    qtd_usuarios?: number;
    /** Format: integer */
    armazenamento?: number;
    /** Format: integer */
    qtd_projetos?: number;
  };
  wikimap: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_wikimap: number;
    /** Format: boolean */
    mundial?: boolean;
    /** Format: text */
    continental?: string;
    /** Format: text */
    pais?: string;
    /** Format: text */
    estado?: string;
    /** Format: text */
    regiao_metropolitana?: string;
    /** Format: text */
    municipio?: string;
    /** Format: text */
    h1?: string;
    /** Format: text */
    h2?: string;
    /** Format: text */
    h3?: string;
    /** Format: text */
    descricao?: string;
    /** Format: text */
    fonte?: string;
    /** Format: text */
    imagem?: string;
    /** Format: boolean */
    publicar?: boolean;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `wikimap_organizacao.id_wikimap_organizacao`.<fk table='wikimap_organizacao' column='id_wikimap_organizacao'/>
     */
    id_wikimap_organizacao?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `wikimap_tema_especifico.id_wikimap_tema_especifico`.<fk table='wikimap_tema_especifico' column='id_wikimap_tema_especifico'/>
     */
    id_wikimap_tema_especifico?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `wikimap_tema_geral.id_wikimap_tema_geral`.<fk table='wikimap_tema_geral' column='id_wikimap_tema_geral'/>
     */
    id_wikimap_tema_geral?: number;
    /** Format: boolean */
    template?: boolean;
  };
  projetos_mapas_personalizados: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_mapas_personalizados: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenants?: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /** Format: boolean */
    compartilhar?: boolean;
    /** Format: boolean */
    publico?: boolean;
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    configuracao?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
  };
  amostras_raspagem: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_amostras_raspagem: number;
    /** Format: double precision */
    vm2?: number;
    /** Format: public.geometry(Point,4326) */
    geom?: string;
    /** Format: text */
    imagem?: string;
    /** Format: double precision */
    x?: number;
    /** Format: double precision */
    y?: number;
    /** Format: text */
    site?: string;
    /** Format: double precision */
    preco?: number;
    /** Format: double precision */
    tamanho?: number;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    muni?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    rua?: string;
    /** Format: character varying */
    estado?: string;
    /** Format: timestamp without time zone */
    data_insercao?: string;
    /** Format: character varying */
    ruabairro?: string;
  };
  recebimentos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_recebimentos: number;
    /** Format: numeric */
    valor: number;
    /** Format: timestamp without time zone */
    data_emissao: string;
    /** Format: timestamp without time zone */
    data_vencimento?: string;
    /** Format: integer */
    id_tenants: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `contratos.id_contratos`.<fk table='contratos' column='id_contratos'/>
     */
    id_contratos: number;
    /**
     * Format: integer
     * @default 1
     */
    status: number;
    /** Format: integer */
    forma_pagamento: number;
    /** Format: integer */
    parcelas?: number;
  };
  projetos_camadas_valores: {
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_projetos_camadas: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos`.<fk table='projetos_camadas_formularios_campos' column='id_projetos_camadas_formularios_campos'/>
     */
    id_projetos_camadas_formularios_campos: number;
    /** Format: numeric */
    valor_num?: number;
    /** Format: character varying */
    valor_select?: string;
    /** Format: boolean */
    valor_checkbox?: boolean;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `criciuma_observacoes.id_projetos_camadas_geometrias`.<fk table='criciuma_observacoes' column='id_projetos_camadas_geometrias'/>
     */
    id_projetos_camadas_geometrias: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_valores: number;
    /** Format: integer */
    valor_int?: number;
    /** Format: character varying */
    valor_text?: string;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /** Format: timestamp without time zone */
    valor_timestamp?: string;
  };
  camadas_usuarios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_camadas_usuarios: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_projetos_camadas?: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /** Format: character varying */
    permissao?: string;
    /**
     * Format: timestamp without time zone
     * @default CURRENT_TIMESTAMP
     */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /**
     * Format: timestamp without time zone
     * @default CURRENT_TIMESTAMP
     */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
  };
  setores_sc: {
    /** Format: integer */
    gid?: number;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: public.geometry(Polygon) */
    geom?: string;
    /** Format: character varying */
    cd_geocodi?: string;
    /** Format: character varying */
    cd_geocodm?: string;
    /** Format: text */
    geomtext?: string;
  };
  krigagem: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_krigagem: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `variogramas.id_variogramas`.<fk table='variogramas' column='id_variogramas'/>
     */
    id_variogramas: number;
    /** Format: integer */
    id_dominio_geografico?: number;
    /** Format: text */
    referencia_raster?: string;
  };
  valores_select: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_valores_select: number;
    /**
     * Format: bigint
     * @description Note:
     * This is a Foreign Key to `projetos_camadas_valores.id_projetos_camadas_valores`.<fk table='projetos_camadas_valores' column='id_projetos_camadas_valores'/>
     */
    id_projetos_camadas_valores?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `campos_select.id_campos_select`.<fk table='campos_select' column='id_campos_select'/>
     */
    id_campos_select?: number;
    /** Format: character varying */
    tbl_valor_banco?: string;
  };
  tenants: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_tenants: number;
    /** Format: character varying */
    token: string;
    /** Format: character varying */
    config?: string;
  };
  importacoes_dxf_geometrias: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_importacoes_dxf_geometrias: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `importacoes_dxf.id_importacoes_dxf`.<fk table='importacoes_dxf' column='id_importacoes_dxf'/>
     */
    id_importacoes_dxf?: number;
    /** Format: public.geometry */
    geom?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
  };
  contratos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_contratos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `planos.id_planos`.<fk table='planos' column='id_planos'/>
     */
    id_planos?: number;
    /** Format: numeric */
    valor?: number;
    /** Format: integer */
    qtd_usuarios?: number;
    /** Format: timestamp without time zone */
    data_contrato?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `licencas.id_licencas`.<fk table='licencas' column='id_licencas'/>
     */
    id_licencas?: number;
    /** Format: integer */
    armazenamento?: number;
  };
  criciuma_zonas: {
    /** Format: integer */
    id_projetos_camadas_geometrias?: number;
    /** Format: text */
    afastamento_embas?: string;
    /** Format: text */
    afastamento_frente?: string;
    /** Format: text */
    afastamento_torre?: string;
    /** Format: text */
    area_maxima_lote?: string;
    /** Format: text */
    area_minima_lote?: string;
    /** Format: text */
    caracterizacao?: string;
    /** Format: text */
    codigo?: string;
    /** Format: text */
    id_zona?: string;
    /** Format: text */
    indice_basico_aproveitamento?: string;
    /** Format: text */
    indice_max_aproveitamento?: string;
    /** Format: text */
    nome?: string;
    /** Format: text */
    numero_max_pavimentos?: string;
    /** Format: text */
    objetivos?: string;
    /** Format: text */
    observacoes?: string;
    /** Format: text */
    taxa_basica_infiltracao?: string;
    /** Format: text */
    taxa_basica_ocupacao?: string;
    /** Format: text */
    taxa_max_ocupacao?: string;
    /** Format: text */
    taxa_min_infiltracao?: string;
    /** Format: text */
    valor_outorga?: string;
    /** Format: public.geometry */
    geom?: string;
  };
  projetos_camadas_valores_valores_select: {
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos`.<fk table='projetos_camadas_formularios_campos' column='id_projetos_camadas_formularios_campos'/>
     */
    id_projetos_camadas_formularios_campos?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_projetos_camadas?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `criciuma_observacoes.id_projetos_camadas_geometrias`.<fk table='criciuma_observacoes' column='id_projetos_camadas_geometrias'/>
     */
    id_projetos_camadas_geometrias?: number;
    /** Format: boolean */
    resumo?: boolean;
    /** Format: character varying */
    nome?: string;
    /** Format: numeric */
    valor_num?: number;
    /** Format: boolean */
    valor_checkbox?: boolean;
    /** Format: integer */
    valor_int?: number;
    /** Format: character varying */
    valor_text?: string;
    /** Format: timestamp without time zone */
    valor_timestamp?: string;
    /** Format: character varying */
    valor_select?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `campos_select.id_campos_select`.<fk table='campos_select' column='id_campos_select'/>
     */
    id_campos_select?: number;
    /** Format: smallint */
    tipo?: number;
  };
  projetos_usuarios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_usuarios: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /** Format: character varying */
    permissao: string;
  };
  campos_select: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_campos_select: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos`.<fk table='projetos_camadas_formularios_campos' column='id_projetos_camadas_formularios_campos'/>
     */
    id_projetos_camadas_formularios_campos?: number;
    /** Format: character varying */
    nome?: string;
    /** Format: integer */
    ordem?: number;
    /** Format: boolean */
    ativo?: boolean;
    /** Format: double precision */
    fator?: number;
    /** Format: character varying */
    tbl_valor_db?: string;
  };
  importacoes_pendentes: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_importacoes_pendentes: number;
    /** Format: character varying */
    codigo?: string;
    /** Format: boolean */
    status_completo?: boolean;
    /** Format: character varying */
    descricao?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /** Format: boolean */
    hide?: boolean;
    /** Format: character varying */
    representacao?: string;
  };
  wikimap_organizacao: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_wikimap_organizacao: number;
    /** Format: text */
    organizacao?: string;
    /** Format: text */
    sigla?: string;
    /** Format: text */
    url?: string;
    /** Format: text */
    descricao?: string;
  };
  projetos_camadas: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas: number;
    /** Format: character varying */
    nome?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos: number;
    /**
     * Format: boolean
     * @default true
     */
    ativo: boolean;
    /** Format: character varying */
    tipo_geometria: string;
    /** Format: character varying */
    cor?: string;
    /** Format: character varying */
    espessura?: string;
    /** Format: character varying */
    preenchimento?: string;
    /** Format: character varying */
    tipo_linha?: string;
    /** Format: character varying */
    simbolo_ponto?: string;
    /** Format: character varying */
    tamanho_ponto?: string;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /**
     * Format: boolean
     * @default false
     */
    rotulo_ativo?: boolean;
    /** Format: character varying */
    rotulo_nome?: string;
    /** Format: character varying */
    sld_body?: string;
    /** Format: integer */
    ordem_visualizacao?: number;
    /** Format: boolean */
    visibilidade?: boolean;
    /** Format: character varying */
    tamanho_rotulo?: string;
    /** Format: character varying */
    legenda?: string;
    /** Format: character varying */
    mapa_tematico?: string;
    /** Format: character varying */
    campo_mapa_tematico?: string;
    /** Format: integer */
    id_campo_mapa_tematico?: number;
    /**
     * Format: integer
     * @default 0
     */
    layer_size?: number;
    /** Format: integer */
    id_campo_rotulo?: number;
    /** Format: boolean */
    publico_ouv?: boolean;
    /** Format: integer */
    tipo_camada?: number;
    /** Format: character varying */
    representacao?: string;
    /** Format: character varying */
    equacao?: string;
    /** Format: boolean */
    show_ouv?: boolean;
    /** Format: integer */
    escala_max?: number;
    /** Format: integer */
    escala_min?: number;
    /** Format: timestamp without time zone */
    aud_atualizado_raspagem?: string;
    /** Format: text */
    sld_body_ouv?: string;
    /** Format: text */
    mapa_tematico_ouv?: string;
    /** Format: text */
    estiloouv?: string;
    /** Format: integer */
    rotulo_decimal?: number;
    /** Format: text */
    estilowebgeo?: string;
    /** Format: text */
    mapa_tematico_fix?: string;
    /** Format: boolean */
    privada?: boolean;
    /** Format: integer */
    id_campo_rotulo_rotacao?: number;
    /** Format: character varying */
    estiloconsultaprevia?: string;
    /** Format: text */
    estiloconsultapreviatext?: string;
    /** Format: text */
    estiloavaliacao?: string;
    /** Format: boolean */
    show_previa?: boolean;
    /** Format: boolean */
    show_icad?: boolean;
    /** Format: boolean */
    show_avaliacao?: boolean;
    /** Format: boolean */
    publico_icad?: boolean;
    /** Format: text */
    estilo_icad?: string;
    /** Format: text */
    legenda_fix?: string;
    /** Format: boolean */
    show_generico?: boolean;
    /** Format: boolean */
    publico_generico?: boolean;
    /** Format: text */
    estilo_generico?: string;
    /** Format: ARRAY */
    id_campos_rotulos?: unknown[];
    /** Format: character varying */
    tbl_nome_db?: string;
    /** Format: character varying */
    chave_principal?: string;
    /** Format: character varying */
    chave_secundaria?: string;
    /** Format: character varying */
    descricao?: string;
    /** Format: character varying */
    url?: string;
  };
  usuarios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_usuarios: number;
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    auth_token?: string;
    /** Format: character varying */
    email?: string;
    /** Format: character varying */
    senha?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenants: number;
    /**
     * Format: boolean
     * @default false
     */
    adm?: boolean;
    /** Format: character varying */
    tipo?: string;
    /**
     * Format: boolean
     * @default true
     */
    ativo?: boolean;
    /**
     * Format: boolean
     * @default false
     */
    status_import: boolean;
    /** Format: character varying */
    ip_login?: string;
    /** Format: character varying */
    foto?: string;
    /** Format: character varying */
    user?: string;
    /** Format: boolean */
    colaborativo?: boolean;
    /** Format: character varying */
    classificacoes?: string;
  };
  wikimap_comentarios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_wikimap_comentarios: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `wikimap.id_wikimap`.<fk table='wikimap' column='id_wikimap'/>
     */
    id_wikimap: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios: number;
    /** Format: text */
    comentario?: string;
    /** Format: timestamp with time zone */
    criado?: string;
  };
  django_migrations: {
    /**
     * Format: bigint
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
    /** Format: character varying */
    app: string;
    /** Format: character varying */
    name: string;
    /** Format: timestamp with time zone */
    applied: string;
  };
  solicitacoes_ouv: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    gid: number;
    /** Format: text */
    nome?: string;
    /** Format: text */
    email?: string;
    /** Format: text */
    msg?: string;
    /** Format: text */
    telefone?: string;
    /** Format: text */
    empresa?: string;
    /** Format: timestamp without time zone */
    data?: string;
    /** Format: text */
    ip?: string;
  };
  faturamentos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_faturamentos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenants?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `contratos.id_contratos`.<fk table='contratos' column='id_contratos'/>
     */
    id_contratos?: number;
    /** Format: character varying */
    tipo?: string;
    /** Format: timestamp without time zone */
    data_fatura?: string;
    /** Format: numeric */
    valor?: number;
    /** Format: character varying */
    status?: string;
    /** Format: character varying */
    descricao?: string;
  };
  referencias_geograficas: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_referencias_geograficas: number;
    /** Format: character varying */
    srid?: string;
    /** Format: character varying */
    descricao?: string;
  };
  importacoes_wms: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_importacoes_wms: number;
    /** Format: character varying */
    link?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    bbox?: string;
    /** Format: character varying */
    url?: string;
    /** Format: character varying */
    params?: string;
  };
  auditoria_delete: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_auditoria_delete: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /** Format: timestamp without time zone */
    aud_hora?: string;
    /** Format: character varying */
    informacao?: string;
    /** Format: bigint */
    id_generico?: number;
    /**
     * Format: boolean
     * @default false
     */
    middleware?: boolean;
    /** Format: character varying */
    uri?: string;
  };
  wikimap_tema_especifico: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_wikimap_tema_especifico: number;
    /** Format: text */
    tema?: string;
  };
  osm_roads: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    gid: number;
    /** Format: character varying */
    osm_id?: string;
    /** Format: smallint */
    code?: number;
    /** Format: character varying */
    fclass?: string;
    /** Format: character varying */
    name?: string;
    /** Format: character varying */
    ref?: string;
    /** Format: character varying */
    oneway?: string;
    /** Format: smallint */
    maxspeed?: number;
    /** Format: double precision */
    layer?: number;
    /** Format: character varying */
    bridge?: string;
    /** Format: character varying */
    tunnel?: string;
    /** Format: public.geometry(MultiLineString,4326) */
    geom?: string;
  };
  empresas: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_empresas: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenants?: number;
    /** Format: character varying */
    nome?: string;
    /** Format: character */
    tipo_pessoa?: string;
    /** Format: character varying */
    cpf_cnpj?: string;
    /** Format: character varying */
    telefone?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `segmentos.id_segmentos`.<fk table='segmentos' column='id_segmentos'/>
     */
    id_segmentos?: number;
    /** Format: character varying */
    endereco?: string;
    /** Format: character varying */
    cidade?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    complemento?: string;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    uf?: string;
    /** Format: character varying */
    logo?: string;
  };
  projetos_camadas_adicionais: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_adicionais: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_projetos_camadas: number;
  };
  wikimap_likes: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_likes_wikimap: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `wikimap.id_wikimap`.<fk table='wikimap' column='id_wikimap'/>
     */
    id_wikimap?: number;
  };
  layouts: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_layout: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projeto?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenant?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuario?: number;
    /** Format: boolean */
    compartilhar?: boolean;
    /** Format: boolean */
    publico?: boolean;
    /** Format: character varying */
    nome?: string;
    /** Format: json */
    configuracao?: unknown;
  };
  variogramas: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_variogramas: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_camadas: number;
    /** Format: character varying */
    nome: string;
    /** Format: double precision */
    nugg: number;
    /** Format: double precision */
    rang: number;
    /** Format: double precision */
    psil: number;
    /** Format: text */
    url?: string;
    /** Format: boolean */
    automatico?: boolean;
    /** Format: boolean */
    log?: boolean;
    /** Format: integer */
    id_campo_vm2?: number;
    /** Format: integer */
    id_campo_chk?: number;
    /** Format: integer */
    id_projetos?: number;
    /** Format: ARRAY */
    zonas_ignorar?: unknown[];
  };
  modelos_variograma: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_modelos_variograma: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /** Format: character varying */
    nome_modelo?: string;
    /** Format: character varying */
    chave?: string;
    /** Format: character varying */
    valor?: string;
  };
  amostras_apartamentos_raspagem: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_amostras_apartamentos_raspagem: number;
    /** Format: double precision */
    vm2?: number;
    /** Format: public.geometry(Point,4326) */
    geom?: string;
    /** Format: text */
    imagem?: string;
    /** Format: double precision */
    x?: number;
    /** Format: double precision */
    y?: number;
    /** Format: text */
    site?: string;
    /** Format: double precision */
    preco?: number;
    /** Format: double precision */
    tamanho?: number;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    muni?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    rua?: string;
    /** Format: character varying */
    estado?: string;
    /** Format: double precision */
    area_util?: number;
    /** Format: timestamp without time zone */
    data_insercao?: string;
  };
  projetos_camadas_geometrias_arquivos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_geometrias_arquivos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `criciuma_observacoes.id_projetos_camadas_geometrias`.<fk table='criciuma_observacoes' column='id_projetos_camadas_geometrias'/>
     */
    id_projetos_camadas_geometrias?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /** Format: character varying */
    url_s3?: string;
    /** Format: integer */
    tipo?: number;
    /** Format: integer */
    file_size?: number;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
  };
  importacoes_dxf: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_importacoes_dxf: number;
    /** Format: character varying */
    nome?: string;
    /** Format: text */
    conteudo?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
  };
  wikimap_tema_geral: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_wikimap_tema_geral: number;
    /** Format: text */
    tema?: string;
  };
  projetos_arquivos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_arquivos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos?: number;
    /** Format: character varying */
    url_s3?: string;
    /** Format: integer */
    tipo?: number;
  };
  amostras_salas_raspagem: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_amostras_salas_raspagem: number;
    /** Format: double precision */
    vm2?: number;
    /** Format: public.geometry(Point,4326) */
    geom?: string;
    /** Format: text */
    imagem?: string;
    /** Format: double precision */
    x?: number;
    /** Format: double precision */
    y?: number;
    /** Format: text */
    site?: string;
    /** Format: double precision */
    preco?: number;
    /** Format: double precision */
    tamanho?: number;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    muni?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    rua?: string;
    /** Format: character varying */
    estado?: string;
    /** Format: double precision */
    area_util?: number;
    /** Format: timestamp without time zone */
    data_insercao?: string;
  };
  projetos_camadas_geometrias: {
    /** Format: public.geometry */
    geom?: string;
    /**
     * Format: timestamp without time zone
     * @default now()
     */
    data_criacao?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_geometrias: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_projetos_camadas: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos.id_projetos`.<fk table='projetos' column='id_projetos'/>
     */
    id_projetos: number;
    /**
     * Format: integer
     * @default 0
     */
    seq: number;
    /** Format: character varying */
    geom_wkt?: string;
    /** Format: character varying */
    rotulo?: string;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /** Format: character varying */
    categoria_mapa_tematico?: string;
    /**
     * Format: boolean
     * @default false
     */
    tem_foto?: boolean;
    /** Format: integer */
    indexmapatematico?: number;
    /** Format: timestamp without time zone */
    aud_raspado?: string;
    /** Format: boolean */
    foto?: boolean;
    /** Format: boolean */
    icadvinculado?: boolean;
    /** Format: boolean */
    icad_vinculado?: boolean;
    /** Format: double precision */
    rotulo_rotacao?: number;
    /** Format: character varying */
    campo_auxiliar?: string;
  };
  projetos_camadas_formularios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_formularios: number;
    /** Format: character varying */
    nome: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_projetos_camadas: number;
    /** Format: integer */
    id_projetos: number;
    /**
     * Format: boolean
     * @default true
     */
    ativo: boolean;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /** Format: character varying */
    representacao?: string;
    /** Format: character varying */
    tbl_valor_db?: string;
  };
  municipios_ibge: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    gid: number;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: character varying */
    cd_geocmu?: string;
    /** Format: public.geometry(MultiPolygon,4674) */
    geom?: string;
  };
  criciuma_observacoes: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_geometrias?: number;
    /** Format: public.geometry */
    geom?: string;
    /** Format: character varying */
    obser?: string;
  };
  sul_roads_refactorr: {
    /** Format: integer */
    gid?: number;
    /** Format: character varying */
    osm_id?: string;
    /** Format: smallint */
    code?: number;
    /** Format: character varying */
    fclass?: string;
    /** Format: character varying */
    name?: string;
    /** Format: character varying */
    ref?: string;
    /** Format: character varying */
    oneway?: string;
    /** Format: smallint */
    maxspeed?: number;
    /** Format: double precision */
    layer?: number;
    /** Format: character varying */
    bridge?: string;
    /** Format: character varying */
    tunnel?: string;
    /** Format: bigint */
    idmuni?: number;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: text */
    cd_geocmu?: string;
    /** Format: public.geometry(MultiLineString,4326) */
    geom?: string;
    /** Format: double precision */
    fator?: number;
    /** Format: public.geometry(Geometry,4326) */
    geomhelper?: string;
    /** Format: public.geometry_dump */
    geom_dump?: string;
    /** Format: public.geometry */
    simple_geom?: string;
    /** Format: ARRAY */
    path?: unknown[];
    /** Format: text */
    geom_type?: string;
    /** Format: text */
    geom_wkt?: string;
  };
  setores_rss: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    gid: number;
    /** Format: double precision */
    id?: number;
    /** Format: character varying */
    cd_geocodi?: string;
    /** Format: character varying */
    tipo?: string;
    /** Format: character varying */
    cd_geocodb?: string;
    /** Format: character varying */
    nm_bairro?: string;
    /** Format: character varying */
    cd_geocods?: string;
    /** Format: character varying */
    nm_subdist?: string;
    /** Format: character varying */
    cd_geocodd?: string;
    /** Format: character varying */
    nm_distrit?: string;
    /** Format: character varying */
    cd_geocodm?: string;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: character varying */
    nm_micro?: string;
    /** Format: character varying */
    nm_meso?: string;
    /** Format: public.geometry(MultiPolygonM,4326) */
    geom?: string;
  };
  projetos_camadas_relatorios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_relatorios: number;
    /** Format: integer */
    id_projetos_camadas?: number;
    /** Format: text */
    nome?: string;
    /** Format: text */
    estrutura?: string;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: integer */
    aud_id_modificado_por?: number;
  };
  sul_roads: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    gid: number;
    /** Format: character varying */
    osm_id?: string;
    /** Format: smallint */
    code?: number;
    /** Format: character varying */
    fclass?: string;
    /** Format: character varying */
    name?: string;
    /** Format: character varying */
    ref?: string;
    /** Format: character varying */
    oneway?: string;
    /** Format: smallint */
    maxspeed?: number;
    /** Format: double precision */
    layer?: number;
    /** Format: character varying */
    bridge?: string;
    /** Format: character varying */
    tunnel?: string;
    /** Format: bigint */
    idmuni?: number;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: text */
    cd_geocmu?: string;
    /** Format: public.geometry(MultiLineString,4326) */
    geom?: string;
    /** Format: double precision */
    fator?: number;
    /** Format: public.geometry(Geometry,4326) */
    geomhelper?: string;
  };
  vinculo: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_vinculos: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_camada_principal?: number;
    /** Format: integer */
    id_campo_principal?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas.id_projetos_camadas`.<fk table='projetos_camadas' column='id_projetos_camadas'/>
     */
    id_camada_secundaria?: number;
    /** Format: integer */
    id_campo_secundario?: number;
    /** Format: integer */
    tipo?: number;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
  };
  contratos_items: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_contratos_items: number;
    /** Format: numeric */
    valor: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `contratos.id_contratos`.<fk table='contratos' column='id_contratos'/>
     */
    id_contratos: number;
    /** Format: text */
    descricao?: string;
    /** Format: integer */
    id_tenants: number;
    /** Format: integer */
    tipo: number;
  };
  setores_rs: {
    /** Format: integer */
    gid?: number;
    /** Format: character varying */
    nm_municip?: string;
    /** Format: public.geometry(Polygon) */
    geom?: string;
    /** Format: character varying */
    cd_geocodi?: string;
    /** Format: character varying */
    cd_geocodm?: string;
    /** Format: text */
    geomtext?: string;
  };
  projetos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos: number;
    /** Format: character varying */
    nome: string;
    /** Format: character varying */
    cidade?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /**
     * Format: boolean
     * @default true
     */
    ativo: boolean;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `tenants.id_tenants`.<fk table='tenants' column='id_tenants'/>
     */
    id_tenants: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `segmentos.id_segmentos`.<fk table='segmentos' column='id_segmentos'/>
     */
    id_segmentos?: number;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /**
     * Format: integer
     * @default 0
     */
    total_size_vectors?: number;
    /** Format: character varying */
    tipo_projeto?: string;
    /** Format: character varying */
    endereco_api?: string;
    /** Format: ARRAY */
    ordem_camadas?: unknown[];
    /** Format: ARRAY */
    campos_favoritos_pesquisa?: unknown[];
    /** Format: character varying */
    ordem_camadas_fix?: string;
    /** Format: character varying */
    notas_consulta_previa?: string;
    /** Format: character varying */
    alias?: string;
    /** Format: text */
    configuracao?: string;
  };
  edificacoes_rincao: {
    /** Format: integer */
    id_edificacoes?: number;
  };
  wikimap_usuarios: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_usuarios_wikimap: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `usuarios.id_usuarios`.<fk table='usuarios' column='id_usuarios'/>
     */
    id_usuarios?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `wikimap.id_wikimap`.<fk table='wikimap' column='id_wikimap'/>
     */
    id_wikimap?: number;
  };
  projetos_camadas_formularios_campos: {
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `projetos_camadas_formularios.id_projetos_camadas_formularios`.<fk table='projetos_camadas_formularios' column='id_projetos_camadas_formularios'/>
     */
    id_projetos_camadas_formularios: number;
    /** Format: character varying */
    nome?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_projetos_camadas_formularios_campos: number;
    /**
     * Format: boolean
     * @default false
     */
    obrigatorio: boolean;
    /** Format: integer */
    id_projetos: number;
    /** Format: character varying */
    hint?: string;
    /** Format: smallint */
    tipo: number;
    /** Format: integer */
    ordenacao?: number;
    /**
     * Format: boolean
     * @default true
     */
    ativo: boolean;
    /** Format: timestamp without time zone */
    aud_criado_data?: string;
    /** Format: integer */
    aud_id_criado_por?: number;
    /** Format: timestamp without time zone */
    aud_modificado_data?: string;
    /** Format: integer */
    aud_id_modificado_por?: number;
    /** Format: character varying */
    representacao?: string;
    /** Format: boolean */
    publico_ouv?: boolean;
    /** Format: double precision */
    fator?: number;
    /** Format: text */
    fators?: string;
    /** Format: integer */
    ordem_visualizacao?: number;
    /** Format: character varying */
    tbl_coluna_db?: string;
    /** Format: ARRAY */
    resumo_card_db?: unknown[];
    /** Format: ARRAY */
    campos_projeto?: unknown[];
    /** Format: character varying */
    tbl_nome_coluna?: string;
    /** Format: ARRAY */
    id_projetos_ocultos?: unknown[];
    /** Format: boolean */
    resumo?: boolean;
    /** Format: character varying */
    descricao?: string;
    /** Format: boolean */
    caracterizacao?: boolean;
    /** Format: json */
    validacao?: unknown;
    /** Format: character varying */
    validacoes?: string;
  };
}

export interface parameters {
  /**
   * @description Preference
   * @enum {string}
   */
  preferParams: 'params=single-object';
  /**
   * @description Preference
   * @enum {string}
   */
  preferReturn: 'return=representation' | 'return=minimal' | 'return=none';
  /**
   * @description Preference
   * @enum {string}
   */
  preferCount: 'count=none';
  /** @description Filtering Columns */
  select: string;
  /** @description On Conflict */
  on_conflict: string;
  /** @description Ordering */
  order: string;
  /** @description Limiting and Pagination */
  range: string;
  /**
   * @description Limiting and Pagination
   * @default items
   */
  rangeUnit: string;
  /** @description Limiting and Pagination */
  offset: string;
  /** @description Limiting and Pagination */
  limit: string;
  /** @description cep_brasil */
  'body.cep_brasil': definitions['cep_brasil'];
  /** Format: integer */
  'rowFilter.cep_brasil.idendereco': string;
  /** Format: integer */
  'rowFilter.cep_brasil.gr_usuario': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.idlocalidade': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.tipo_logr': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.logr_nome': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.logr_copl': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.numero': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.bairro': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.nome_localidade': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.sigla_uf': string;
  /** Format: character varying */
  'rowFilter.cep_brasil.cep': string;
  /** Format: double precision */
  'rowFilter.cep_brasil.latitude': string;
  /** Format: double precision */
  'rowFilter.cep_brasil.longitude': string;
  /** Format: public.geometry(Point,4326) */
  'rowFilter.cep_brasil.geom': string;
  /** @description importacoes_tiff */
  'body.importacoes_tiff': definitions['importacoes_tiff'];
  /** Format: integer */
  'rowFilter.importacoes_tiff.id_importacoes_tiff': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.nome_arquivo': string;
  /** Format: integer */
  'rowFilter.importacoes_tiff.id_projetos': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.nome_layer': string;
  /** Format: bigint */
  'rowFilter.importacoes_tiff.file_size': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.tipo_imagem': string;
  /** Format: integer */
  'rowFilter.importacoes_tiff.min_zoom': string;
  /** Format: integer */
  'rowFilter.importacoes_tiff.max_zoom': string;
  /** Format: text */
  'rowFilter.importacoes_tiff.extensao': string;
  /** Format: boolean */
  'rowFilter.importacoes_tiff.sinal': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.representacao': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.url': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.extent': string;
  /** Format: character varying */
  'rowFilter.importacoes_tiff.preview': string;
  /** @description licencas */
  'body.licencas': definitions['licencas'];
  /** Format: integer */
  'rowFilter.licencas.id_licencas': string;
  /** Format: integer */
  'rowFilter.licencas.id_tenants': string;
  /** Format: integer */
  'rowFilter.licencas.id_planos': string;
  /** Format: numeric */
  'rowFilter.licencas.valor': string;
  /** Format: integer */
  'rowFilter.licencas.qtd_usuarios_plano': string;
  /** Format: timestamp without time zone */
  'rowFilter.licencas.data_cadastro': string;
  /** Format: timestamp without time zone */
  'rowFilter.licencas.data_inicio_vigencia': string;
  /** Format: timestamp without time zone */
  'rowFilter.licencas.data_final_vigencia': string;
  /** Format: character varying */
  'rowFilter.licencas.status': string;
  /** Format: integer */
  'rowFilter.licencas.armazenamento_plano': string;
  /** Format: integer */
  'rowFilter.licencas.armazenamento_adicional': string;
  /** Format: integer */
  'rowFilter.licencas.armazenamento_total': string;
  /** Format: numeric */
  'rowFilter.licencas.valor_armazenamento_ad': string;
  /** Format: integer */
  'rowFilter.licencas.qtd_usuarios_adicionais': string;
  /** Format: integer */
  'rowFilter.licencas.qtd_usuarios_total': string;
  /** Format: integer */
  'rowFilter.licencas.armazenamento_adicional_raster': string;
  /** Format: integer */
  'rowFilter.licencas.armazenamento_adicional_vetor': string;
  /** Format: integer */
  'rowFilter.licencas.uso_vetor': string;
  /** Format: integer */
  'rowFilter.licencas.uso_raster': string;
  /** Format: bigint */
  'rowFilter.licencas.uso_vetor_big': string;
  /** Format: bigint */
  'rowFilter.licencas.uso_raster_big': string;
  /** Format: bigint */
  'rowFilter.licencas.armazenamento_adicional_raster_big': string;
  /** Format: bigint */
  'rowFilter.licencas.armazenamento_adicional_vetor_big': string;
  /** Format: character varying */
  'rowFilter.licencas.token_card': string;
  /** Format: character varying */
  'rowFilter.licencas.token_bing': string;
  /** Format: character varying */
  'rowFilter.licencas.token_mapbox': string;
  /** @description segmentos */
  'body.segmentos': definitions['segmentos'];
  /** Format: integer */
  'rowFilter.segmentos.id_segmentos': string;
  /** Format: character varying */
  'rowFilter.segmentos.descricao': string;
  /** Format: character varying */
  'rowFilter.segmentos.tipo': string;
  /** @description sul_roads_refactor */
  'body.sul_roads_refactor': definitions['sul_roads_refactor'];
  /** Format: integer */
  'rowFilter.sul_roads_refactor.gid': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.osm_id': string;
  /** Format: smallint */
  'rowFilter.sul_roads_refactor.code': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.fclass': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.name': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.ref': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.oneway': string;
  /** Format: smallint */
  'rowFilter.sul_roads_refactor.maxspeed': string;
  /** Format: double precision */
  'rowFilter.sul_roads_refactor.layer': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.bridge': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.tunnel': string;
  /** Format: bigint */
  'rowFilter.sul_roads_refactor.idmuni': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactor.nm_municip': string;
  /** Format: text */
  'rowFilter.sul_roads_refactor.cd_geocmu': string;
  /** Format: public.geometry(MultiLineString,4326) */
  'rowFilter.sul_roads_refactor.geom': string;
  /** Format: double precision */
  'rowFilter.sul_roads_refactor.fator': string;
  /** Format: public.geometry(Geometry,4326) */
  'rowFilter.sul_roads_refactor.geomhelper': string;
  /** @description fontes_wms */
  'body.fontes_wms': definitions['fontes_wms'];
  /** Format: integer */
  'rowFilter.fontes_wms.id_fontes_wms': string;
  /** Format: character varying */
  'rowFilter.fontes_wms.nome': string;
  /** Format: character varying */
  'rowFilter.fontes_wms.descricao': string;
  /** Format: character varying */
  'rowFilter.fontes_wms.url': string;
  /** Format: character varying */
  'rowFilter.fontes_wms.foto': string;
  /** @description planos */
  'body.planos': definitions['planos'];
  /** Format: integer */
  'rowFilter.planos.id_planos': string;
  /** Format: character varying */
  'rowFilter.planos.nome': string;
  /** Format: numeric */
  'rowFilter.planos.valor': string;
  /** Format: integer */
  'rowFilter.planos.qtd_usuarios': string;
  /** Format: integer */
  'rowFilter.planos.armazenamento': string;
  /** Format: integer */
  'rowFilter.planos.qtd_projetos': string;
  /** @description wikimap */
  'body.wikimap': definitions['wikimap'];
  /** Format: integer */
  'rowFilter.wikimap.id_wikimap': string;
  /** Format: boolean */
  'rowFilter.wikimap.mundial': string;
  /** Format: text */
  'rowFilter.wikimap.continental': string;
  /** Format: text */
  'rowFilter.wikimap.pais': string;
  /** Format: text */
  'rowFilter.wikimap.estado': string;
  /** Format: text */
  'rowFilter.wikimap.regiao_metropolitana': string;
  /** Format: text */
  'rowFilter.wikimap.municipio': string;
  /** Format: text */
  'rowFilter.wikimap.h1': string;
  /** Format: text */
  'rowFilter.wikimap.h2': string;
  /** Format: text */
  'rowFilter.wikimap.h3': string;
  /** Format: text */
  'rowFilter.wikimap.descricao': string;
  /** Format: text */
  'rowFilter.wikimap.fonte': string;
  /** Format: text */
  'rowFilter.wikimap.imagem': string;
  /** Format: boolean */
  'rowFilter.wikimap.publicar': string;
  /** Format: integer */
  'rowFilter.wikimap.id_projetos': string;
  /** Format: integer */
  'rowFilter.wikimap.id_wikimap_organizacao': string;
  /** Format: integer */
  'rowFilter.wikimap.id_wikimap_tema_especifico': string;
  /** Format: integer */
  'rowFilter.wikimap.id_wikimap_tema_geral': string;
  /** Format: boolean */
  'rowFilter.wikimap.template': string;
  /** @description projetos_mapas_personalizados */
  'body.projetos_mapas_personalizados': definitions['projetos_mapas_personalizados'];
  /** Format: integer */
  'rowFilter.projetos_mapas_personalizados.id_projetos_mapas_personalizados': string;
  /** Format: bigint */
  'rowFilter.projetos_mapas_personalizados.id_projetos': string;
  /** Format: bigint */
  'rowFilter.projetos_mapas_personalizados.id_tenants': string;
  /** Format: bigint */
  'rowFilter.projetos_mapas_personalizados.id_usuarios': string;
  /** Format: boolean */
  'rowFilter.projetos_mapas_personalizados.compartilhar': string;
  /** Format: boolean */
  'rowFilter.projetos_mapas_personalizados.publico': string;
  /** Format: character varying */
  'rowFilter.projetos_mapas_personalizados.nome': string;
  /** Format: character varying */
  'rowFilter.projetos_mapas_personalizados.configuracao': string;
  /** Format: integer */
  'rowFilter.projetos_mapas_personalizados.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_mapas_personalizados.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_mapas_personalizados.aud_id_modificado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_mapas_personalizados.aud_modificado_data': string;
  /** @description amostras_raspagem */
  'body.amostras_raspagem': definitions['amostras_raspagem'];
  /** Format: integer */
  'rowFilter.amostras_raspagem.id_amostras_raspagem': string;
  /** Format: double precision */
  'rowFilter.amostras_raspagem.vm2': string;
  /** Format: public.geometry(Point,4326) */
  'rowFilter.amostras_raspagem.geom': string;
  /** Format: text */
  'rowFilter.amostras_raspagem.imagem': string;
  /** Format: double precision */
  'rowFilter.amostras_raspagem.x': string;
  /** Format: double precision */
  'rowFilter.amostras_raspagem.y': string;
  /** Format: text */
  'rowFilter.amostras_raspagem.site': string;
  /** Format: double precision */
  'rowFilter.amostras_raspagem.preco': string;
  /** Format: double precision */
  'rowFilter.amostras_raspagem.tamanho': string;
  /** Format: character varying */
  'rowFilter.amostras_raspagem.cep': string;
  /** Format: character varying */
  'rowFilter.amostras_raspagem.muni': string;
  /** Format: character varying */
  'rowFilter.amostras_raspagem.bairro': string;
  /** Format: character varying */
  'rowFilter.amostras_raspagem.rua': string;
  /** Format: character varying */
  'rowFilter.amostras_raspagem.estado': string;
  /** Format: timestamp without time zone */
  'rowFilter.amostras_raspagem.data_insercao': string;
  /** Format: character varying */
  'rowFilter.amostras_raspagem.ruabairro': string;
  /** @description recebimentos */
  'body.recebimentos': definitions['recebimentos'];
  /** Format: integer */
  'rowFilter.recebimentos.id_recebimentos': string;
  /** Format: numeric */
  'rowFilter.recebimentos.valor': string;
  /** Format: timestamp without time zone */
  'rowFilter.recebimentos.data_emissao': string;
  /** Format: timestamp without time zone */
  'rowFilter.recebimentos.data_vencimento': string;
  /** Format: integer */
  'rowFilter.recebimentos.id_tenants': string;
  /** Format: integer */
  'rowFilter.recebimentos.id_contratos': string;
  /** Format: integer */
  'rowFilter.recebimentos.status': string;
  /** Format: integer */
  'rowFilter.recebimentos.forma_pagamento': string;
  /** Format: integer */
  'rowFilter.recebimentos.parcelas': string;
  /** @description projetos_camadas_valores */
  'body.projetos_camadas_valores': definitions['projetos_camadas_valores'];
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.id_projetos': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.id_projetos_camadas': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.id_projetos_camadas_formularios_campos': string;
  /** Format: numeric */
  'rowFilter.projetos_camadas_valores.valor_num': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_valores.valor_select': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_valores.valor_checkbox': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.id_projetos_camadas_geometrias': string;
  /** Format: bigint */
  'rowFilter.projetos_camadas_valores.id_projetos_camadas_valores': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.valor_int': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_valores.valor_text': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_valores.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_valores.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores.aud_id_modificado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_valores.valor_timestamp': string;
  /** @description camadas_usuarios */
  'body.camadas_usuarios': definitions['camadas_usuarios'];
  /** Format: integer */
  'rowFilter.camadas_usuarios.id_camadas_usuarios': string;
  /** Format: bigint */
  'rowFilter.camadas_usuarios.id_projetos_camadas': string;
  /** Format: bigint */
  'rowFilter.camadas_usuarios.id_usuarios': string;
  /** Format: character varying */
  'rowFilter.camadas_usuarios.permissao': string;
  /** Format: timestamp without time zone */
  'rowFilter.camadas_usuarios.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.camadas_usuarios.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.camadas_usuarios.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.camadas_usuarios.aud_id_modificado_por': string;
  /** @description setores_sc */
  'body.setores_sc': definitions['setores_sc'];
  /** Format: integer */
  'rowFilter.setores_sc.gid': string;
  /** Format: character varying */
  'rowFilter.setores_sc.nm_municip': string;
  /** Format: public.geometry(Polygon) */
  'rowFilter.setores_sc.geom': string;
  /** Format: character varying */
  'rowFilter.setores_sc.cd_geocodi': string;
  /** Format: character varying */
  'rowFilter.setores_sc.cd_geocodm': string;
  /** Format: text */
  'rowFilter.setores_sc.geomtext': string;
  /** @description krigagem */
  'body.krigagem': definitions['krigagem'];
  /** Format: integer */
  'rowFilter.krigagem.id_krigagem': string;
  /** Format: integer */
  'rowFilter.krigagem.id_variogramas': string;
  /** Format: integer */
  'rowFilter.krigagem.id_dominio_geografico': string;
  /** Format: text */
  'rowFilter.krigagem.referencia_raster': string;
  /** @description valores_select */
  'body.valores_select': definitions['valores_select'];
  /** Format: integer */
  'rowFilter.valores_select.id_valores_select': string;
  /** Format: bigint */
  'rowFilter.valores_select.id_projetos_camadas_valores': string;
  /** Format: integer */
  'rowFilter.valores_select.id_campos_select': string;
  /** Format: character varying */
  'rowFilter.valores_select.tbl_valor_banco': string;
  /** @description tenants */
  'body.tenants': definitions['tenants'];
  /** Format: integer */
  'rowFilter.tenants.id_tenants': string;
  /** Format: character varying */
  'rowFilter.tenants.token': string;
  /** Format: character varying */
  'rowFilter.tenants.config': string;
  /** @description importacoes_dxf_geometrias */
  'body.importacoes_dxf_geometrias': definitions['importacoes_dxf_geometrias'];
  /** Format: integer */
  'rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf_geometrias': string;
  /** Format: integer */
  'rowFilter.importacoes_dxf_geometrias.id_importacoes_dxf': string;
  /** Format: public.geometry */
  'rowFilter.importacoes_dxf_geometrias.geom': string;
  /** Format: integer */
  'rowFilter.importacoes_dxf_geometrias.id_projetos': string;
  /** @description contratos */
  'body.contratos': definitions['contratos'];
  /** Format: integer */
  'rowFilter.contratos.id_contratos': string;
  /** Format: integer */
  'rowFilter.contratos.id_planos': string;
  /** Format: numeric */
  'rowFilter.contratos.valor': string;
  /** Format: integer */
  'rowFilter.contratos.qtd_usuarios': string;
  /** Format: timestamp without time zone */
  'rowFilter.contratos.data_contrato': string;
  /** Format: integer */
  'rowFilter.contratos.id_licencas': string;
  /** Format: integer */
  'rowFilter.contratos.armazenamento': string;
  /** @description criciuma_zonas */
  'body.criciuma_zonas': definitions['criciuma_zonas'];
  /** Format: integer */
  'rowFilter.criciuma_zonas.id_projetos_camadas_geometrias': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.afastamento_embas': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.afastamento_frente': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.afastamento_torre': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.area_maxima_lote': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.area_minima_lote': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.caracterizacao': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.codigo': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.id_zona': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.indice_basico_aproveitamento': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.indice_max_aproveitamento': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.nome': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.numero_max_pavimentos': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.objetivos': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.observacoes': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.taxa_basica_infiltracao': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.taxa_basica_ocupacao': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.taxa_max_ocupacao': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.taxa_min_infiltracao': string;
  /** Format: text */
  'rowFilter.criciuma_zonas.valor_outorga': string;
  /** Format: public.geometry */
  'rowFilter.criciuma_zonas.geom': string;
  /** @description projetos_camadas_valores_valores_select */
  'body.projetos_camadas_valores_valores_select': definitions['projetos_camadas_valores_valores_select'];
  /** Format: integer */
  'rowFilter.projetos_camadas_valores_valores_select.id_projetos_camadas_formularios_campos': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores_valores_select.id_projetos_camadas': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores_valores_select.id_projetos_camadas_geometrias': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_valores_valores_select.resumo': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_valores_valores_select.nome': string;
  /** Format: numeric */
  'rowFilter.projetos_camadas_valores_valores_select.valor_num': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_valores_valores_select.valor_checkbox': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores_valores_select.valor_int': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_valores_valores_select.valor_text': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_valores_valores_select.valor_timestamp': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_valores_valores_select.valor_select': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_valores_valores_select.id_campos_select': string;
  /** Format: smallint */
  'rowFilter.projetos_camadas_valores_valores_select.tipo': string;
  /** @description projetos_usuarios */
  'body.projetos_usuarios': definitions['projetos_usuarios'];
  /** Format: integer */
  'rowFilter.projetos_usuarios.id_projetos_usuarios': string;
  /** Format: integer */
  'rowFilter.projetos_usuarios.id_projetos': string;
  /** Format: integer */
  'rowFilter.projetos_usuarios.id_usuarios': string;
  /** Format: character varying */
  'rowFilter.projetos_usuarios.permissao': string;
  /** @description campos_select */
  'body.campos_select': definitions['campos_select'];
  /** Format: integer */
  'rowFilter.campos_select.id_campos_select': string;
  /** Format: integer */
  'rowFilter.campos_select.id_projetos_camadas_formularios_campos': string;
  /** Format: character varying */
  'rowFilter.campos_select.nome': string;
  /** Format: integer */
  'rowFilter.campos_select.ordem': string;
  /** Format: boolean */
  'rowFilter.campos_select.ativo': string;
  /** Format: double precision */
  'rowFilter.campos_select.fator': string;
  /** Format: character varying */
  'rowFilter.campos_select.tbl_valor_db': string;
  /** @description importacoes_pendentes */
  'body.importacoes_pendentes': definitions['importacoes_pendentes'];
  /** Format: integer */
  'rowFilter.importacoes_pendentes.id_importacoes_pendentes': string;
  /** Format: character varying */
  'rowFilter.importacoes_pendentes.codigo': string;
  /** Format: boolean */
  'rowFilter.importacoes_pendentes.status_completo': string;
  /** Format: character varying */
  'rowFilter.importacoes_pendentes.descricao': string;
  /** Format: integer */
  'rowFilter.importacoes_pendentes.id_projetos': string;
  /** Format: boolean */
  'rowFilter.importacoes_pendentes.hide': string;
  /** Format: character varying */
  'rowFilter.importacoes_pendentes.representacao': string;
  /** @description wikimap_organizacao */
  'body.wikimap_organizacao': definitions['wikimap_organizacao'];
  /** Format: integer */
  'rowFilter.wikimap_organizacao.id_wikimap_organizacao': string;
  /** Format: text */
  'rowFilter.wikimap_organizacao.organizacao': string;
  /** Format: text */
  'rowFilter.wikimap_organizacao.sigla': string;
  /** Format: text */
  'rowFilter.wikimap_organizacao.url': string;
  /** Format: text */
  'rowFilter.wikimap_organizacao.descricao': string;
  /** @description projetos_camadas */
  'body.projetos_camadas': definitions['projetos_camadas'];
  /** Format: integer */
  'rowFilter.projetos_camadas.id_projetos_camadas': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.nome': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.id_projetos': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.ativo': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.tipo_geometria': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.cor': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.espessura': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.preenchimento': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.tipo_linha': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.simbolo_ponto': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.tamanho_ponto': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.aud_id_modificado_por': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.rotulo_ativo': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.rotulo_nome': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.sld_body': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.ordem_visualizacao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.visibilidade': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.tamanho_rotulo': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.legenda': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.mapa_tematico': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.campo_mapa_tematico': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.id_campo_mapa_tematico': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.layer_size': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.id_campo_rotulo': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.publico_ouv': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.tipo_camada': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.representacao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.equacao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.show_ouv': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.escala_max': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.escala_min': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas.aud_atualizado_raspagem': string;
  /** Format: text */
  'rowFilter.projetos_camadas.sld_body_ouv': string;
  /** Format: text */
  'rowFilter.projetos_camadas.mapa_tematico_ouv': string;
  /** Format: text */
  'rowFilter.projetos_camadas.estiloouv': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.rotulo_decimal': string;
  /** Format: text */
  'rowFilter.projetos_camadas.estilowebgeo': string;
  /** Format: text */
  'rowFilter.projetos_camadas.mapa_tematico_fix': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.privada': string;
  /** Format: integer */
  'rowFilter.projetos_camadas.id_campo_rotulo_rotacao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.estiloconsultaprevia': string;
  /** Format: text */
  'rowFilter.projetos_camadas.estiloconsultapreviatext': string;
  /** Format: text */
  'rowFilter.projetos_camadas.estiloavaliacao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.show_previa': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.show_icad': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.show_avaliacao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.publico_icad': string;
  /** Format: text */
  'rowFilter.projetos_camadas.estilo_icad': string;
  /** Format: text */
  'rowFilter.projetos_camadas.legenda_fix': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.show_generico': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas.publico_generico': string;
  /** Format: text */
  'rowFilter.projetos_camadas.estilo_generico': string;
  /** Format: ARRAY */
  'rowFilter.projetos_camadas.id_campos_rotulos': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.tbl_nome_db': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.chave_principal': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.chave_secundaria': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.descricao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas.url': string;
  /** @description usuarios */
  'body.usuarios': definitions['usuarios'];
  /** Format: integer */
  'rowFilter.usuarios.id_usuarios': string;
  /** Format: character varying */
  'rowFilter.usuarios.nome': string;
  /** Format: character varying */
  'rowFilter.usuarios.auth_token': string;
  /** Format: character varying */
  'rowFilter.usuarios.email': string;
  /** Format: character varying */
  'rowFilter.usuarios.senha': string;
  /** Format: integer */
  'rowFilter.usuarios.id_tenants': string;
  /** Format: boolean */
  'rowFilter.usuarios.adm': string;
  /** Format: character varying */
  'rowFilter.usuarios.tipo': string;
  /** Format: boolean */
  'rowFilter.usuarios.ativo': string;
  /** Format: boolean */
  'rowFilter.usuarios.status_import': string;
  /** Format: character varying */
  'rowFilter.usuarios.ip_login': string;
  /** Format: character varying */
  'rowFilter.usuarios.foto': string;
  /** Format: character varying */
  'rowFilter.usuarios.user': string;
  /** Format: boolean */
  'rowFilter.usuarios.colaborativo': string;
  /** Format: character varying */
  'rowFilter.usuarios.classificacoes': string;
  /** @description wikimap_comentarios */
  'body.wikimap_comentarios': definitions['wikimap_comentarios'];
  /** Format: integer */
  'rowFilter.wikimap_comentarios.id_wikimap_comentarios': string;
  /** Format: integer */
  'rowFilter.wikimap_comentarios.id_wikimap': string;
  /** Format: integer */
  'rowFilter.wikimap_comentarios.id_usuarios': string;
  /** Format: text */
  'rowFilter.wikimap_comentarios.comentario': string;
  /** Format: timestamp with time zone */
  'rowFilter.wikimap_comentarios.criado': string;
  /** @description django_migrations */
  'body.django_migrations': definitions['django_migrations'];
  /** Format: bigint */
  'rowFilter.django_migrations.id': string;
  /** Format: character varying */
  'rowFilter.django_migrations.app': string;
  /** Format: character varying */
  'rowFilter.django_migrations.name': string;
  /** Format: timestamp with time zone */
  'rowFilter.django_migrations.applied': string;
  /** @description solicitacoes_ouv */
  'body.solicitacoes_ouv': definitions['solicitacoes_ouv'];
  /** Format: integer */
  'rowFilter.solicitacoes_ouv.gid': string;
  /** Format: text */
  'rowFilter.solicitacoes_ouv.nome': string;
  /** Format: text */
  'rowFilter.solicitacoes_ouv.email': string;
  /** Format: text */
  'rowFilter.solicitacoes_ouv.msg': string;
  /** Format: text */
  'rowFilter.solicitacoes_ouv.telefone': string;
  /** Format: text */
  'rowFilter.solicitacoes_ouv.empresa': string;
  /** Format: timestamp without time zone */
  'rowFilter.solicitacoes_ouv.data': string;
  /** Format: text */
  'rowFilter.solicitacoes_ouv.ip': string;
  /** @description faturamentos */
  'body.faturamentos': definitions['faturamentos'];
  /** Format: integer */
  'rowFilter.faturamentos.id_faturamentos': string;
  /** Format: integer */
  'rowFilter.faturamentos.id_tenants': string;
  /** Format: integer */
  'rowFilter.faturamentos.id_contratos': string;
  /** Format: character varying */
  'rowFilter.faturamentos.tipo': string;
  /** Format: timestamp without time zone */
  'rowFilter.faturamentos.data_fatura': string;
  /** Format: numeric */
  'rowFilter.faturamentos.valor': string;
  /** Format: character varying */
  'rowFilter.faturamentos.status': string;
  /** Format: character varying */
  'rowFilter.faturamentos.descricao': string;
  /** @description referencias_geograficas */
  'body.referencias_geograficas': definitions['referencias_geograficas'];
  /** Format: integer */
  'rowFilter.referencias_geograficas.id_referencias_geograficas': string;
  /** Format: character varying */
  'rowFilter.referencias_geograficas.srid': string;
  /** Format: character varying */
  'rowFilter.referencias_geograficas.descricao': string;
  /** @description importacoes_wms */
  'body.importacoes_wms': definitions['importacoes_wms'];
  /** Format: integer */
  'rowFilter.importacoes_wms.id_importacoes_wms': string;
  /** Format: character varying */
  'rowFilter.importacoes_wms.link': string;
  /** Format: integer */
  'rowFilter.importacoes_wms.id_projetos': string;
  /** Format: character varying */
  'rowFilter.importacoes_wms.nome': string;
  /** Format: character varying */
  'rowFilter.importacoes_wms.bbox': string;
  /** Format: character varying */
  'rowFilter.importacoes_wms.url': string;
  /** Format: character varying */
  'rowFilter.importacoes_wms.params': string;
  /** @description auditoria_delete */
  'body.auditoria_delete': definitions['auditoria_delete'];
  /** Format: integer */
  'rowFilter.auditoria_delete.id_auditoria_delete': string;
  /** Format: integer */
  'rowFilter.auditoria_delete.id_projetos': string;
  /** Format: integer */
  'rowFilter.auditoria_delete.id_usuarios': string;
  /** Format: timestamp without time zone */
  'rowFilter.auditoria_delete.aud_hora': string;
  /** Format: character varying */
  'rowFilter.auditoria_delete.informacao': string;
  /** Format: bigint */
  'rowFilter.auditoria_delete.id_generico': string;
  /** Format: boolean */
  'rowFilter.auditoria_delete.middleware': string;
  /** Format: character varying */
  'rowFilter.auditoria_delete.uri': string;
  /** @description wikimap_tema_especifico */
  'body.wikimap_tema_especifico': definitions['wikimap_tema_especifico'];
  /** Format: integer */
  'rowFilter.wikimap_tema_especifico.id_wikimap_tema_especifico': string;
  /** Format: text */
  'rowFilter.wikimap_tema_especifico.tema': string;
  /** @description osm_roads */
  'body.osm_roads': definitions['osm_roads'];
  /** Format: integer */
  'rowFilter.osm_roads.gid': string;
  /** Format: character varying */
  'rowFilter.osm_roads.osm_id': string;
  /** Format: smallint */
  'rowFilter.osm_roads.code': string;
  /** Format: character varying */
  'rowFilter.osm_roads.fclass': string;
  /** Format: character varying */
  'rowFilter.osm_roads.name': string;
  /** Format: character varying */
  'rowFilter.osm_roads.ref': string;
  /** Format: character varying */
  'rowFilter.osm_roads.oneway': string;
  /** Format: smallint */
  'rowFilter.osm_roads.maxspeed': string;
  /** Format: double precision */
  'rowFilter.osm_roads.layer': string;
  /** Format: character varying */
  'rowFilter.osm_roads.bridge': string;
  /** Format: character varying */
  'rowFilter.osm_roads.tunnel': string;
  /** Format: public.geometry(MultiLineString,4326) */
  'rowFilter.osm_roads.geom': string;
  /** @description empresas */
  'body.empresas': definitions['empresas'];
  /** Format: integer */
  'rowFilter.empresas.id_empresas': string;
  /** Format: integer */
  'rowFilter.empresas.id_tenants': string;
  /** Format: character varying */
  'rowFilter.empresas.nome': string;
  /** Format: character */
  'rowFilter.empresas.tipo_pessoa': string;
  /** Format: character varying */
  'rowFilter.empresas.cpf_cnpj': string;
  /** Format: character varying */
  'rowFilter.empresas.telefone': string;
  /** Format: integer */
  'rowFilter.empresas.id_segmentos': string;
  /** Format: character varying */
  'rowFilter.empresas.endereco': string;
  /** Format: character varying */
  'rowFilter.empresas.cidade': string;
  /** Format: character varying */
  'rowFilter.empresas.bairro': string;
  /** Format: character varying */
  'rowFilter.empresas.complemento': string;
  /** Format: character varying */
  'rowFilter.empresas.cep': string;
  /** Format: character varying */
  'rowFilter.empresas.uf': string;
  /** Format: character varying */
  'rowFilter.empresas.logo': string;
  /** @description projetos_camadas_adicionais */
  'body.projetos_camadas_adicionais': definitions['projetos_camadas_adicionais'];
  /** Format: integer */
  'rowFilter.projetos_camadas_adicionais.id_projetos_camadas_adicionais': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_adicionais.id_projetos': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_adicionais.id_projetos_camadas': string;
  /** @description wikimap_likes */
  'body.wikimap_likes': definitions['wikimap_likes'];
  /** Format: integer */
  'rowFilter.wikimap_likes.id_likes_wikimap': string;
  /** Format: integer */
  'rowFilter.wikimap_likes.id_usuarios': string;
  /** Format: integer */
  'rowFilter.wikimap_likes.id_wikimap': string;
  /** @description layouts */
  'body.layouts': definitions['layouts'];
  /** Format: integer */
  'rowFilter.layouts.id_layout': string;
  /** Format: integer */
  'rowFilter.layouts.id_projeto': string;
  /** Format: integer */
  'rowFilter.layouts.id_tenant': string;
  /** Format: integer */
  'rowFilter.layouts.id_usuario': string;
  /** Format: boolean */
  'rowFilter.layouts.compartilhar': string;
  /** Format: boolean */
  'rowFilter.layouts.publico': string;
  /** Format: character varying */
  'rowFilter.layouts.nome': string;
  /** Format: json */
  'rowFilter.layouts.configuracao': string;
  /** @description variogramas */
  'body.variogramas': definitions['variogramas'];
  /** Format: integer */
  'rowFilter.variogramas.id_variogramas': string;
  /** Format: integer */
  'rowFilter.variogramas.id_camadas': string;
  /** Format: character varying */
  'rowFilter.variogramas.nome': string;
  /** Format: double precision */
  'rowFilter.variogramas.nugg': string;
  /** Format: double precision */
  'rowFilter.variogramas.rang': string;
  /** Format: double precision */
  'rowFilter.variogramas.psil': string;
  /** Format: text */
  'rowFilter.variogramas.url': string;
  /** Format: boolean */
  'rowFilter.variogramas.automatico': string;
  /** Format: boolean */
  'rowFilter.variogramas.log': string;
  /** Format: integer */
  'rowFilter.variogramas.id_campo_vm2': string;
  /** Format: integer */
  'rowFilter.variogramas.id_campo_chk': string;
  /** Format: integer */
  'rowFilter.variogramas.id_projetos': string;
  /** Format: ARRAY */
  'rowFilter.variogramas.zonas_ignorar': string;
  /** @description modelos_variograma */
  'body.modelos_variograma': definitions['modelos_variograma'];
  /** Format: integer */
  'rowFilter.modelos_variograma.id_modelos_variograma': string;
  /** Format: integer */
  'rowFilter.modelos_variograma.id_projetos': string;
  /** Format: character varying */
  'rowFilter.modelos_variograma.nome_modelo': string;
  /** Format: character varying */
  'rowFilter.modelos_variograma.chave': string;
  /** Format: character varying */
  'rowFilter.modelos_variograma.valor': string;
  /** @description amostras_apartamentos_raspagem */
  'body.amostras_apartamentos_raspagem': definitions['amostras_apartamentos_raspagem'];
  /** Format: integer */
  'rowFilter.amostras_apartamentos_raspagem.id_amostras_apartamentos_raspagem': string;
  /** Format: double precision */
  'rowFilter.amostras_apartamentos_raspagem.vm2': string;
  /** Format: public.geometry(Point,4326) */
  'rowFilter.amostras_apartamentos_raspagem.geom': string;
  /** Format: text */
  'rowFilter.amostras_apartamentos_raspagem.imagem': string;
  /** Format: double precision */
  'rowFilter.amostras_apartamentos_raspagem.x': string;
  /** Format: double precision */
  'rowFilter.amostras_apartamentos_raspagem.y': string;
  /** Format: text */
  'rowFilter.amostras_apartamentos_raspagem.site': string;
  /** Format: double precision */
  'rowFilter.amostras_apartamentos_raspagem.preco': string;
  /** Format: double precision */
  'rowFilter.amostras_apartamentos_raspagem.tamanho': string;
  /** Format: character varying */
  'rowFilter.amostras_apartamentos_raspagem.cep': string;
  /** Format: character varying */
  'rowFilter.amostras_apartamentos_raspagem.muni': string;
  /** Format: character varying */
  'rowFilter.amostras_apartamentos_raspagem.bairro': string;
  /** Format: character varying */
  'rowFilter.amostras_apartamentos_raspagem.rua': string;
  /** Format: character varying */
  'rowFilter.amostras_apartamentos_raspagem.estado': string;
  /** Format: double precision */
  'rowFilter.amostras_apartamentos_raspagem.area_util': string;
  /** Format: timestamp without time zone */
  'rowFilter.amostras_apartamentos_raspagem.data_insercao': string;
  /** @description projetos_camadas_geometrias_arquivos */
  'body.projetos_camadas_geometrias_arquivos': definitions['projetos_camadas_geometrias_arquivos'];
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias_arquivos': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.id_projetos_camadas_geometrias': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.id_projetos': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_geometrias_arquivos.url_s3': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.tipo': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.file_size': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_geometrias_arquivos.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_geometrias_arquivos.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias_arquivos.aud_id_modificado_por': string;
  /** @description importacoes_dxf */
  'body.importacoes_dxf': definitions['importacoes_dxf'];
  /** Format: integer */
  'rowFilter.importacoes_dxf.id_importacoes_dxf': string;
  /** Format: character varying */
  'rowFilter.importacoes_dxf.nome': string;
  /** Format: text */
  'rowFilter.importacoes_dxf.conteudo': string;
  /** Format: integer */
  'rowFilter.importacoes_dxf.id_projetos': string;
  /** @description wikimap_tema_geral */
  'body.wikimap_tema_geral': definitions['wikimap_tema_geral'];
  /** Format: integer */
  'rowFilter.wikimap_tema_geral.id_wikimap_tema_geral': string;
  /** Format: text */
  'rowFilter.wikimap_tema_geral.tema': string;
  /** @description projetos_arquivos */
  'body.projetos_arquivos': definitions['projetos_arquivos'];
  /** Format: integer */
  'rowFilter.projetos_arquivos.id_projetos_arquivos': string;
  /** Format: integer */
  'rowFilter.projetos_arquivos.id_projetos': string;
  /** Format: character varying */
  'rowFilter.projetos_arquivos.url_s3': string;
  /** Format: integer */
  'rowFilter.projetos_arquivos.tipo': string;
  /** @description amostras_salas_raspagem */
  'body.amostras_salas_raspagem': definitions['amostras_salas_raspagem'];
  /** Format: integer */
  'rowFilter.amostras_salas_raspagem.id_amostras_salas_raspagem': string;
  /** Format: double precision */
  'rowFilter.amostras_salas_raspagem.vm2': string;
  /** Format: public.geometry(Point,4326) */
  'rowFilter.amostras_salas_raspagem.geom': string;
  /** Format: text */
  'rowFilter.amostras_salas_raspagem.imagem': string;
  /** Format: double precision */
  'rowFilter.amostras_salas_raspagem.x': string;
  /** Format: double precision */
  'rowFilter.amostras_salas_raspagem.y': string;
  /** Format: text */
  'rowFilter.amostras_salas_raspagem.site': string;
  /** Format: double precision */
  'rowFilter.amostras_salas_raspagem.preco': string;
  /** Format: double precision */
  'rowFilter.amostras_salas_raspagem.tamanho': string;
  /** Format: character varying */
  'rowFilter.amostras_salas_raspagem.cep': string;
  /** Format: character varying */
  'rowFilter.amostras_salas_raspagem.muni': string;
  /** Format: character varying */
  'rowFilter.amostras_salas_raspagem.bairro': string;
  /** Format: character varying */
  'rowFilter.amostras_salas_raspagem.rua': string;
  /** Format: character varying */
  'rowFilter.amostras_salas_raspagem.estado': string;
  /** Format: double precision */
  'rowFilter.amostras_salas_raspagem.area_util': string;
  /** Format: timestamp without time zone */
  'rowFilter.amostras_salas_raspagem.data_insercao': string;
  /** @description projetos_camadas_geometrias */
  'body.projetos_camadas_geometrias': definitions['projetos_camadas_geometrias'];
  /** Format: public.geometry */
  'rowFilter.projetos_camadas_geometrias.geom': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_geometrias.data_criacao': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.id_projetos_camadas_geometrias': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.id_projetos_camadas': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.id_projetos': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.seq': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_geometrias.geom_wkt': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_geometrias.rotulo': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_geometrias.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_geometrias.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.aud_id_modificado_por': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_geometrias.categoria_mapa_tematico': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_geometrias.tem_foto': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_geometrias.indexmapatematico': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_geometrias.aud_raspado': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_geometrias.foto': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_geometrias.icadvinculado': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_geometrias.icad_vinculado': string;
  /** Format: double precision */
  'rowFilter.projetos_camadas_geometrias.rotulo_rotacao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_geometrias.campo_auxiliar': string;
  /** @description projetos_camadas_formularios */
  'body.projetos_camadas_formularios': definitions['projetos_camadas_formularios'];
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios.id_projetos_camadas_formularios': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios.nome': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios.id_projetos_camadas': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios.id_projetos': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_formularios.ativo': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_formularios.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_formularios.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios.aud_id_modificado_por': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios.representacao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios.tbl_valor_db': string;
  /** @description municipios_ibge */
  'body.municipios_ibge': definitions['municipios_ibge'];
  /** Format: integer */
  'rowFilter.municipios_ibge.gid': string;
  /** Format: character varying */
  'rowFilter.municipios_ibge.nm_municip': string;
  /** Format: character varying */
  'rowFilter.municipios_ibge.cd_geocmu': string;
  /** Format: public.geometry(MultiPolygon,4674) */
  'rowFilter.municipios_ibge.geom': string;
  /** @description criciuma_observacoes */
  'body.criciuma_observacoes': definitions['criciuma_observacoes'];
  /** Format: integer */
  'rowFilter.criciuma_observacoes.id_projetos_camadas_geometrias': string;
  /** Format: public.geometry */
  'rowFilter.criciuma_observacoes.geom': string;
  /** Format: character varying */
  'rowFilter.criciuma_observacoes.obser': string;
  /** @description sul_roads_refactorr */
  'body.sul_roads_refactorr': definitions['sul_roads_refactorr'];
  /** Format: integer */
  'rowFilter.sul_roads_refactorr.gid': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.osm_id': string;
  /** Format: smallint */
  'rowFilter.sul_roads_refactorr.code': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.fclass': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.name': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.ref': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.oneway': string;
  /** Format: smallint */
  'rowFilter.sul_roads_refactorr.maxspeed': string;
  /** Format: double precision */
  'rowFilter.sul_roads_refactorr.layer': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.bridge': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.tunnel': string;
  /** Format: bigint */
  'rowFilter.sul_roads_refactorr.idmuni': string;
  /** Format: character varying */
  'rowFilter.sul_roads_refactorr.nm_municip': string;
  /** Format: text */
  'rowFilter.sul_roads_refactorr.cd_geocmu': string;
  /** Format: public.geometry(MultiLineString,4326) */
  'rowFilter.sul_roads_refactorr.geom': string;
  /** Format: double precision */
  'rowFilter.sul_roads_refactorr.fator': string;
  /** Format: public.geometry(Geometry,4326) */
  'rowFilter.sul_roads_refactorr.geomhelper': string;
  /** Format: public.geometry_dump */
  'rowFilter.sul_roads_refactorr.geom_dump': string;
  /** Format: public.geometry */
  'rowFilter.sul_roads_refactorr.simple_geom': string;
  /** Format: ARRAY */
  'rowFilter.sul_roads_refactorr.path': string;
  /** Format: text */
  'rowFilter.sul_roads_refactorr.geom_type': string;
  /** Format: text */
  'rowFilter.sul_roads_refactorr.geom_wkt': string;
  /** @description setores_rss */
  'body.setores_rss': definitions['setores_rss'];
  /** Format: integer */
  'rowFilter.setores_rss.gid': string;
  /** Format: double precision */
  'rowFilter.setores_rss.id': string;
  /** Format: character varying */
  'rowFilter.setores_rss.cd_geocodi': string;
  /** Format: character varying */
  'rowFilter.setores_rss.tipo': string;
  /** Format: character varying */
  'rowFilter.setores_rss.cd_geocodb': string;
  /** Format: character varying */
  'rowFilter.setores_rss.nm_bairro': string;
  /** Format: character varying */
  'rowFilter.setores_rss.cd_geocods': string;
  /** Format: character varying */
  'rowFilter.setores_rss.nm_subdist': string;
  /** Format: character varying */
  'rowFilter.setores_rss.cd_geocodd': string;
  /** Format: character varying */
  'rowFilter.setores_rss.nm_distrit': string;
  /** Format: character varying */
  'rowFilter.setores_rss.cd_geocodm': string;
  /** Format: character varying */
  'rowFilter.setores_rss.nm_municip': string;
  /** Format: character varying */
  'rowFilter.setores_rss.nm_micro': string;
  /** Format: character varying */
  'rowFilter.setores_rss.nm_meso': string;
  /** Format: public.geometry(MultiPolygonM,4326) */
  'rowFilter.setores_rss.geom': string;
  /** @description projetos_camadas_relatorios */
  'body.projetos_camadas_relatorios': definitions['projetos_camadas_relatorios'];
  /** Format: integer */
  'rowFilter.projetos_camadas_relatorios.id_projetos_camadas_relatorios': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_relatorios.id_projetos_camadas': string;
  /** Format: text */
  'rowFilter.projetos_camadas_relatorios.nome': string;
  /** Format: text */
  'rowFilter.projetos_camadas_relatorios.estrutura': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_relatorios.aud_criado_data': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_relatorios.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_relatorios.aud_id_criado_por': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_relatorios.aud_id_modificado_por': string;
  /** @description sul_roads */
  'body.sul_roads': definitions['sul_roads'];
  /** Format: integer */
  'rowFilter.sul_roads.gid': string;
  /** Format: character varying */
  'rowFilter.sul_roads.osm_id': string;
  /** Format: smallint */
  'rowFilter.sul_roads.code': string;
  /** Format: character varying */
  'rowFilter.sul_roads.fclass': string;
  /** Format: character varying */
  'rowFilter.sul_roads.name': string;
  /** Format: character varying */
  'rowFilter.sul_roads.ref': string;
  /** Format: character varying */
  'rowFilter.sul_roads.oneway': string;
  /** Format: smallint */
  'rowFilter.sul_roads.maxspeed': string;
  /** Format: double precision */
  'rowFilter.sul_roads.layer': string;
  /** Format: character varying */
  'rowFilter.sul_roads.bridge': string;
  /** Format: character varying */
  'rowFilter.sul_roads.tunnel': string;
  /** Format: bigint */
  'rowFilter.sul_roads.idmuni': string;
  /** Format: character varying */
  'rowFilter.sul_roads.nm_municip': string;
  /** Format: text */
  'rowFilter.sul_roads.cd_geocmu': string;
  /** Format: public.geometry(MultiLineString,4326) */
  'rowFilter.sul_roads.geom': string;
  /** Format: double precision */
  'rowFilter.sul_roads.fator': string;
  /** Format: public.geometry(Geometry,4326) */
  'rowFilter.sul_roads.geomhelper': string;
  /** @description vinculo */
  'body.vinculo': definitions['vinculo'];
  /** Format: integer */
  'rowFilter.vinculo.id_vinculos': string;
  /** Format: integer */
  'rowFilter.vinculo.id_camada_principal': string;
  /** Format: integer */
  'rowFilter.vinculo.id_campo_principal': string;
  /** Format: integer */
  'rowFilter.vinculo.id_camada_secundaria': string;
  /** Format: integer */
  'rowFilter.vinculo.id_campo_secundario': string;
  /** Format: integer */
  'rowFilter.vinculo.tipo': string;
  /** Format: timestamp without time zone */
  'rowFilter.vinculo.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.vinculo.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.vinculo.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.vinculo.aud_id_modificado_por': string;
  /** @description contratos_items */
  'body.contratos_items': definitions['contratos_items'];
  /** Format: integer */
  'rowFilter.contratos_items.id_contratos_items': string;
  /** Format: numeric */
  'rowFilter.contratos_items.valor': string;
  /** Format: integer */
  'rowFilter.contratos_items.id_contratos': string;
  /** Format: text */
  'rowFilter.contratos_items.descricao': string;
  /** Format: integer */
  'rowFilter.contratos_items.id_tenants': string;
  /** Format: integer */
  'rowFilter.contratos_items.tipo': string;
  /** @description setores_rs */
  'body.setores_rs': definitions['setores_rs'];
  /** Format: integer */
  'rowFilter.setores_rs.gid': string;
  /** Format: character varying */
  'rowFilter.setores_rs.nm_municip': string;
  /** Format: public.geometry(Polygon) */
  'rowFilter.setores_rs.geom': string;
  /** Format: character varying */
  'rowFilter.setores_rs.cd_geocodi': string;
  /** Format: character varying */
  'rowFilter.setores_rs.cd_geocodm': string;
  /** Format: text */
  'rowFilter.setores_rs.geomtext': string;
  /** @description projetos */
  'body.projetos': definitions['projetos'];
  /** Format: integer */
  'rowFilter.projetos.id_projetos': string;
  /** Format: character varying */
  'rowFilter.projetos.nome': string;
  /** Format: character varying */
  'rowFilter.projetos.cidade': string;
  /** Format: integer */
  'rowFilter.projetos.id_usuarios': string;
  /** Format: boolean */
  'rowFilter.projetos.ativo': string;
  /** Format: integer */
  'rowFilter.projetos.id_tenants': string;
  /** Format: integer */
  'rowFilter.projetos.id_segmentos': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos.aud_id_modificado_por': string;
  /** Format: integer */
  'rowFilter.projetos.total_size_vectors': string;
  /** Format: character varying */
  'rowFilter.projetos.tipo_projeto': string;
  /** Format: character varying */
  'rowFilter.projetos.endereco_api': string;
  /** Format: ARRAY */
  'rowFilter.projetos.ordem_camadas': string;
  /** Format: ARRAY */
  'rowFilter.projetos.campos_favoritos_pesquisa': string;
  /** Format: character varying */
  'rowFilter.projetos.ordem_camadas_fix': string;
  /** Format: character varying */
  'rowFilter.projetos.notas_consulta_previa': string;
  /** Format: character varying */
  'rowFilter.projetos.alias': string;
  /** Format: text */
  'rowFilter.projetos.configuracao': string;
  /** @description edificacoes_rincao */
  'body.edificacoes_rincao': definitions['edificacoes_rincao'];
  /** Format: integer */
  'rowFilter.edificacoes_rincao.id_edificacoes': string;
  /** @description wikimap_usuarios */
  'body.wikimap_usuarios': definitions['wikimap_usuarios'];
  /** Format: integer */
  'rowFilter.wikimap_usuarios.id_usuarios_wikimap': string;
  /** Format: integer */
  'rowFilter.wikimap_usuarios.id_usuarios': string;
  /** Format: integer */
  'rowFilter.wikimap_usuarios.id_wikimap': string;
  /** @description projetos_camadas_formularios_campos */
  'body.projetos_camadas_formularios_campos': definitions['projetos_camadas_formularios_campos'];
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.nome': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.id_projetos_camadas_formularios_campos': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_formularios_campos.obrigatorio': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.id_projetos': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.hint': string;
  /** Format: smallint */
  'rowFilter.projetos_camadas_formularios_campos.tipo': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.ordenacao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_formularios_campos.ativo': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_formularios_campos.aud_criado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.aud_id_criado_por': string;
  /** Format: timestamp without time zone */
  'rowFilter.projetos_camadas_formularios_campos.aud_modificado_data': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.aud_id_modificado_por': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.representacao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_formularios_campos.publico_ouv': string;
  /** Format: double precision */
  'rowFilter.projetos_camadas_formularios_campos.fator': string;
  /** Format: text */
  'rowFilter.projetos_camadas_formularios_campos.fators': string;
  /** Format: integer */
  'rowFilter.projetos_camadas_formularios_campos.ordem_visualizacao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.tbl_coluna_db': string;
  /** Format: ARRAY */
  'rowFilter.projetos_camadas_formularios_campos.resumo_card_db': string;
  /** Format: ARRAY */
  'rowFilter.projetos_camadas_formularios_campos.campos_projeto': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.tbl_nome_coluna': string;
  /** Format: ARRAY */
  'rowFilter.projetos_camadas_formularios_campos.id_projetos_ocultos': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_formularios_campos.resumo': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.descricao': string;
  /** Format: boolean */
  'rowFilter.projetos_camadas_formularios_campos.caracterizacao': string;
  /** Format: json */
  'rowFilter.projetos_camadas_formularios_campos.validacao': string;
  /** Format: character varying */
  'rowFilter.projetos_camadas_formularios_campos.validacoes': string;
}

export interface operations {}

export interface external {}
